import * as i0 from '@angular/core';
import { EventEmitter, TemplateRef, Component, ViewEncapsulation, ViewChild, Output, Input, ContentChildren, HostListener, forwardRef, HostBinding, Directive, InjectionToken, Injectable, Optional, Injector, Inject, Self, ChangeDetectionStrategy, ContentChild, ViewChildren, Pipe, NgModule } from '@angular/core';
import { BehaviorSubject, Subject, Subscription, fromEvent, combineLatest, merge } from 'rxjs';
import * as i1 from '@rogers/cdk/common/a11y';
import * as i1$1 from '@rogers/cdk/common/services';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4$1 from '@angular/cdk/a11y';
import { CdkMonitorFocus, A11yModule } from '@angular/cdk/a11y';
import * as i5 from '@rogers/cdk/common/directives';
import { DirectivesModule } from '@rogers/cdk/common/directives';
import { __decorate } from 'tslib';
import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';
import * as i3$3 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, CheckboxRequiredValidator, COMPOSITION_BUFFER_MODE, Validators, FormsModule } from '@angular/forms';
import { Default, Required } from '@rogers/cdk/common/decorators';
import { takeUntil, startWith, debounceTime } from 'rxjs/operators';
import * as i2 from '@rogers/cdk/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { ESCAPE, RIGHT_ARROW, LEFT_ARROW, UP_ARROW, DOWN_ARROW, PAGE_UP, PAGE_DOWN, HOME, END, TAB } from '@angular/cdk/keycodes';
import * as _djs from 'dayjs';
import _djs__default, { extend } from 'dayjs';
import 'dayjs/locale/en-ca';
import 'dayjs/locale/fr-ca';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import * as weekDay from 'dayjs/plugin/weekday';
import weekDay__default from 'dayjs/plugin/weekday';
import { chunk, isBrowser } from '@rogers/cdk/common/utils';
import * as i2$1 from '@rogers/cdk/button';
import { ButtonModule } from '@rogers/cdk/button';
import * as i3 from '@rogers/cdk/icon';
import { IconModule } from '@rogers/cdk/icon';
import * as i3$2 from '@angular/cdk/platform';
import { getSupportedInputTypes, PlatformModule } from '@angular/cdk/platform';
import * as i2$2 from '@angular/cdk/text-field';
import * as i6 from '@angular/cdk/portal';
import { BasePortalOutlet, CdkPortalOutlet, TemplatePortal, ComponentPortal, DomPortalOutlet, PortalModule } from '@angular/cdk/portal';
import { dateFormats } from '@rogers/cdk/common/constants';
import IMask from 'imask';
import * as i3$1 from '@angular/cdk/overlay';
import { OverlayRef, OverlayConfig, OverlayModule } from '@angular/cdk/overlay';
import { Breakpoints, MediaBreakpoints } from '@rogers/cdk/common/enums';
import * as i2$3 from '@angular/cdk/layout';
import { DSValidators } from '@rogers/cdk/common/validators';
import * as i3$4 from '@angular/cdk/collections';

class OptionComponent {
    constructor() {
        this.click = new EventEmitter();
    }
    set focused(val) {
        this._focused = val;
    }
    get focused() {
        return !!this._focused;
    }
    ngOnInit() { }
}
OptionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: OptionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OptionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: OptionComponent, selector: "ds-option", inputs: { value: "value" }, outputs: { click: "click" }, viewQueries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true, static: true }], ngImport: i0, template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n", encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: OptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-option', styles: [], encapsulation: ViewEncapsulation.None, template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { template: [{
                type: ViewChild,
                args: [TemplateRef, { static: true }]
            }], click: [{
                type: Output
            }], value: [{
                type: Input
            }] } });

class AutoCompleteComponent {
    constructor(element, _changeDetectorRef, focusMonitor, window) {
        this.element = element;
        this._changeDetectorRef = _changeDetectorRef;
        this.focusMonitor = focusMonitor;
        this.window = window;
        this.selectedValue = new BehaviorSubject(null);
    }
    get hasFocus() {
        return this._hasFocus;
    }
    ngAfterViewInit() {
        this.focusMonitor
            .monitor(this.element.nativeElement, true)
            .subscribe((origin) => {
            this._hasFocus = !!origin;
        });
    }
    handleClick(event) {
        const code = event.keyCode || event.which;
        switch (code) {
            case 13:
            case 32:
                if (this.window.isBrowser()) {
                    const focusedOption = this.options.find((o) => o.focused);
                    event.preventDefault();
                    this.elementClick(event, focusedOption);
                    event.stopPropagation();
                }
                break;
            case 40:
                this.next();
                event.preventDefault();
                break;
            case 38:
                if (this.window.isBrowser()) {
                    if (this.focusedOptionIndex === 0) {
                        this.focusMonitor.focusVia(this.element.nativeElement
                            .closest('.ds-formField')
                            .getElementsByTagName('input')[0], 'keyboard');
                    }
                    else {
                        this.previous();
                        event.preventDefault();
                    }
                }
                break;
            default:
                break;
        }
    }
    next() {
        return this.focusedOptionIndex !== this.options.length - 1
            ? this.focusOption(this.focusedOptionIndex + 1)
            : '';
    }
    previous() {
        return this.focusedOptionIndex !== 0
            ? this.focusOption(this.focusedOptionIndex - 1)
            : '';
    }
    focusOption(index) {
        this.focusedOptionIndex = index;
        if (this.window.isBrowser()) {
            this.focusMonitor.focusVia(this.element.nativeElement.querySelectorAll('li')[index], 'keyboard');
        }
    }
    elementClick(event, option) {
        this.selectedValue.next(option);
        option.click.emit({ event, option });
        this.options.reset([]);
        this._changeDetectorRef.markForCheck();
    }
    onOptionFocus(option) {
        option.focused = true;
    }
    onOptionBlur(option) {
        option.focused = false;
    }
    onBlur(event) {
        if (!this.element.nativeElement.contains(event.relatedTarget)) {
            this.options.reset([]);
            this._changeDetectorRef.markForCheck();
        }
    }
    ngOnInit() { }
}
AutoCompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AutoCompleteComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1.FocusMonitor }, { token: i1$1.WindowService }], target: i0.ɵɵFactoryTarget.Component });
AutoCompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AutoCompleteComponent, selector: "ds-auto-complete", host: { listeners: { "keydown": "handleClick($event)", "focusout": "onBlur($event)" }, properties: { "class.ds-bgcolor-white": "true", "class.d-none": "true", "class.d-block": "options.length ? true : false", "class.ds-corners": "true" } }, queries: [{ propertyName: "options", predicate: OptionComponent }], ngImport: i0, template: "<!-- Span below is to add a separator between input field and autocomplete results -->\n<span class=\"d-block px-16 ds-borders bx-2 by-0 ds-brcolor-black\">\n  <span class=\"d-block ds-border-bottom\"></span>\n</span>\n<ul\n  role=\"listbox\"\n  class=\"\n    list-none\n    ds-no-overflow\n    pt-12\n    pb-8\n    ds-borders\n    bt-0\n    bx-2\n    bb-2\n    ds-brcolor-black ds-corners-bottom\n  \"\n>\n  <li\n    role=\"option\"\n    cdkMonitorSubtreeFocus\n    *ngFor=\"let option of options; let index = index\"\n    [attr.tabindex]=\"focusedOptionIndex === index ? 0 : -1\"\n    class=\"\n      px-16\n      py-12\n      text-body\n      mb-0\n      d-flex\n      align-items-start align-items-sm-center\n      outline-none\n      ds-pointer\n    \"\n    (click)=\"elementClick($event, option)\"\n    (focus)=\"onOptionFocus(option)\"\n    (blur)=\"onOptionBlur(option)\"\n  >\n    <ng-container [ngTemplateOutlet]=\"option.template\"></ng-container>\n  </li>\n</ul>\n", directives: [{ type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4$1.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }, { type: i5.FocusDirective, selector: "[focus]", inputs: ["focus", "eventSource"] }, { type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AutoCompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-auto-complete', host: {
                        '[class.ds-bgcolor-white]': 'true',
                        '[class.d-none]': 'true',
                        '[class.d-block]': 'options.length ? true : false',
                        '[class.ds-corners]': 'true',
                    }, encapsulation: ViewEncapsulation.None, template: "<!-- Span below is to add a separator between input field and autocomplete results -->\n<span class=\"d-block px-16 ds-borders bx-2 by-0 ds-brcolor-black\">\n  <span class=\"d-block ds-border-bottom\"></span>\n</span>\n<ul\n  role=\"listbox\"\n  class=\"\n    list-none\n    ds-no-overflow\n    pt-12\n    pb-8\n    ds-borders\n    bt-0\n    bx-2\n    bb-2\n    ds-brcolor-black ds-corners-bottom\n  \"\n>\n  <li\n    role=\"option\"\n    cdkMonitorSubtreeFocus\n    *ngFor=\"let option of options; let index = index\"\n    [attr.tabindex]=\"focusedOptionIndex === index ? 0 : -1\"\n    class=\"\n      px-16\n      py-12\n      text-body\n      mb-0\n      d-flex\n      align-items-start align-items-sm-center\n      outline-none\n      ds-pointer\n    \"\n    (click)=\"elementClick($event, option)\"\n    (focus)=\"onOptionFocus(option)\"\n    (blur)=\"onOptionBlur(option)\"\n  >\n    <ng-container [ngTemplateOutlet]=\"option.template\"></ng-container>\n  </li>\n</ul>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1.FocusMonitor }, { type: i1$1.WindowService }]; }, propDecorators: { options: [{
                type: ContentChildren,
                args: [OptionComponent]
            }], handleClick: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onBlur: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }] } });

let uid$6 = 0;
const DS_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxComponent),
    multi: true,
};
class CheckboxChange {
}
class CheckboxComponent {
    constructor(element, cdr, focusMonitor, cdkCore) {
        this.element = element;
        this.cdr = cdr;
        this.focusMonitor = focusMonitor;
        this.cdkCore = cdkCore;
        this.destroyed$ = new Subject();
        this.uniqueId = `ds-checkbox-id-${uid$6++}`;
        this._id = '';
        this._checked = false;
        this._disabled = false;
        this.name = null;
        this.caption = null;
        this.change = new EventEmitter();
        this.indeterminateChange = new EventEmitter();
        this._indeterminate = false;
        this.onTouched = () => { };
        this._controlValueAccessorChangeFn = () => { };
        this.focusMonitor
            .monitor(this.element, true)
            .pipe(takeUntil(this.destroyed$))
            .subscribe((focusOrigin) => {
            if (!focusOrigin) {
                Promise.resolve().then(() => {
                    this.onTouched();
                    this.cdr.markForCheck();
                });
            }
        });
    }
    set id(id) {
        this._id = id || this.uniqueId;
        if (id) {
            this.hostId = id + '-host';
        }
    }
    get id() {
        return this._id;
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    get checked() {
        return this._checked;
    }
    set checked(value) {
        const newValue = coerceBooleanProperty(value);
        if (newValue !== this.checked) {
            this._checked = newValue;
            this.cdr.markForCheck();
        }
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        const newValue = coerceBooleanProperty(value);
        if (newValue !== this.disabled) {
            this._disabled = newValue;
            this.cdr.markForCheck();
        }
    }
    get inputId() {
        return this.id || this.uniqueId;
    }
    get indeterminate() {
        return this._indeterminate;
    }
    set indeterminate(value) {
        this._indeterminate = coerceBooleanProperty(value);
        this._syncIndeterminate(this._indeterminate);
        this.indeterminateChange.emit(this._indeterminate);
        this.cdr.markForCheck();
    }
    get brand() {
        return this.cdkCore.brand;
    }
    ngOnInit() { }
    ngAfterViewInit() {
        this._syncIndeterminate(this._indeterminate);
    }
    ngOnDestroy() {
        this.destroyed$.next(void 0);
        this.destroyed$.complete();
        this.focusMonitor.stopMonitoring(this.element);
    }
    writeValue(obj) {
        this.checked = !!obj;
    }
    registerOnChange(fn) {
        this._controlValueAccessorChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    toggle() {
        this.checked = !this.checked;
    }
    onInputClick(event) {
        event.stopPropagation();
        if (!this.disabled) {
            //on manual click set indeterminate= false
            this.toggle();
            if (this.indeterminate) {
                this._indeterminate = false;
                this.indeterminateChange.emit(this._indeterminate);
            }
            this.emitChangeEvent();
        }
    }
    focus() {
        this.focusMonitor.focusVia(this.element, 'keyboard');
    }
    onInteractionEvent(event) {
        event.stopPropagation();
    }
    emitChangeEvent() {
        const event = new CheckboxChange();
        event.source = this;
        event.checked = this.checked;
        this._controlValueAccessorChangeFn(this.checked);
        this.change.emit(event);
    }
    _syncIndeterminate(value) {
        const nativeCheckbox = this.inputElement;
        if (nativeCheckbox) {
            nativeCheckbox.nativeElement.indeterminate = value;
        }
    }
    getAriaControls() {
        // Storybook taking arrays as object so need to test if ariaControls is an array
        return this.ariaControls && Array.isArray(this.ariaControls)
            ? this.ariaControls.join(' ')
            : null;
    }
}
CheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CheckboxComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1.FocusMonitor }, { token: i2.CDKCoreService }], target: i0.ɵɵFactoryTarget.Component });
CheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CheckboxComponent, selector: "ds-checkbox", inputs: { id: "id", ariaDescribedBy: "ariaDescribedBy", required: "required", checked: "checked", disabled: "disabled", name: "name", value: "value", caption: "caption", standalone: "standalone", ariaControls: "ariaControls", indeterminate: "indeterminate" }, outputs: { change: "change", indeterminateChange: "indeterminateChange" }, host: { properties: { "class.-indeterminate": "indeterminate", "attr.id": "this.hostId" }, classAttribute: "ds-checkbox" }, providers: [DS_CHECKBOX_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "inputElement", first: true, predicate: ["input"], descendants: true, static: true }], ngImport: i0, template: "<label\n  [attr.for]=\"inputId\"\n  [attr.title]=\"caption\"\n  [attr.aria-labelledby]=\"inputId + '-label-container'\"\n  class=\"ds-checkboxLabel d-inline-flex align-items-start\"\n  [ngClass]=\"{ '-standalone justify-content-center': standalone }\"\n  #label\n>\n  <input\n    type=\"checkbox\"\n    #input\n    class=\"ds-checkbox__input cdk-visually-hidden\"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [tabIndex]=\"0\"\n    [attr.aria-label]=\"caption\"\n    [attr.aria-checked]=\"\n      checked && !indeterminate ? 'true' : indeterminate ? 'mixed' : 'false'\n    \"\n    [attr.aria-controls]=\"getAriaControls()\"\n    [attr.aria-describedby]=\"ariaDescribedBy || null\"\n    (change)=\"onInteractionEvent($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <div\n    class=\"ds-checkbox__box my-12\"\n    aria-hidden=\"true\"\n    [ngClass]=\"{\n      'rds-icon-checkmark': brand === 'rogers' && checked && !indeterminate,\n      'fds-icon-checkmark': brand === 'fido' && checked && !indeterminate,\n      'cds-icon-checkmark': brand === 'chatr' && checked && !indeterminate,\n      'sds-icon-checkmark': brand === 'r4b' && checked && !indeterminate,\n      'rds-icon-minus': brand === 'rogers' && indeterminate,\n      'fds-icon-minus': brand === 'fido' && indeterminate,\n      'cds-icon-minus': brand === 'chatr' && indeterminate,\n      'sds-icon-minus': brand === 'r4b' && indeterminate\n    }\"\n  ></div>\n  <div\n    class=\"ds-checkboxLabel__container ml-8 text-body my-12\"\n    [brClass]=\"[['text-semi', 'text-semi', '', 'text-semi']]\"\n    [id]=\"inputId + '-label-container'\"\n    [ngClass]=\"{ 'sr-only': standalone }\"\n  >\n    <span style=\"display: none\">&nbsp;</span>\n    <!-- Add an invisible span so JAWS can read the label -->\n    <ng-content></ng-content>\n  </div>\n</label>\n", directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.BrandClassDirective, selector: "[brClass]", inputs: ["brClass"] }], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    Default(false)
], CheckboxComponent.prototype, "standalone", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-checkbox', encapsulation: ViewEncapsulation.None, host: {
                        class: 'ds-checkbox',
                        '[class.-indeterminate]': 'indeterminate',
                    }, providers: [DS_CHECKBOX_CONTROL_VALUE_ACCESSOR], template: "<label\n  [attr.for]=\"inputId\"\n  [attr.title]=\"caption\"\n  [attr.aria-labelledby]=\"inputId + '-label-container'\"\n  class=\"ds-checkboxLabel d-inline-flex align-items-start\"\n  [ngClass]=\"{ '-standalone justify-content-center': standalone }\"\n  #label\n>\n  <input\n    type=\"checkbox\"\n    #input\n    class=\"ds-checkbox__input cdk-visually-hidden\"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [tabIndex]=\"0\"\n    [attr.aria-label]=\"caption\"\n    [attr.aria-checked]=\"\n      checked && !indeterminate ? 'true' : indeterminate ? 'mixed' : 'false'\n    \"\n    [attr.aria-controls]=\"getAriaControls()\"\n    [attr.aria-describedby]=\"ariaDescribedBy || null\"\n    (change)=\"onInteractionEvent($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <div\n    class=\"ds-checkbox__box my-12\"\n    aria-hidden=\"true\"\n    [ngClass]=\"{\n      'rds-icon-checkmark': brand === 'rogers' && checked && !indeterminate,\n      'fds-icon-checkmark': brand === 'fido' && checked && !indeterminate,\n      'cds-icon-checkmark': brand === 'chatr' && checked && !indeterminate,\n      'sds-icon-checkmark': brand === 'r4b' && checked && !indeterminate,\n      'rds-icon-minus': brand === 'rogers' && indeterminate,\n      'fds-icon-minus': brand === 'fido' && indeterminate,\n      'cds-icon-minus': brand === 'chatr' && indeterminate,\n      'sds-icon-minus': brand === 'r4b' && indeterminate\n    }\"\n  ></div>\n  <div\n    class=\"ds-checkboxLabel__container ml-8 text-body my-12\"\n    [brClass]=\"[['text-semi', 'text-semi', '', 'text-semi']]\"\n    [id]=\"inputId + '-label-container'\"\n    [ngClass]=\"{ 'sr-only': standalone }\"\n  >\n    <span style=\"display: none\">&nbsp;</span>\n    <!-- Add an invisible span so JAWS can read the label -->\n    <ng-content></ng-content>\n  </div>\n</label>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1.FocusMonitor }, { type: i2.CDKCoreService }]; }, propDecorators: { hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], id: [{
                type: Input
            }], ariaDescribedBy: [{
                type: Input
            }], required: [{
                type: Input
            }], checked: [{
                type: Input
            }], disabled: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], caption: [{
                type: Input
            }], standalone: [{
                type: Input
            }], ariaControls: [{
                type: Input
            }], change: [{
                type: Output
            }], inputElement: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }], indeterminateChange: [{
                type: Output
            }], indeterminate: [{
                type: Input
            }] } });

const DS_CHECKBOX_REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    useExisting: forwardRef(() => CheckboxRequiredValidatorDirective),
    multi: true,
};
class CheckboxRequiredValidatorDirective extends CheckboxRequiredValidator {
}
CheckboxRequiredValidatorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CheckboxRequiredValidatorDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
CheckboxRequiredValidatorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: CheckboxRequiredValidatorDirective, selector: "ds-checkbox[required][formControlName],\n             ds-checkbox[required][formControl], ds-checkbox[required][ngModel]", host: { properties: { "attr.required": "required ? \"\" : null" } }, providers: [DS_CHECKBOX_REQUIRED_VALIDATOR], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CheckboxRequiredValidatorDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: `ds-checkbox[required][formControlName],
             ds-checkbox[required][formControl], ds-checkbox[required][ngModel]`,
                    providers: [DS_CHECKBOX_REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required ? "" : null' },
                }]
        }] });

class DatepickerInjectableData {
    constructor(data) {
        this.data = data;
    }
    get source() {
        return this.data;
    }
}
const token = 'ds-datepicker-dpid';
const dpid = new InjectionToken(token);
const provider = {
    provide: dpid,
    useValue: new DatepickerInjectableData({}),
};

class Day {
    constructor(_date) {
        this._date = _date;
        this.disabled = false;
    }
    static isDisabled(config, _day) {
        return ((config.minDate && _day.date.isBefore(config.minDate, 'date')) ||
            (config.maxDate && _day.date.isAfter(config.maxDate, 'date')) ||
            (config.blockedDates &&
                config.blockedDates.findIndex((d) => _day.date.isSame(d, 'date')) > -1));
    }
    get date() {
        return this._date;
    }
    get formatDate() {
        return this.date.format('D-MM-YYYY');
    }
    get day() {
        return Number(this.date.format('D'));
    }
    fromPreviousMonth(date) {
        return this.date.isBefore(date, 'month');
    }
    fromNextMonth(date) {
        return this.date.isAfter(date, 'month');
    }
    isEqualTo(date) {
        // because Dayjs.isSame(undefined) returns true
        return date !== undefined ? this.date.isSame(date, 'day') : false;
    }
}

const NUMBER_OF_DAYS_IN_WEEK = 7;
class Month {
    constructor(date, config) {
        this.date = date;
        this.config = config;
        this._currentDisplayedMonth = this.date.clone();
        this._previousDisplayedMonth = this.date.clone().subtract(1, 'month');
        this._nextDisplayedMonth = this.date.clone().add(1, 'month');
    }
    get totalNumberOfDaysInMonth() {
        return this._currentDisplayedMonth.daysInMonth();
    }
    get lastDayofPreviousMonth() {
        return Number(this._previousDisplayedMonth.endOf('month').format('D'));
    }
    get indexOfLastDayOfPreviousMonth() {
        return Number(this._previousDisplayedMonth.endOf('month').format('d'));
    }
    get indexOfFirstDayOfNextMonth() {
        return Number(this._nextDisplayedMonth.startOf('month').format('d'));
    }
    getCalendarMonthMatrix() {
        const calendarMonth = [
            ...this.previousMonthDayList().reverse(),
            ...this.currentMonthDayList(),
            ...this.nextMonthDayList(),
        ];
        return chunk(calendarMonth, NUMBER_OF_DAYS_IN_WEEK);
    }
    currentMonthDayList() {
        const arr = [];
        for (let i = 0; i < this.totalNumberOfDaysInMonth; i++) {
            const _day = new Day(this._currentDisplayedMonth.clone().startOf('month').add(i, 'day'));
            _day.disabled = Day.isDisabled(this.config, _day);
            arr.push(_day);
        }
        return arr;
    }
    previousMonthDayList() {
        const arr = [];
        if (this.indexOfLastDayOfPreviousMonth !== NUMBER_OF_DAYS_IN_WEEK - 1) {
            for (let i = 0, lastDay = this.lastDayofPreviousMonth; i < this.indexOfLastDayOfPreviousMonth + 1; i++, lastDay--) {
                const _day = new Day(this._previousDisplayedMonth.clone().endOf('month').subtract(i, 'day'));
                _day.disabled = Day.isDisabled(this.config, _day);
                arr.push(_day);
            }
        }
        return arr;
    }
    nextMonthDayList() {
        const arr = [];
        if (this.indexOfFirstDayOfNextMonth !== 0) {
            for (let i = this.indexOfFirstDayOfNextMonth, day = 0; i < NUMBER_OF_DAYS_IN_WEEK; i++, day++) {
                const _day = new Day(this._nextDisplayedMonth.clone().startOf('month').add(day, 'day'));
                _day.disabled = Day.isDisabled(this.config, _day);
                arr.push(_day);
            }
        }
        return arr;
    }
}

class CalendarComponent {
    constructor(windowService) {
        this.windowService = windowService;
        this.keydownEventSubscription = Subscription.EMPTY;
        this._dayjs = _djs.default();
        this.matrix = [];
        this.weekDaysArr = [];
        this.dateChange = new EventEmitter();
        this.focusBlur = new EventEmitter();
        if (!this.language) {
            this.language = 'en';
        }
    }
    get dayjs() {
        return this._dayjs;
    }
    get focusedDate() {
        return this._focusedDate.clone();
    }
    get todaysDate() {
        return this._todaysDate;
    }
    get currentDisplayDate() {
        return this._currentDisplayDate.clone();
    }
    get localeLang() {
        return this.language.concat('-ca');
    }
    get weekDaysHead() {
        return this.weekDaysArr;
    }
    get displayMonth() {
        return this.currentDisplayDate.locale(this.localeLang).format('MMMM');
    }
    get displayYear() {
        return this.currentDisplayDate.format('YYYY');
    }
    set language(lang) {
        this._language = lang;
        this.dayjs.locale(this.localeLang);
    }
    get language() {
        return this._language;
    }
    set attached(value) {
        this._attached = value;
        if (value) {
            this.subscribeToKeyboardEvents();
        }
        else {
            this.keydownEventSubscription.unsubscribe();
        }
    }
    get attached() {
        return !!this._attached;
    }
    set selectedDate(value) {
        if (value) {
            this._selectedDate = value.clone();
        }
    }
    get selectedDate() {
        return this._selectedDate;
    }
    ngOnInit() {
        extend(customParseFormat.default);
        extend(weekDay.default);
        this.subscribeToKeyboardEvents();
        this.changeCurrentDisplayMonth(this.selectedDate ? this.selectedDate : this.dayjs, this.selectedDate ? this.selectedDate : this.dayjs);
        this._todaysDate = this._dayjs.clone();
        // initialize week days array
        for (let i = 0; i < 7; i++) {
            const dayArray = [];
            dayArray.push(_djs
                .default()
                .locale(this.localeLang)
                .weekday(i)
                .format('ddd')
                .substring(0, 1));
            dayArray.push(_djs.default().locale(this.localeLang).weekday(i).format('dddd'));
            this.weekDaysArr.push(dayArray);
        }
    }
    changeCurrentDisplayMonth(date, focusedDate) {
        this._currentDisplayDate = date.clone();
        this.matrix = new Month(this.currentDisplayDate, this.config || {}).getCalendarMonthMatrix();
        this.setFocusedDate(focusedDate.clone());
    }
    setFocusedDate(date) {
        this._focusedDate = date.clone();
    }
    goBack(numberOfDays) {
        const next = this.focusedDate.subtract(numberOfDays, 'day');
        if (next.isBefore(this.currentDisplayDate, 'month')) {
            this.goToPreviousDate('month', next);
        }
        else {
            this.setFocusedDate(next);
        }
    }
    goFront(numberOfDays) {
        const next = this.focusedDate.add(numberOfDays, 'day');
        if (next.isAfter(this.currentDisplayDate, 'month')) {
            this.goToNextDate('month', next);
        }
        else {
            this.setFocusedDate(next);
        }
    }
    goRight() {
        this.goFront(1);
    }
    goLeft() {
        this.goBack(1);
    }
    goDown() {
        this.goFront(7);
    }
    goUp() {
        this.goBack(7);
    }
    pageUp(unit) {
        const next = this.focusedDate.subtract(1, unit);
        this.changeCurrentDisplayMonth(next, next);
    }
    pageDown(unit) {
        const next = this.focusedDate.add(1, unit);
        this.changeCurrentDisplayMonth(next, next);
    }
    home() {
        this.setFocusedDate(this.focusedDate.startOf('month'));
    }
    end() {
        this.setFocusedDate(this.focusedDate.endOf('month'));
    }
    spaceOrEnter() {
        this.setSelectedDate(this.focusedDate);
    }
    keyProcessor(e) {
        if (this.attached) {
            e.preventDefault();
            if (e.keyCode === 39) {
                // Right
                this.goRight();
            }
            else if (e.keyCode === 37) {
                // Left
                this.goLeft();
            }
            else if (e.keyCode === 38) {
                // Up
                this.goUp();
            }
            else if (e.keyCode === 40) {
                // Down
                this.goDown();
            }
            else if (!e.altKey && e.keyCode === 33) {
                // PgUp
                this.pageUp('month');
            }
            else if (!e.altKey && e.keyCode === 34) {
                // PgDown
                this.pageDown('month');
            }
            else if (e.keyCode === 36) {
                // Home
                this.home();
            }
            else if (e.keyCode === 35) {
                // End
                this.end();
            }
            else if (e.altKey && e.keyCode === 33) {
                // Alt+PgUp
                this.pageUp('year');
            }
            else if (e.altKey && e.keyCode === 34) {
                // Alt+PgDown
                this.pageDown('year');
            }
            else if (!e.shiftKey && e.keyCode === 9) {
                // Tab
                this.focusBlur.emit('tab');
            }
            else if (e.shiftKey && e.keyCode === 9) {
                // Shift+Tab
                this.focusBlur.emit('shiftTab');
            }
            else if (e.keyCode === 32 || e.keyCode === 13) {
                // Space or Enter
                this.spaceOrEnter();
            }
            else if (e.keyCode === 27) {
                // ESC
                this.focusBlur.emit('esc');
            }
        }
    }
    isDisabled(_date) {
        return this.matrix.some((_weekDays) => _weekDays.findIndex((_day) => _day.isEqualTo(_date) && _day.disabled) >
            -1);
    }
    subscribeToKeyboardEvents() {
        if (this.windowService.isBrowser()) {
            if (this.keydownEventSubscription === Subscription.EMPTY) {
                this.keydownEventSubscription = fromEvent(document, 'keydown').subscribe((e) => {
                    this.keyProcessor(e);
                });
            }
        }
    }
    goToPreviousDate(unit, focusedDate) {
        this.changeCurrentDisplayMonth(this.currentDisplayDate.subtract(1, unit), focusedDate || this.currentDisplayDate.subtract(1, unit).startOf('month'));
    }
    goToNextDate(unit, focusedDate) {
        this.changeCurrentDisplayMonth(this.currentDisplayDate.add(1, unit), focusedDate || this.currentDisplayDate.add(1, unit).startOf('month'));
    }
    setSelectedDate(date) {
        if (!this.isDisabled(date)) {
            this._selectedDate = date.clone();
            this.setFocusedDate(date);
            this.dateChange.emit(date);
        }
    }
    getDateTitle(date) {
        let title;
        this.language === 'en'
            ? (title = date.date.format('dddd, MMMM D, YYYY'))
            : (title = date.date.locale('fr-ca').format('dddd, MMMM D, YYYY'));
        if (date.isEqualTo(this.todaysDate) && this.currentDateTitle) {
            title += '. ' + this.currentDateTitle;
        }
        if (this.isDisabled(date.date) && this.blockedDateTitle) {
            title += '. ' + this.blockedDateTitle;
        }
        return title;
    }
    ngOnDestroy() {
        this.attached = false;
        this.keydownEventSubscription.unsubscribe();
    }
}
CalendarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarComponent, deps: [{ token: i1$1.WindowService }], target: i0.ɵɵFactoryTarget.Component });
CalendarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CalendarComponent, selector: "ds-calendar", inputs: { language: "language", attached: "attached", config: "config", selectedDate: "selectedDate", eventSource: "eventSource", blockedDateTitle: "blockedDateTitle", currentDateTitle: "currentDateTitle", a11yDescriptionPrevious: "a11yDescriptionPrevious", a11yDescriptionNext: "a11yDescriptionNext" }, outputs: { dateChange: "dateChange", focusBlur: "focusBlur" }, ngImport: i0, template: "<div\n  class=\"calendar-navigation d-flex justify-content-between align-items-center mb-16\"\n>\n  <div id=\"calendar-month-title\" class=\"text-bold\" aria-live=\"polite\">\n    {{ displayMonth | uppercase }} {{ displayYear }}\n  </div>\n  <div class=\"d-flex justify-content-between\">\n    <button\n      [attr.aria-label]=\"a11yDescriptionPrevious\"\n      ds-button\n      variant=\"icon\"\n      (click)=\"goToPreviousDate('month')\"\n    >\n      <ds-icon [name]=\"'chevron-left-outlined'\"></ds-icon>\n    </button>\n    <button\n      [attr.aria-label]=\"a11yDescriptionNext\"\n      ds-button\n      variant=\"icon\"\n      (click)=\"goToNextDate('month')\"\n    >\n      <ds-icon [name]=\"'chevron-right-outlined'\"></ds-icon>\n    </button>\n  </div>\n</div>\n<div>\n  <table role=\"grid\" aria-labelledby=\"calendar-month-title\" class=\"w-100\">\n    <thead class=\"text-bold\" role=\"presentation\">\n      <tr>\n        <th\n          *ngFor=\"let weekDayHead of weekDaysHead\"\n          class=\"text-center pb-8\"\n          scope=\"col\"\n          [attr.abbr]=\"weekDayHead[1]\"\n        >\n          {{ weekDayHead[0] }}\n        </th>\n      </tr>\n    </thead>\n    <tbody role=\"presentation\">\n      <tr *ngFor=\"let matrixRow of matrix; let weekIndex = index\" role=\"row\">\n        <td\n          *ngFor=\"let matrixElement of matrixRow; let dayIndex = index\"\n          role=\"gridcell\"\n        >\n          <div class=\"cellWrapper\">\n            <button\n              #date\n              [attr.aria-disabled]=\"matrixElement.disabled\"\n              [attr.title]=\"getDateTitle(matrixElement)\"\n              [attr.aria-label]=\"getDateTitle(matrixElement)\"\n              [focus]=\"matrixElement.isEqualTo(focusedDate)\"\n              [eventSource]=\"eventSource\"\n              [ngClass]=\"{\n                '-disabled': matrixElement.disabled,\n                '-selected': matrixElement.isEqualTo(selectedDate),\n                '-focused': matrixElement.isEqualTo(focusedDate),\n                '-today': matrixElement.isEqualTo(todaysDate),\n                '-previousDate': matrixElement.fromPreviousMonth(\n                  currentDisplayDate\n                ),\n                '-nextDate': matrixElement.fromNextMonth(currentDisplayDate),\n                'ds-pointer': !matrixElement.disabled\n              }\"\n              (click)=\"\n                !matrixElement.disabled && setSelectedDate(matrixElement.date)\n              \"\n              class=\"datepicker-date w-100 h-100 p-4 full-screen\"\n            >\n              <div\n                class=\"d-flex justify-content-center align-items-center w-100 h-100\"\n              >\n                {{ matrixElement.day }}\n              </div>\n            </button>\n          </div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n", components: [{ type: i2$1.ButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["variant", "size", "alignIcon", "img", "transparent", "disabled", "tabIndex", "a11yDescription"] }, { type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.FocusDirective, selector: "[focus]", inputs: ["focus", "eventSource"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "uppercase": i4.UpperCasePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-calendar', template: "<div\n  class=\"calendar-navigation d-flex justify-content-between align-items-center mb-16\"\n>\n  <div id=\"calendar-month-title\" class=\"text-bold\" aria-live=\"polite\">\n    {{ displayMonth | uppercase }} {{ displayYear }}\n  </div>\n  <div class=\"d-flex justify-content-between\">\n    <button\n      [attr.aria-label]=\"a11yDescriptionPrevious\"\n      ds-button\n      variant=\"icon\"\n      (click)=\"goToPreviousDate('month')\"\n    >\n      <ds-icon [name]=\"'chevron-left-outlined'\"></ds-icon>\n    </button>\n    <button\n      [attr.aria-label]=\"a11yDescriptionNext\"\n      ds-button\n      variant=\"icon\"\n      (click)=\"goToNextDate('month')\"\n    >\n      <ds-icon [name]=\"'chevron-right-outlined'\"></ds-icon>\n    </button>\n  </div>\n</div>\n<div>\n  <table role=\"grid\" aria-labelledby=\"calendar-month-title\" class=\"w-100\">\n    <thead class=\"text-bold\" role=\"presentation\">\n      <tr>\n        <th\n          *ngFor=\"let weekDayHead of weekDaysHead\"\n          class=\"text-center pb-8\"\n          scope=\"col\"\n          [attr.abbr]=\"weekDayHead[1]\"\n        >\n          {{ weekDayHead[0] }}\n        </th>\n      </tr>\n    </thead>\n    <tbody role=\"presentation\">\n      <tr *ngFor=\"let matrixRow of matrix; let weekIndex = index\" role=\"row\">\n        <td\n          *ngFor=\"let matrixElement of matrixRow; let dayIndex = index\"\n          role=\"gridcell\"\n        >\n          <div class=\"cellWrapper\">\n            <button\n              #date\n              [attr.aria-disabled]=\"matrixElement.disabled\"\n              [attr.title]=\"getDateTitle(matrixElement)\"\n              [attr.aria-label]=\"getDateTitle(matrixElement)\"\n              [focus]=\"matrixElement.isEqualTo(focusedDate)\"\n              [eventSource]=\"eventSource\"\n              [ngClass]=\"{\n                '-disabled': matrixElement.disabled,\n                '-selected': matrixElement.isEqualTo(selectedDate),\n                '-focused': matrixElement.isEqualTo(focusedDate),\n                '-today': matrixElement.isEqualTo(todaysDate),\n                '-previousDate': matrixElement.fromPreviousMonth(\n                  currentDisplayDate\n                ),\n                '-nextDate': matrixElement.fromNextMonth(currentDisplayDate),\n                'ds-pointer': !matrixElement.disabled\n              }\"\n              (click)=\"\n                !matrixElement.disabled && setSelectedDate(matrixElement.date)\n              \"\n              class=\"datepicker-date w-100 h-100 p-4 full-screen\"\n            >\n              <div\n                class=\"d-flex justify-content-center align-items-center w-100 h-100\"\n              >\n                {{ matrixElement.day }}\n              </div>\n            </button>\n          </div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.WindowService }]; }, propDecorators: { language: [{
                type: Input
            }], attached: [{
                type: Input
            }], config: [{
                type: Input
            }], selectedDate: [{
                type: Input
            }], eventSource: [{
                type: Input
            }], blockedDateTitle: [{
                type: Input
            }], currentDateTitle: [{
                type: Input
            }], a11yDescriptionPrevious: [{
                type: Input
            }], a11yDescriptionNext: [{
                type: Input
            }], dateChange: [{
                type: Output
            }], focusBlur: [{
                type: Output
            }] } });

class DatepickerComponent {
    constructor() {
        this.hasAttached = new BehaviorSubject(false);
        this.selectedDateChange = new EventEmitter();
    }
    get selectedDate() {
        return this._selectedDate;
    }
    set language(language) {
        this._language = language;
    }
    get language() {
        return this._language || 'en';
    }
    ngOnInit() { }
    blurKeyDetectionHandler(e) {
        if (e === 'esc' || e === 'shiftTab') {
            this.dpid.source.inputHostElement.focus();
        }
        else if (e === 'tab') {
            this.dpid.source.datepickerHostButton.focus();
        }
    }
    selectedDateChangeHandler(date) {
        this.selectedDateChange.emit(date.toDate());
    }
    setOverlayRef(overlayRef) {
        this.overlayRef = overlayRef;
    }
    setDatepickerInjectableData(datepickerInjectableData) {
        this.dpid = datepickerInjectableData;
    }
    setSelectedDate(date) {
        this._selectedDate = date;
    }
}
DatepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DatepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: DatepickerComponent, selector: "ds-datepicker", inputs: { config: "config", blockedDateTitle: "blockedDateTitle", currentDateTitle: "currentDateTitle", language: "language", a11yDescriptionPrevious: "a11yDescriptionPrevious", a11yDescriptionNext: "a11yDescriptionNext" }, outputs: { selectedDateChange: "selectedDateChange" }, ngImport: i0, template: "<div class=\"p-16\" *ngIf=\"hasAttached | async as _hasAttached\">\n  <ds-calendar\n    [language]=\"language\"\n    [attached]=\"_hasAttached\"\n    [config]=\"config\"\n    [blockedDateTitle]=\"blockedDateTitle\"\n    [currentDateTitle]=\"currentDateTitle\"\n    [selectedDate]=\"selectedDate\"\n    [eventSource]=\"eventSource\"\n    [a11yDescriptionPrevious]=\"a11yDescriptionPrevious\"\n    [a11yDescriptionNext]=\"a11yDescriptionNext\"\n    (dateChange)=\"selectedDateChangeHandler($event)\"\n    (focusBlur)=\"blurKeyDetectionHandler($event)\"\n  ></ds-calendar>\n</div>\n", components: [{ type: CalendarComponent, selector: "ds-calendar", inputs: ["language", "attached", "config", "selectedDate", "eventSource", "blockedDateTitle", "currentDateTitle", "a11yDescriptionPrevious", "a11yDescriptionNext"], outputs: ["dateChange", "focusBlur"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i4.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-datepicker', template: "<div class=\"p-16\" *ngIf=\"hasAttached | async as _hasAttached\">\n  <ds-calendar\n    [language]=\"language\"\n    [attached]=\"_hasAttached\"\n    [config]=\"config\"\n    [blockedDateTitle]=\"blockedDateTitle\"\n    [currentDateTitle]=\"currentDateTitle\"\n    [selectedDate]=\"selectedDate\"\n    [eventSource]=\"eventSource\"\n    [a11yDescriptionPrevious]=\"a11yDescriptionPrevious\"\n    [a11yDescriptionNext]=\"a11yDescriptionNext\"\n    (dateChange)=\"selectedDateChangeHandler($event)\"\n    (focusBlur)=\"blurKeyDetectionHandler($event)\"\n  ></ds-calendar>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { config: [{
                type: Input
            }], blockedDateTitle: [{
                type: Input
            }], currentDateTitle: [{
                type: Input
            }], language: [{
                type: Input
            }], a11yDescriptionPrevious: [{
                type: Input
            }], a11yDescriptionNext: [{
                type: Input
            }], selectedDateChange: [{
                type: Output
            }] } });

class HintComponent {
    constructor() { }
    ngOnInit() { }
}
HintComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: HintComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HintComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: HintComponent, selector: "ds-hint", inputs: { hintMessage: "hintMessage" }, host: { properties: { "class.ds-hint": "true" } }, ngImport: i0, template: "<p class=\"ds-hint text-body-sm mb-0 pt-4\" [innerHTML]=\"hintMessage\"></p>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: HintComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-hint', host: {
                        '[class.ds-hint]': 'true',
                    }, template: "<p class=\"ds-hint text-body-sm mb-0 pt-4\" [innerHTML]=\"hintMessage\"></p>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { hintMessage: [{
                type: Input
            }] } });

class InputLabelComponent {
    constructor() { }
    ngOnInit() { }
}
InputLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InputLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputLabelComponent, selector: "ds-input-label", inputs: { optional: "optional" }, ngImport: i0, template: "<span class=\"ds-inputLabel d-block ds-no-overflow\"\n  ><ng-content></ng-content\n  ><span class=\"ds-inputLabel__optional text-body-sm ml-4\" *ngIf=\"optional\">\n    <em> ({{ optional }})</em></span\n  ></span\n>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-input-label', encapsulation: ViewEncapsulation.None, template: "<span class=\"ds-inputLabel d-block ds-no-overflow\"\n  ><ng-content></ng-content\n  ><span class=\"ds-inputLabel__optional text-body-sm ml-4\" *ngIf=\"optional\">\n    <em> ({{ optional }})</em></span\n  ></span\n>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { optional: [{
                type: Input
            }] } });

/** Provider that defines how form controls behave with regards to displaying error messages. */
class ErrorStateMatcher {
    isErrorState(control, form) {
        return !!(control &&
            control.invalid &&
            (control.touched || (form && form.submitted)));
    }
}
ErrorStateMatcher.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ErrorStateMatcher, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ErrorStateMatcher.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ErrorStateMatcher, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ErrorStateMatcher, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class ShowOnDirtyErrorStateMatcher {
    isErrorState(control, form) {
        return !!(control &&
            control.invalid &&
            (control.dirty || (form && form.submitted)));
    }
}
ShowOnDirtyErrorStateMatcher.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ShowOnDirtyErrorStateMatcher, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ShowOnDirtyErrorStateMatcher.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ShowOnDirtyErrorStateMatcher });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ShowOnDirtyErrorStateMatcher, decorators: [{
            type: Injectable
        }] });
/**
 * Mixin to augment a directive with updateErrorState method.
 * For component with `errorState` and need to update `errorState`.
 */
function mixinErrorState(base) {
    return class extends base {
        constructor(...args) {
            super(...args);
            /** Whether the component is in an error state. */
            this.errorState = false;
            /**
             * Stream that emits whenever the state of the input changes such that the wrapping
             * `FormField` needs to run change detection.
             */
            this.stateChanges = new Subject();
        }
        updateErrorState() {
            const oldState = this.errorState;
            const parent = this._parentFormGroup || this._parentForm;
            const matcher = this.errorStateMatcher || this._defaultErrorStateMatcher;
            const control = this.ngControl
                ? this.ngControl.control
                : null;
            const newState = matcher.isErrorState(control, parent);
            if (newState !== oldState) {
                this.errorState = newState;
                this.stateChanges.next();
            }
        }
    };
}

class FormFieldControl {
}

var InputMaskType;
(function (InputMaskType) {
    InputMaskType["CreditCardNumber"] = "0000 0000 0000 0000";
    InputMaskType["CreditCardExpiry"] = "MM/YY";
    InputMaskType["CVV"] = "000";
    InputMaskType["Date"] = "MM/DD/YYYY";
    InputMaskType["PhoneNumber"] = "(000) 000-0000";
    InputMaskType["Custom"] = "CUSTOM_MASK";
})(InputMaskType || (InputMaskType = {}));
var EventType;
(function (EventType) {
    EventType["Accept"] = "accept";
    EventType["Complete"] = "complete";
})(EventType || (EventType = {}));

class DatepickerOverlayHostComponent extends BasePortalOutlet {
    constructor(el, focusMonitor, ngZone, cdr, dpid, overlayRef, datepickerComponentInstance) {
        super();
        this.el = el;
        this.focusMonitor = focusMonitor;
        this.ngZone = ngZone;
        this.cdr = cdr;
        this.dpid = dpid;
        this.overlayRef = overlayRef;
        this.datepickerComponentInstance = datepickerComponentInstance;
        this.destroyed$ = new Subject();
    }
    ngOnInit() {
        this.focusWrapper.nativeElement.focus();
        this.cdkMonitorFocus.cdkFocusChange
            .pipe(takeUntil(this.destroyed$))
            .subscribe((origin) => {
            this.ngZone.run(() => {
                const __self = this;
                if (origin === null && !this.dpid.source['debug']) {
                    if (this.overlayRef && this.overlayRef.hasAttached()) {
                        this.dpid.source?.close?.();
                        this.datepickerComponentInstance?.hasAttached.next(false);
                        this.overlayRef.detach();
                        this.overlayRef.dispose();
                    }
                }
                this.cdr.markForCheck();
            });
        });
    }
    attachComponentPortal(portal) {
        if (this.portalOutlet.hasAttached()) {
            this.portalOutlet.detach();
        }
        return this.portalOutlet.attachComponentPortal(portal);
    }
    attachTemplatePortal(portal) {
        if (this.portalOutlet.hasAttached()) {
            this.portalOutlet.detach();
            this.datepickerComponentInstance?.hasAttached.next(false);
        }
        let evr = null;
        this.datepickerComponentInstance?.setDatepickerInjectableData(this.dpid);
        this.datepickerComponentInstance?.setOverlayRef(this.overlayRef);
        evr = this.portalOutlet.attachTemplatePortal(portal);
        this.datepickerComponentInstance?.hasAttached.next(true);
        return evr;
    }
    ngOnDestroy() {
        this.destroyed$.next(void 0);
        this.destroyed$.complete();
        if (this.focusMonitorRef) {
            this.focusMonitor.stopMonitoring(this.focusWrapper);
        }
        this.datepickerComponentInstance?.hasAttached.next(false);
    }
}
DatepickerOverlayHostComponent.containerClass = '.ds-datepicker-overlay-host';
DatepickerOverlayHostComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerOverlayHostComponent, deps: [{ token: i0.ElementRef }, { token: i1.FocusMonitor }, { token: i0.NgZone }, { token: i0.ChangeDetectorRef }, { token: DatepickerInjectableData, optional: true }, { token: i3$1.OverlayRef, optional: true }, { token: DatepickerComponent, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DatepickerOverlayHostComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: DatepickerOverlayHostComponent, selector: "ds-datepicker-overlay-host", host: { properties: { "class.ds-shadow": "true", "class.ds-bgcolor-white": "true", "class.ds-datepicker-overlay-host": "true", "class.ds-corners": "true", "class.ds-no-overflow": "true" } }, viewQueries: [{ propertyName: "portalOutlet", first: true, predicate: CdkPortalOutlet, descendants: true, static: true }, { propertyName: "focusWrapper", first: true, predicate: ["focusWrapper"], descendants: true, static: true }, { propertyName: "cdkMonitorFocus", first: true, predicate: CdkMonitorFocus, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div\n  #focusWrapper\n  class=\"datepicker-focus-wrapper\"\n  cdkMonitorSubtreeFocus\n  tabindex=\"0\"\n>\n  <ng-template cdkPortalOutlet></ng-template>\n</div>\n", directives: [{ type: i4$1.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }, { type: i6.CdkPortalOutlet, selector: "[cdkPortalOutlet]", inputs: ["cdkPortalOutlet"], outputs: ["attached"], exportAs: ["cdkPortalOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerOverlayHostComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-datepicker-overlay-host', host: {
                        '[class.ds-shadow]': 'true',
                        '[class.ds-bgcolor-white]': 'true',
                        '[class.ds-datepicker-overlay-host]': 'true',
                        '[class.ds-corners]': 'true',
                        '[class.ds-no-overflow]': 'true',
                    }, template: "<div\n  #focusWrapper\n  class=\"datepicker-focus-wrapper\"\n  cdkMonitorSubtreeFocus\n  tabindex=\"0\"\n>\n  <ng-template cdkPortalOutlet></ng-template>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.FocusMonitor }, { type: i0.NgZone }, { type: i0.ChangeDetectorRef }, { type: DatepickerInjectableData, decorators: [{
                    type: Optional
                }] }, { type: i3$1.OverlayRef, decorators: [{
                    type: Optional
                }] }, { type: DatepickerComponent, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { portalOutlet: [{
                type: ViewChild,
                args: [CdkPortalOutlet, { static: true }]
            }], focusWrapper: [{
                type: ViewChild,
                args: ['focusWrapper', { static: true }]
            }], cdkMonitorFocus: [{
                type: ViewChild,
                args: [CdkMonitorFocus, { static: true }]
            }] } });

class DatepickerService {
    constructor(overlay, injector, windowService) {
        this.overlay = overlay;
        this.injector = injector;
        this.windowService = windowService;
        this.additionalProviders = [];
    }
    close() {
        this.vcr?.detach();
        this.vcr?.clear();
        if (this.overlayRef?.hasAttached()) {
            this.overlayRef?.detach();
            this.overlayRef?.dispose();
        }
        this.dpid = null;
        this.vcr = null;
        this.additionalProviders = [];
    }
    open(content, vcr, dpid, hostElement, providers) {
        this.close();
        this.vcr = vcr;
        this.dpid = dpid;
        this.dpid.source.close = this.close.bind(this);
        this.additionalProviders = providers;
        this.positionStrategy = this.getPositionStrategy(hostElement);
        this.overlayRef = this.createOverlay();
        const hostRef = this.createHostComponentRef();
        if (content.ref instanceof TemplateRef) {
            const ref = content.ref;
            const templatePortal = this.createTemplatePortal(ref);
            hostRef.instance.attachTemplatePortal(templatePortal);
        }
        else {
            const injector = this.createInjector([
                [OverlayRef, this.overlayRef],
                [DatepickerInjectableData, dpid],
            ]);
            const componentPortal = this.createComponentPortal(content, injector);
            hostRef.instance.attachComponentPortal(componentPortal);
        }
        return this.overlayRef;
    }
    createHostComponentRef() {
        const injector = this.createInjector([
            [OverlayRef, this.overlayRef],
            [DatepickerInjectableData, this.dpid],
        ]);
        const hostPortal = this.createComponentPortal({
            componentClass: DatepickerOverlayHostComponent,
            componentInstance: null,
        }, injector);
        return this.overlayRef.attach(hostPortal);
    }
    createTemplatePortal(ref) {
        return new TemplatePortal(ref, this.vcr);
    }
    createComponentPortal(componentParam, injector) {
        return new ComponentPortal(componentParam.componentClass, this.vcr, injector);
    }
    createOverlay() {
        const config = new OverlayConfig({
            disposeOnNavigation: true,
            hasBackdrop: false,
            positionStrategy: this.positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
        });
        return this.overlay.create(config);
    }
    createInjector(map) {
        const providers = map
            ?.concat(this.additionalProviders || [])
            ?.map((v) => {
            return {
                provide: v[0],
                useValue: v[1],
            };
        });
        return Injector.create({
            providers: providers,
            parent: this.injector,
        });
    }
    getPositionStrategy(elementRef) {
        const viewportMargin = this.windowService.isBrowser() && window.innerWidth < Breakpoints.Xs
            ? 0
            : 8;
        return this.overlay
            .position()
            .flexibleConnectedTo(elementRef)
            .withTransformOriginOn(DatepickerOverlayHostComponent.containerClass)
            .withFlexibleDimensions(false)
            .withViewportMargin(viewportMargin)
            .withPush()
            .withPositions([
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top',
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'end',
                overlayY: 'top',
            },
            {
                originX: 'end',
                originY: 'center',
                overlayX: 'center',
                overlayY: 'top',
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'top',
            },
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'bottom',
            },
            {
                originX: 'end',
                originY: 'center',
                overlayX: 'start',
                overlayY: 'top',
            },
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'center',
                overlayY: 'top',
            },
            {
                originX: 'end',
                originY: 'center',
                overlayX: 'end',
                overlayY: 'top',
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'center',
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
            {
                originX: 'end',
                originY: 'center',
                overlayX: 'start',
                overlayY: 'bottom',
            },
            {
                originX: 'end',
                originY: 'center',
                overlayX: 'start',
                overlayY: 'center',
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'center',
                overlayY: 'center',
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'end',
                overlayY: 'bottom',
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'top',
            },
            {
                originX: 'end',
                originY: 'center',
                overlayX: 'end',
                overlayY: 'bottom',
            },
            {
                originX: 'center',
                originY: 'center',
                overlayX: 'start',
                overlayY: 'center',
            },
        ]);
    }
}
DatepickerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerService, deps: [{ token: i3$1.Overlay }, { token: i0.Injector }, { token: i1$1.WindowService }], target: i0.ɵɵFactoryTarget.Injectable });
DatepickerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i3$1.Overlay }, { type: i0.Injector }, { type: i1$1.WindowService }]; } });

const MASKEDINPUT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    useExisting: forwardRef(() => InputMaskDirective),
    multi: true,
};
class InputMaskDirective {
    constructor(_changeDetectorRef, _elementRef, _renderer, _compositionMode) {
        this._changeDetectorRef = _changeDetectorRef;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._compositionMode = _compositionMode;
        /**
         * If this is true, the mask only shown when the input is focused
         *
         * If this is false, the mask will use the 'lazy' flag
         *
         * default = true
         *
         * @memberof InputMaskDirective
         */
        this.hideMaskWhenNotFocused = true;
        this.maskedInputChanged = new EventEmitter();
        this.maskedInputCompleted = new EventEmitter();
        this.onTouched = () => { };
        this.onChange = () => { };
        this._viewInitialized = false;
        this._composing = false;
        this._writing = false;
        if (this._compositionMode == null) {
            this._compositionMode = !this._isAndroid();
        }
    }
    /**
     * Select predefined types using @ds-shared/Types.Core.InputMaskType
     *
     * To use a custom mask,
     * select InputMaskType.Custom
     * and provide value for 'customMask'
     *
     * @memberof InputMaskDirective
     */
    get dsMask() {
        return this._dsMask;
    }
    set dsMask(value) {
        this._dsMask = value;
        if (value !== 'CUSTOM_MASK') {
            this.maskSetup();
        }
    }
    /**
     * { mask: string | RegExp, lazy: boolean }
     *
     * mask = string can have following characters:
     *
     * 0 - any digit
     *
     * a - any letter
     *
     * \* - any char
     *
     * other chars which is not in custom definitions supposed to be fixed
     *
     * [] - make input optional
     *
     * {} - include fixed part in unmasked value
     *
     * ` - prevent symbols shift back
     *
     * mask = RegExp will only format the input without displaying any mask
     *
     *
     * lazy = false to display mask as soon as the input is focused.
     *
     * lazy = true will only format input based on the mask
     *
     * @memberof InputMaskDirective
     */
    get customMask() {
        return this._customMask;
    }
    set customMask(value) {
        this._customMask = value;
        this.maskSetup();
    }
    get maskValue() {
        return this._maskRef ? this._maskRef.value : undefined;
    }
    set maskValue(value) {
        this._maskRef
            ? (this._maskRef.value = value)
            : this._renderer.setProperty(this._elementRef, 'value', value);
    }
    get unmaskedValue() {
        return this._maskRef ? this._maskRef.unmaskedValue : undefined;
    }
    ngAfterViewInit() {
        if (this.dsMask)
            this._initializeMask();
        this._viewInitialized = true;
    }
    ngOnChanges(changes) {
        if (!changes.dsMask ||
            (this.dsMask === InputMaskType.Custom && !changes.customMask) ||
            !this._viewInitialized)
            return;
        this.maskSetup();
    }
    maskSetup() {
        if (this.dsMask) {
            if (this._maskRef) {
                if (this.dsMask === InputMaskType.Custom) {
                    this._maskRef.updateOptions(this.customMask);
                }
                else {
                    this._maskRef.updateOptions({ mask: this.dsMask });
                }
            }
            else {
                this._initializeMask();
                this.onChange(this.maskValue);
            }
        }
        else {
            this._destroyMask();
        }
    }
    onFocus() {
        if (this._maskRef && this.hideMaskWhenNotFocused) {
            this._maskRef.updateOptions({
                lazy: false, // make placeholder visible
            });
            this._maskRef.value = this._maskRef.masked.resolve(this._maskRef.unmaskedValue);
        }
        if (this.formControl) {
            this.formControl.markAsTouched();
        }
    }
    onBlur() {
        if (this._maskRef && this.hideMaskWhenNotFocused) {
            this._maskRef.updateOptions({
                lazy: true, // make placeholder hidden
            });
            this._maskRef.value = this._maskRef.masked.resolve(this._maskRef.unmaskedValue);
        }
    }
    onCompositionStart() {
        this._composing = true;
    }
    onCompositionEnd(value) {
        this._composing = false;
        if (this._compositionMode)
            this.onInput(value);
    }
    onInput(value) {
        // if mask is attached all input goes throw mask
        if (this._maskRef)
            return;
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this.onChange(value);
        }
    }
    _initializeMask() {
        switch (this.dsMask) {
            case InputMaskType.CreditCardNumber:
                this._maskRef = IMask(this._elementRef.nativeElement, this._getCreditCardNumberOptions());
                break;
            case InputMaskType.CVV:
            case InputMaskType.PhoneNumber:
                this._maskRef = IMask(this._elementRef.nativeElement, {
                    mask: this.dsMask,
                });
                break;
            case InputMaskType.CreditCardExpiry:
                this._maskRef = IMask(this._elementRef.nativeElement, this._getCreditCardExpiryOptions());
                break;
            case InputMaskType.Date:
                this._maskRef = IMask(this._elementRef.nativeElement, this._getDateOptions());
                break;
            case InputMaskType.Custom:
                if (this.customMask) {
                    this._maskRef = IMask(this._elementRef.nativeElement, this.customMask);
                }
                break;
            default:
                break;
        }
        if (this._maskRef) {
            this._changeDetectorRef.detectChanges();
            this._setupEventHandlers();
        }
    }
    _setupEventHandlers() {
        this._maskRef
            .on(EventType.Accept, this._onAccept.bind(this))
            .on(EventType.Complete, this._onComplete.bind(this));
    }
    _getCreditCardNumberOptions() {
        return {
            mask: [
                {
                    mask: '0000 0000 0000 0000',
                    startWith: ['51', '52', '53', '54', '55'],
                    lazy: false,
                    type: 'MASTERCARD',
                },
                {
                    mask: '0000 0000 0000 0000',
                    startWith: ['4'],
                    lazy: false,
                    type: 'VISA',
                },
                {
                    mask: '0000 000000 00000',
                    startWith: ['34', '37'],
                    lazy: false,
                    type: 'AMEX',
                },
                {
                    mask: '0000 0000 0000 0000',
                    startWith: [],
                    lazy: false,
                    type: 'NA',
                },
            ],
            dispatch: (appended, dynamicMasked) => {
                const value = (dynamicMasked.value + appended).replace(/\D/g, '');
                return dynamicMasked.compiledMasks.find((m) => {
                    if (m.startWith.findIndex((n) => value.indexOf(n) === 0) > -1) {
                        return m;
                    }
                    return m.type === 'NA' ? m : undefined;
                });
            },
        };
    }
    _getCreditCardExpiryOptions() {
        return {
            blocks: {
                MM: {
                    mask: IMask.MaskedRange,
                    from: 1,
                    to: 12,
                    minLength: 2,
                    maxLength: 2,
                    placeholderChar: 'M',
                },
                YY: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 99,
                    minLength: 2,
                    maxLength: 2,
                    placeholderChar: 'Y',
                },
            },
            mask: 'MM/YY',
        };
    }
    _getDateOptions() {
        return {
            blocks: {
                MM: {
                    mask: IMask.MaskedRange,
                    from: 1,
                    to: 12,
                    minLength: 2,
                    maxLength: 2,
                    placeholderChar: 'M',
                },
                DD: {
                    mask: IMask.MaskedRange,
                    from: 1,
                    to: 31,
                    minLength: 2,
                    maxLength: 2,
                    placeholderChar: 'D',
                },
                YYYY: {
                    mask: IMask.MaskedRange,
                    from: 1900,
                    to: 9999,
                    minLength: 4,
                    maxLength: 4,
                    placeholderChar: 'Y',
                },
            },
            mask: 'MM/DD/YYYY',
        };
    }
    _beginWrite(value) {
        this._writing = true;
        this._writingValue = value;
    }
    _endWrite() {
        this._writing = false;
        return this._writingValue;
    }
    emitData(eventType) {
        const data = {
            maskedValue: this.maskValue,
            unmaskedValue: this.unmaskedValue,
        };
        const currentMask = this._maskRef.masked.currentMask;
        if (this.dsMask === InputMaskType.CreditCardNumber && currentMask) {
            data.type = currentMask.type;
        }
        if (eventType === EventType.Accept) {
            this.maskedInputChanged.emit(data);
        }
        else {
            this.maskedInputCompleted.emit(data);
        }
    }
    _destroyMask() {
        if (this._maskRef) {
            this._maskRef.destroy();
            delete this._maskRef;
        }
    }
    _onAccept() {
        const value = this.maskValue;
        // if value was not changed during writing don't fire events
        // for details see https://github.com/uNmAnNeR/imaskjs/issues/136
        if (this._writing && value === this._endWrite())
            return;
        this.onChange(value);
        this.emitData(EventType.Accept);
    }
    _onComplete() {
        this.emitData(EventType.Complete);
    }
    _isAndroid() {
        return /android (\d+)/.test(navigator.userAgent.toLowerCase());
    }
    writeValue(value) {
        value = value === null ? '' : value;
        if (this._maskRef) {
            this._beginWrite(value);
            if (this.maskValue !== value ||
                // handle cases like Number('') === 0,
                // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
                (typeof value !== 'string' &&
                    this._maskRef.value === '' &&
                    !this._maskRef.el.isActive)) {
                this.maskValue = value;
            }
        }
        else {
            this._renderer.setProperty(this._elementRef, 'value', value);
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this._renderer.setProperty(this._elementRef, 'disabled', isDisabled);
    }
    ngOnDestroy() {
        this._destroyMask();
        this.maskedInputChanged.complete();
        this.maskedInputCompleted.complete();
    }
}
InputMaskDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputMaskDirective, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: COMPOSITION_BUFFER_MODE, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
InputMaskDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: InputMaskDirective, selector: "input[dsInput][dsMask]", inputs: { dsMask: "dsMask", customMask: "customMask", hideMaskWhenNotFocused: "hideMaskWhenNotFocused", formControl: "formControl" }, outputs: { maskedInputChanged: "maskedInputChanged", maskedInputCompleted: "maskedInputCompleted" }, host: { listeners: { "focus": "onFocus()", "input": "onInput($event.target.value)", "blur": "onBlur()", "compositionstart": "onCompositionStart()", "compositionend": "onCompositionEnd($event.target.value)" }, classAttribute: "ds-mask" }, providers: [MASKEDINPUT_VALUE_ACCESSOR], exportAs: ["dsMask"], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[dsInput][dsMask]',
                    exportAs: 'dsMask',
                    host: {
                        class: 'ds-mask',
                        '(focus)': 'onFocus()',
                        '(input)': 'onInput($event.target.value)',
                        '(blur)': 'onBlur()',
                        '(compositionstart)': 'onCompositionStart()',
                        '(compositionend)': 'onCompositionEnd($event.target.value)',
                    },
                    providers: [MASKEDINPUT_VALUE_ACCESSOR],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [COMPOSITION_BUFFER_MODE]
                }] }]; }, propDecorators: { dsMask: [{
                type: Input
            }], customMask: [{
                type: Input
            }], hideMaskWhenNotFocused: [{
                type: Input
            }], formControl: [{
                type: Input
            }], maskedInputChanged: [{
                type: Output
            }], maskedInputCompleted: [{
                type: Output
            }] } });

let uid$5 = 0;
class DatepickerDirective {
    constructor(windowService, _el, _datePickerService, _platform, cfr, appRef, injector, ngControl, _dsMask) {
        this.windowService = windowService;
        this._el = _el;
        this._datePickerService = _datePickerService;
        this._platform = _platform;
        this.cfr = cfr;
        this.appRef = appRef;
        this.injector = injector;
        this.ngControl = ngControl;
        this._dsMask = _dsMask;
        this.uniqueId = `ds-datepicker-input-${uid$5++}`;
        this.destroyed$ = new Subject();
        this._selectedDateChangeSubscription = Subscription.EMPTY;
        this.allowedKeys = [
            'F1',
            'F2',
            'F3',
            'F4',
            'F5',
            'F6',
            'F7',
            'F8',
            'F9',
            'F10',
            'F11',
            'F12',
            'Tab',
            'CapsLock',
            'Shift',
            'Control',
            'Meta',
            'Alt',
            'Enter',
            'Backspace',
            'Home',
            'End',
            'ArrowUp',
            'ArrowDown',
            'ArrowRight',
            'ArrowLeft',
            'Clear',
            'Delete',
            'Help',
            'PageUp',
            'PageDown',
            'Escape',
        ];
        this.allowedCharacters = ['/', '-', ' ', '.'];
        this.allowedCombinations = [
            { ctrlKey: true, key: 'a' },
            { metaKey: true, key: 'a' },
        ];
    }
    get config() {
        return this._config;
    }
    set config(value) {
        this._config = value;
        if (this.isMobile()) {
            if (!this.hostRefPortal) {
                this.hostRefPortal = this.createDomPortalOutlet(this.element);
                this.hostRefPortal.outletElement.parentElement.appendChild(this.loadHtml(value));
            }
            else {
                const existingChild = document.getElementById(this.uniqueId);
                this.hostRefPortal.outletElement.parentElement.replaceChild(existingChild, this.loadHtml(value));
            }
        }
    }
    set format(format) {
        this._format = format;
        if (this.selectedDate) {
            this.value = this.selectedDate.format(this.format) || '';
        }
    }
    get format() {
        return this._format;
    }
    set value(value) {
        if (value !== this.value) {
            this._value = value;
            this.element.value = value;
            if (this.ngControl) {
                this.ngControl.control.setValue(value, {
                    onlySelf: false,
                    emitEvent: true,
                    emitModelToViewChange: true,
                    emitViewToModelChange: true,
                });
            }
        }
    }
    get value() {
        return this.element.value;
    }
    get selectedDate() {
        return this._selectedDate;
    }
    set selectedDate(date) {
        this._selectedDate = date;
        this.value = date?.format(this.format) || '';
    }
    get mobileDateInput() {
        return this._mobileDateInput;
    }
    set mobileDateInput(element) {
        this._mobileDateInput = element;
        this._mobileDateInput.showPicker = HTMLInputElement.prototype['showPicker'];
        this._mobileDateInput.addEventListener('change', (e) => {
            const newDateValue = e.target.value;
            const formattedDate = _djs.default(newDateValue).format(this.format);
            this.value = formattedDate;
            this.changeHandler(e);
        });
        this._mobileDateInput.addEventListener('click', (event) => {
            /* iOS has a different behaviour on the date input click, so we need to stop the propagation.
              Also, iOS does not support showPicker()
            */
            if (this._platform.IOS) {
                event.stopPropagation();
            }
            else {
                this._mobileDateInput.showPicker();
            }
        });
        this.element.addEventListener('click', (event) => {
            event.stopPropagation();
            this._mobileDateInput.focus();
            this._mobileDateInput.click();
        });
    }
    get element() {
        return this._el.nativeElement;
    }
    ngOnInit() {
        extend(customParseFormat.default);
        if (!!this.value) {
            this.selectedDate = _djs.default(this.value);
        }
        if (this.dsDatepicker) {
            this.dsDatepicker.selectedDateChange
                .pipe(takeUntil(this.destroyed$))
                .subscribe((date) => {
                this.value = _djs.default(date).format(this.format);
                this.dsDatepicker.setSelectedDate(_djs.default(date));
                this._datePickerService.close();
                this.element.focus();
            });
        }
        this.element.onkeydown = this.onKeydownHandler.bind(this);
    }
    ngAfterViewInit() {
        if (this.dsDatepicker && this.value) {
            const d = _djs.default(this.value);
            d.format(this.format);
            this.dsDatepicker.setSelectedDate(d);
        }
        // Use of mobile native date picker
        if (this.isMobile()) {
            this.element.setAttribute('readOnly', 'true');
            if (!this._mobileDateInput) {
                this.mobileDateInput = document.getElementById(this.uniqueId);
            }
        }
    }
    ngAfterContentInit() {
        this.applyMask();
    }
    ngOnChanges(changes) {
        if (!changes.format?.firstChange) {
            this.applyMask();
        }
    }
    applyMask() {
        if (this._dsMask && this.format) {
            this._hasMask = true;
            switch (this.format) {
                case 'MM/DD':
                    this._dsMask.dsMask = InputMaskType.Custom;
                    this._dsMask.customMask = {
                        blocks: {
                            MM: {
                                mask: IMask.MaskedRange,
                                from: 1,
                                to: 12,
                                maxLength: 2,
                                placeholderChar: 'M',
                            },
                            DD: {
                                mask: IMask.MaskedRange,
                                from: 1,
                                to: 31,
                                maxLength: 2,
                                placeholderChar: 'D',
                            },
                        },
                        mask: 'MM/DD',
                    };
                    break;
                case 'MM/YY':
                    this._dsMask.dsMask = InputMaskType.Custom;
                    this._dsMask.customMask = {
                        blocks: {
                            MM: {
                                mask: IMask.MaskedRange,
                                from: 1,
                                to: 12,
                                maxLength: 2,
                                placeholderChar: 'M',
                            },
                            YY: {
                                mask: IMask.MaskedRange,
                                from: 0,
                                to: 99,
                                maxLength: 2,
                                placeholderChar: 'Y',
                            },
                        },
                        mask: 'MM/YY',
                    };
                    break;
                case 'MM/YYYY':
                    this._dsMask.dsMask = InputMaskType.Custom;
                    this._dsMask.customMask = {
                        blocks: {
                            MM: {
                                mask: IMask.MaskedRange,
                                from: 1,
                                to: 12,
                                maxLength: 2,
                                placeholderChar: 'M',
                            },
                            YYYY: {
                                mask: IMask.MaskedRange,
                                from: 1900,
                                to: 9999,
                                maxLength: 4,
                                placeholderChar: 'Y',
                            },
                        },
                        mask: 'MM/YYYY',
                    };
                    break;
                case 'MMYY':
                    this._dsMask.dsMask = InputMaskType.Custom;
                    this._dsMask.customMask = {
                        blocks: {
                            MM: {
                                mask: IMask.MaskedRange,
                                from: 1,
                                to: 12,
                                maxLength: 2,
                                placeholderChar: 'M',
                            },
                            YY: {
                                mask: IMask.MaskedRange,
                                from: 0,
                                to: 99,
                                maxLength: 2,
                                placeholderChar: 'Y',
                            },
                        },
                        mask: 'MMYY',
                    };
                    break;
                default:
                    this._dsMask.dsMask = InputMaskType.Date;
                    break;
            }
        }
    }
    blurHandler(e) {
        if (this.windowService.getBrowsers().isSafari) {
            this.changeHandler(e);
        }
    }
    changeHandler(e) {
        if (this.value.trim() === '') {
            this.setDatepicker(null);
            this.selectedDate = null;
            return;
        }
        const date = _djs.default(this.value, dateFormats[this.format], true);
        if (!date.isValid()) {
            this.setErrors({ invalidDateEntered: true });
            this.setDatepicker(null);
            return;
        }
        const day = new Day(date);
        const isDisabled = !!this.config && Day.isDisabled(this.config, day);
        if (isDisabled) {
            this.setErrors({ disabledDateSelected: true });
            return;
        }
        if (!this.isMobile()) {
            this.selectedDate = date;
        }
        this.setDatepicker(date);
    }
    createDomPortalOutlet(host) {
        return new DomPortalOutlet(host, this.cfr, this.appRef, this.injector);
    }
    loadHtml(config) {
        const invisibleDateInput = document.createElement('input');
        invisibleDateInput.setAttribute('id', this.uniqueId);
        invisibleDateInput.setAttribute('type', 'date');
        invisibleDateInput.setAttribute('value', '');
        invisibleDateInput.setAttribute('tabindex', '-1');
        // iOS does not show datepicker pop up if display is none or visibility hidden
        if (this._platform.IOS) {
            invisibleDateInput.style.opacity = '0';
            invisibleDateInput.style.width = '0px';
            invisibleDateInput.style.height = '0px';
            invisibleDateInput.style.position = 'fixed';
        }
        else {
            invisibleDateInput.style.display = 'none';
        }
        if (config.maxDate) {
            invisibleDateInput.setAttribute('max', _djs.default(config.maxDate).format('YYYY-MM-DD'));
        }
        if (config.minDate) {
            invisibleDateInput.setAttribute('min', _djs.default(config.minDate).format('YYYY-MM-DD'));
        }
        return invisibleDateInput;
    }
    onKeydownHandler(e) {
        if (!this.isAllowedKey(e.key)) {
            if (this.isNumber(e.key) ||
                this.isAllowedCharacter(e.key) ||
                this.isAllowedCombination(e)) {
                if (!this.isWithinFormatLength(e.key) && !this._hasMask) {
                    e.preventDefault();
                }
            }
            else {
                e.preventDefault();
            }
        }
    }
    isNumber(key) {
        return !isNaN(Number(key));
    }
    isAllowedKey(key) {
        return !!this.allowedKeys.find((ky) => ky === key);
    }
    isAllowedCharacter(key) {
        return !!this.allowedCharacters.find((ky) => ky === key);
    }
    isAllowedCombination(e) {
        return !!this.allowedCombinations.find((comb) => {
            const allKeysMatchedCombination = [];
            Object.keys(comb).forEach((key) => {
                allKeysMatchedCombination.push(e[key] === comb[key]);
            });
            return !allKeysMatchedCombination.includes(false, 0);
        });
    }
    isWithinFormatLength(key) {
        if (this.isAllowedCharacter(key) || this.isNumber(key)) {
            if ((this.value + key).length > this.format.length) {
                return false;
            }
        }
        return true;
    }
    focusHandler(e) {
        if (this.isMobile()) {
            this.element.click();
        }
    }
    isMobile() {
        return this._platform.ANDROID || this._platform.IOS;
    }
    ngOnDestroy() {
        this.destroyed$.next(void 0);
        this.destroyed$.complete();
        this._selectedDateChangeSubscription.unsubscribe();
        if (this.hostRefPortal) {
            this.hostRefPortal.detach();
            this.hostRefPortal.dispose();
        }
    }
    setErrors(errors) {
        if (this.ngControl) {
            this.ngControl.control.setErrors(errors);
        }
    }
    setDatepicker(value) {
        if (!this.isMobile() && this.dsDatepicker) {
            this.dsDatepicker.setSelectedDate(value);
        }
    }
}
DatepickerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerDirective, deps: [{ token: i1$1.WindowService }, { token: i0.ElementRef }, { token: DatepickerService }, { token: i3$2.Platform }, { token: i0.ComponentFactoryResolver }, { token: i0.ApplicationRef }, { token: i0.Injector }, { token: i3$3.NgControl, optional: true, self: true }, { token: InputMaskDirective, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Directive });
DatepickerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: DatepickerDirective, selector: "input[dsDatepicker]", inputs: { config: "config", dsDatepicker: "dsDatepicker", format: "format", value: "value" }, host: { listeners: { "focus": "focusHandler($event)", "change": "changeHandler($event)", "blur": "blurHandler($event)" } }, usesOnChanges: true, ngImport: i0 });
__decorate([
    Default('MM/DD/YYYY')
], DatepickerDirective.prototype, "format", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[dsDatepicker]',
                    host: {
                        '(focus)': 'focusHandler($event)',
                        '(change)': 'changeHandler($event)',
                        '(blur)': 'blurHandler($event)',
                    },
                }]
        }], ctorParameters: function () { return [{ type: i1$1.WindowService }, { type: i0.ElementRef }, { type: DatepickerService }, { type: i3$2.Platform }, { type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }, { type: i0.Injector }, { type: i3$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: InputMaskDirective, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }]; }, propDecorators: { config: [{
                type: Input
            }], dsDatepicker: [{
                type: Input
            }], format: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

const DS_INPUT_INVALID_TYPES = [
    'button',
    'checkbox',
    'file',
    'hidden',
    'image',
    'radio',
    'range',
    'reset',
    'submit',
];
let uid$4 = 0;
class InputBase$1 {
    constructor(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
        this._parentForm = _parentForm;
        this._parentFormGroup = _parentFormGroup;
        this.ngControl = ngControl;
    }
}
const InputMixinBase$1 = mixinErrorState(InputBase$1);
class InputFormDirective extends InputMixinBase$1 {
    constructor(_element, _platform, _autofillMonitor, ngControl, _parentForm, _parentFormGroup, datepickerLegacyDirective, _defaultErrorStateMatcher, ngZone, windowService) {
        super(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl);
        this._element = _element;
        this._platform = _platform;
        this._autofillMonitor = _autofillMonitor;
        this.ngControl = ngControl;
        this.datepickerLegacyDirective = datepickerLegacyDirective;
        this.ngZone = ngZone;
        this.windowService = windowService;
        this.destroyed$ = new Subject();
        this._disabled = false;
        this._readonly = false;
        this.inputValueAccessor = { value: '' };
        this.stateChanges = new Subject();
        this.hasNgControl = false;
        this.autofilled = false;
        this.focused = false;
        this.controlType = 'ds-input';
        this.neverEmptyInputTypes = [
            'date',
            'datetime',
            'datetime-local',
            'month',
            'time',
            'week',
        ].filter((t) => getSupportedInputTypes().has(t));
        this.passwordToggleButtonClick = new EventEmitter();
        this.previousNativeValue = this.value;
        this.inputValueAccessor = this._element.nativeElement;
        this.maxLength = Number(this._element.nativeElement.getAttribute('maxlength'));
        this.minLength = Number(this._element.nativeElement.getAttribute('minlength'));
        this.id = this.id;
        if (this._platform.IOS) {
            this.ngZone.runOutsideAngular(() => {
                this._element.nativeElement.addEventListener('keyup', (event) => {
                    const el = event.target;
                    if (!el.value && !el.selectionStart && !el.selectionEnd) {
                        el.setSelectionRange(1, 1);
                        el.setSelectionRange(0, 0);
                    }
                });
            });
        }
        this.hasNgControl = this.ngControl !== null ? true : false;
    }
    get showPasswordToggleButton() {
        return this._showPasswordToggleButton;
    }
    set showPasswordToggleButton(toggleButton) {
        this._showPasswordToggleButton = coerceBooleanProperty(toggleButton);
    }
    get uniqueInputId() {
        return `ds-form-input-id-${uid$4++}`;
    }
    get empty() {
        return (!this.isNeverEmpty() &&
            !this._element.nativeElement.value &&
            !this.isBadInput() &&
            !this.autofilled);
    }
    set value(value) {
        if (value !== this.value) {
            this.inputValueAccessor.value = value;
            this.stateChanges.next();
        }
    }
    get value() {
        return this.inputValueAccessor.value;
    }
    set id(id) {
        this._id = id || this.uniqueInputId;
    }
    get id() {
        return this._id;
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    get disabled() {
        if (this.ngControl && this.ngControl.disabled !== null) {
            return this.ngControl.disabled;
        }
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this.focused) {
            this.focused = false;
            this.stateChanges.next();
        }
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value || 'text';
        this.validateType();
        this._isDateType = this._type === 'date';
        if (this.datepickerLegacyDirective && this._type === 'date') {
            this._element.nativeElement.type = 'text';
            this._type = 'text';
        }
        else if (this.type === 'date' && !this.datepickerLegacyDirective) {
            this._element.nativeElement.type = 'text';
            this._type = 'text';
        }
        else if (!this.isTextarea() && getSupportedInputTypes().has(this._type)) {
            this._element.nativeElement.type = this._type;
        }
    }
    get readonly() {
        return this._readonly;
    }
    set readonly(value) {
        this._readonly = coerceBooleanProperty(value);
    }
    get characterCountMessage() {
        return this._characterCountMessage;
    }
    set characterCountMessage(message) {
        this._characterCountMessage = message;
        this.stateChanges.next();
    }
    get customState() {
        return this._customState;
    }
    set customState(state) {
        if (state) {
            this._customState = state;
            this.stateChanges.next();
            return;
        }
        this._customState = null;
        this.stateChanges.next();
    }
    get isDateType() {
        return this._isDateType;
    }
    get element() {
        return this._element.nativeElement;
    }
    ngOnInit() {
        if (this._platform.isBrowser) {
            this._autofillMonitor
                .monitor(this._element.nativeElement)
                .pipe(takeUntil(this.destroyed$))
                .subscribe((event) => {
                this.autofilled = event.isAutofilled;
                this.stateChanges.next();
            });
        }
    }
    ngOnChanges() {
        this.stateChanges.next();
    }
    ngOnDestroy() {
        this.destroyed$.next(void 0);
        this.destroyed$.complete();
        this.stateChanges.complete();
        if (this._platform.isBrowser) {
            this._autofillMonitor.stopMonitoring(this._element.nativeElement);
        }
    }
    ngDoCheck() {
        if (this.ngControl) {
            this.updateErrorState();
        }
        this.dirtyCheckNativeValue();
    }
    onInput() {
        // Noop function
    }
    isBadInput() {
        const validity = this._element.nativeElement.validity;
        return validity && validity.badInput;
    }
    isNeverEmpty() {
        return this.neverEmptyInputTypes.indexOf(this.type) > -1;
    }
    isTextarea() {
        return this._element.nativeElement.nodeName.toLowerCase() === 'textarea';
    }
    validateType() {
        if (DS_INPUT_INVALID_TYPES.indexOf(this.type) > -1) {
            throw new Error(`Input type "${this.type}" is not supported by dsInput`);
        }
    }
    focus() {
        this._element.nativeElement.focus();
    }
    focusChanged(isFocused) {
        if (isFocused !== this.focused && (!this.readonly || !isFocused)) {
            this.focused = isFocused;
            this.stateChanges.next();
        }
    }
    dirtyCheckNativeValue() {
        const newValue = this._element.nativeElement.value;
        if (this.previousNativeValue !== newValue) {
            this.previousNativeValue = newValue;
            this.stateChanges.next();
        }
    }
    onContainerClick(event) {
        if (!this.focused) {
            this.focus();
        }
    }
    getNodeTypeAndInputType() {
        return {
            nodeType: this._element.nativeElement.nodeName.toLowerCase(),
            type: this.type,
        };
    }
    isTouched() {
        const control = this.ngControl;
        return !!(control && control.touched);
    }
    _hideInput() {
        return (!this.focused &&
            this.value.length === 0 &&
            this.getNodeTypeAndInputType().nodeType !== 'textarea' &&
            this.getNodeTypeAndInputType().nodeType !== 'select');
    }
    isMobile() {
        return this._platform.ANDROID || this._platform.IOS;
    }
    // Used to apply fix for select element indentation bug which was fixed in
    // Firefox version 107
    isFirefox106OrLess() {
        if (this._platform.FIREFOX) {
            if (this.windowService.isBrowser()) {
                let versionOffset = window.navigator.userAgent.indexOf('Firefox/');
                let version = parseInt(window.navigator.userAgent.substring(versionOffset + 8));
                return version <= 106;
            }
        }
        return false;
    }
    onPasswordToggleButtonClick(event) {
        this.passwordToggleButtonClick.emit(event);
    }
}
InputFormDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputFormDirective, deps: [{ token: i0.ElementRef }, { token: i3$2.Platform }, { token: i2$2.AutofillMonitor }, { token: i3$3.NgControl, optional: true, self: true }, { token: i3$3.NgForm, optional: true }, { token: i3$3.FormGroupDirective, optional: true }, { token: DatepickerDirective, optional: true, self: true }, { token: ErrorStateMatcher }, { token: i0.NgZone }, { token: i1$1.WindowService }], target: i0.ɵɵFactoryTarget.Directive });
InputFormDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: InputFormDirective, selector: "input[dsInput], textarea[dsInput], select[dsNativeControl]", inputs: { maxLength: "maxLength", a11yDescription: "a11yDescription", suffixTitle: "suffixTitle", errorStateMatcher: "errorStateMatcher", showPasswordToggleButton: "showPasswordToggleButton", placeholder: "placeholder", value: "value", id: "id", required: "required", disabled: "disabled", type: "type", readonly: "readonly", characterCountMessage: "characterCountMessage", customState: "customState" }, outputs: { passwordToggleButtonClick: "passwordToggleButtonClick" }, host: { listeners: { "blur": "focusChanged(false)", "focus": "focusChanged(true)", "input": "onInput()" }, properties: { "class.-disabled": "disabled", "class.-hidden": "_hideInput()", "class.-select": "getNodeTypeAndInputType().nodeType === \"select\"", "class.-firefox-polyfill": "isFirefox106OrLess()", "attr.id": "id", "attr.placeholder": "placeholder", "disabled": "disabled", "required": "required", "attr.readonly": "readonly || null", "attr.aria-describedby": "ariaDescribedby || null", "attr.aria-invalid": "errorState", "attr.aria-label": "ariaLabel || null", "attr.aria-required": "required" }, classAttribute: "ds-input w-100 text-body mb-0 pt-16 ds-bgcolor-transparent" }, providers: [{ provide: FormFieldControl, useExisting: InputFormDirective }], exportAs: ["dsInput"], usesInheritance: true, usesOnChanges: true, ngImport: i0 });
__decorate([
    Default(true)
], InputFormDirective.prototype, "showPasswordToggleButton", null);
__decorate([
    Default(null)
], InputFormDirective.prototype, "customState", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputFormDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: `input[dsInput], textarea[dsInput], select[dsNativeControl]`,
                    exportAs: 'dsInput',
                    host: {
                        class: 'ds-input w-100 text-body mb-0 pt-16 ds-bgcolor-transparent',
                        '[class.-disabled]': 'disabled',
                        '[class.-hidden]': '_hideInput()',
                        '[class.-select]': 'getNodeTypeAndInputType().nodeType === "select"',
                        '[class.-firefox-polyfill]': 'isFirefox106OrLess()',
                        '[attr.id]': 'id',
                        '[attr.placeholder]': 'placeholder',
                        '[disabled]': 'disabled',
                        '[required]': 'required',
                        '[attr.readonly]': 'readonly || null',
                        '[attr.aria-describedby]': 'ariaDescribedby || null',
                        '[attr.aria-invalid]': 'errorState',
                        '[attr.aria-label]': 'ariaLabel || null',
                        '[attr.aria-required]': 'required',
                        '(blur)': 'focusChanged(false)',
                        '(focus)': 'focusChanged(true)',
                        '(input)': 'onInput()', // NOOP listener for ng change detection
                    },
                    providers: [{ provide: FormFieldControl, useExisting: InputFormDirective }],
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i3$2.Platform }, { type: i2$2.AutofillMonitor }, { type: i3$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i3$3.NgForm, decorators: [{
                    type: Optional
                }] }, { type: i3$3.FormGroupDirective, decorators: [{
                    type: Optional
                }] }, { type: DatepickerDirective, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: ErrorStateMatcher }, { type: i0.NgZone }, { type: i1$1.WindowService }]; }, propDecorators: { maxLength: [{
                type: Input
            }], a11yDescription: [{
                type: Input
            }], suffixTitle: [{
                type: Input
            }], errorStateMatcher: [{
                type: Input
            }], showPasswordToggleButton: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], value: [{
                type: Input
            }], id: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], type: [{
                type: Input
            }], readonly: [{
                type: Input
            }], characterCountMessage: [{
                type: Input
            }], customState: [{
                type: Input
            }], passwordToggleButtonClick: [{
                type: Output
            }] } });

class SuccessComponent {
    constructor() { }
    ngOnInit() { }
}
SuccessComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SuccessComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SuccessComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: SuccessComponent, selector: "ds-success", inputs: { successMessage: "successMessage" }, host: { properties: { "class.ds-error": "true", "class.d-flex": "true", "class.align-items-center": "true", "class.mt-4": "true" } }, ngImport: i0, template: "<ds-icon\n  [name]=\"'check-circle'\"\n  [color]=\"'success'\"\n></ds-icon>\n<span\n  class=\"text-body-sm mb-0 text-italic ml-4\"\n  [brClass]=\"[['text-semi', '', '', 'text-semi']]\"\n  role=\"alert\"\n  [innerHTML]=\"successMessage\"\n></span>\n", components: [{ type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i5.BrandClassDirective, selector: "[brClass]", inputs: ["brClass"] }] });
__decorate([
    Required()
], SuccessComponent.prototype, "successMessage", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SuccessComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-success', host: {
                        '[class.ds-error]': 'true',
                        '[class.d-flex]': 'true',
                        '[class.align-items-center]': 'true',
                        '[class.mt-4]': 'true',
                    }, template: "<ds-icon\n  [name]=\"'check-circle'\"\n  [color]=\"'success'\"\n></ds-icon>\n<span\n  class=\"text-body-sm mb-0 text-italic ml-4\"\n  [brClass]=\"[['text-semi', '', '', 'text-semi']]\"\n  role=\"alert\"\n  [innerHTML]=\"successMessage\"\n></span>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { successMessage: [{
                type: Input
            }] } });

class ErrorComponent {
    constructor() { }
    ngOnInit() { }
}
ErrorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ErrorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: ErrorComponent, selector: "ds-error", inputs: { errorMessage: "errorMessage" }, host: { properties: { "class.ds-error": "true", "class.d-flex": "true", "class.align-items-center": "true", "class.mt-4": "true" } }, ngImport: i0, template: "<ds-icon\n  [name]=\"'error-outlined'\"\n  [color]=\"'error'\"\n></ds-icon>\n<span\n  class=\"text-body-sm mb-0 text-italic ml-4\"\n  [brClass]=\"[['text-semi', '', '', 'text-semi']]\"\n  role=\"alert\"\n  [innerHTML]=\"errorMessage\"\n></span>\n", components: [{ type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i5.BrandClassDirective, selector: "[brClass]", inputs: ["brClass"] }] });
__decorate([
    Required()
], ErrorComponent.prototype, "errorMessage", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-error', host: {
                        '[class.ds-error]': 'true',
                        '[class.d-flex]': 'true',
                        '[class.align-items-center]': 'true',
                        '[class.mt-4]': 'true',
                    }, template: "<ds-icon\n  [name]=\"'error-outlined'\"\n  [color]=\"'error'\"\n></ds-icon>\n<span\n  class=\"text-body-sm mb-0 text-italic ml-4\"\n  [brClass]=\"[['text-semi', '', '', 'text-semi']]\"\n  role=\"alert\"\n  [innerHTML]=\"errorMessage\"\n></span>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { errorMessage: [{
                type: Input
            }] } });

class PasswordHintItemComponent {
    constructor(_vcr, cdkCore) {
        this._vcr = _vcr;
        this.cdkCore = cdkCore;
        this._valid = null;
    }
    get valid() {
        return this._valid;
    }
    set valid(valid) {
        this._valid = valid !== undefined ? valid : null;
        if (this.type !== 'fnKey') {
            if (this.valid && this.valid !== null) {
                this.icon = 'checkmark';
                return;
            }
            if (!this.valid && this.valid !== null) {
                this.icon = 'error-outlined';
                return;
            }
        }
    }
    get icon() {
        return this._icon;
    }
    set icon(icon) {
        if (this.type === 'fnKey' || this.valid !== null) {
            this._icon = icon;
            return;
        }
    }
    get iconColor() {
        if (this.type === 'fnKey') {
            return '';
        }
        return this.valid && this.valid !== null
            ? 'success'
            : !this.valid && this.valid !== null
                ? 'error'
                : '';
    }
    get brand() {
        return this.cdkCore.brand;
    }
    get hintPortal() {
        return new TemplatePortal(this._hintRef, this._vcr);
    }
    ngOnInit() { }
    showIcon() {
        return this.valid !== null || this.type === 'fnKey';
    }
}
PasswordHintItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PasswordHintItemComponent, deps: [{ token: i0.ViewContainerRef }, { token: i2.CDKCoreService }], target: i0.ɵɵFactoryTarget.Component });
PasswordHintItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: PasswordHintItemComponent, selector: "ds-password-hint-item", inputs: { type: "type", isVisible: "isVisible", valid: "valid", message: "message", icon: "icon" }, host: { properties: { "class.-functionKey": "type === \"fnKey\"" } }, viewQueries: [{ propertyName: "_hintRef", first: true, predicate: TemplateRef, descendants: true, static: true }], ngImport: i0, template: "<ng-template>\n  <div\n    class=\"ds-passwordHints__hint px-8 pt-8 d-flex\"\n    [ngClass]=\"{\n      '-functionKey mt-16': type === 'fnKey',\n      'ds-bgcolor-concrete':\n        (brand === 'rogers' || brand === 'r4b') && type === 'fnKey',\n      'ds-bgcolor-fog':\n        brand !== 'rogers' && brand !== 'r4b' && type === 'fnKey',\n      'py-4': (brand === 'rogers' || brand === 'r4b') && type === 'fnKey',\n      'pb-8': brand !== 'rogers' && brand !== 'r4b' && type === 'fnKey'\n    }\"\n    *ngIf=\"isVisible\"\n    [@enterAnimation]\n  >\n    <p\n      class=\"text-body-sm mb-0 d-inline-flex\"\n      [ngClass]=\"{\n        'text-semi':\n          (type === 'fnKey' || (!valid && valid !== null) || valid) &&\n          (brand === 'rogers' || brand === 'r4b')\n      }\"\n    >\n      <span class=\"ds-passwordHints__icon d-inline-block mr-8\">\n        <ds-icon\n          [name]=\"icon\"\n          [color]=\"iconColor\"\n          *ngIf=\"showIcon()\"\n          [@enterAnimation]\n        ></ds-icon\n      ></span>\n      {{ message }}\n    </p>\n  </div></ng-template\n>\n", components: [{ type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], animations: [
        trigger('enterAnimation', [
            transition(':enter', [
                style({ opacity: 0, height: 0, overflow: 'hidden' }),
                animate('200ms', style({ opacity: 1, height: '*', overflow: 'hidden' })),
            ]),
            transition(':leave', [
                style({ opacity: 1, overflow: 'hidden' }),
                animate('200ms', style({ opacity: 0, height: 0, overflow: 'hidden' })),
            ]),
        ]),
    ] });
__decorate([
    Default('message')
], PasswordHintItemComponent.prototype, "type", void 0);
__decorate([
    Default(true)
], PasswordHintItemComponent.prototype, "isVisible", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PasswordHintItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-password-hint-item', animations: [
                        trigger('enterAnimation', [
                            transition(':enter', [
                                style({ opacity: 0, height: 0, overflow: 'hidden' }),
                                animate('200ms', style({ opacity: 1, height: '*', overflow: 'hidden' })),
                            ]),
                            transition(':leave', [
                                style({ opacity: 1, overflow: 'hidden' }),
                                animate('200ms', style({ opacity: 0, height: 0, overflow: 'hidden' })),
                            ]),
                        ]),
                    ], host: {
                        '[class.-functionKey]': 'type === "fnKey"',
                    }, template: "<ng-template>\n  <div\n    class=\"ds-passwordHints__hint px-8 pt-8 d-flex\"\n    [ngClass]=\"{\n      '-functionKey mt-16': type === 'fnKey',\n      'ds-bgcolor-concrete':\n        (brand === 'rogers' || brand === 'r4b') && type === 'fnKey',\n      'ds-bgcolor-fog':\n        brand !== 'rogers' && brand !== 'r4b' && type === 'fnKey',\n      'py-4': (brand === 'rogers' || brand === 'r4b') && type === 'fnKey',\n      'pb-8': brand !== 'rogers' && brand !== 'r4b' && type === 'fnKey'\n    }\"\n    *ngIf=\"isVisible\"\n    [@enterAnimation]\n  >\n    <p\n      class=\"text-body-sm mb-0 d-inline-flex\"\n      [ngClass]=\"{\n        'text-semi':\n          (type === 'fnKey' || (!valid && valid !== null) || valid) &&\n          (brand === 'rogers' || brand === 'r4b')\n      }\"\n    >\n      <span class=\"ds-passwordHints__icon d-inline-block mr-8\">\n        <ds-icon\n          [name]=\"icon\"\n          [color]=\"iconColor\"\n          *ngIf=\"showIcon()\"\n          [@enterAnimation]\n        ></ds-icon\n      ></span>\n      {{ message }}\n    </p>\n  </div></ng-template\n>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i2.CDKCoreService }]; }, propDecorators: { type: [{
                type: Input
            }], isVisible: [{
                type: Input
            }], valid: [{
                type: Input
            }], message: [{
                type: Input
            }], icon: [{
                type: Input
            }], _hintRef: [{
                type: ViewChild,
                args: [TemplateRef, { static: true }]
            }] } });

class PasswordHintsComponent {
    constructor() {
        this.portals = [];
    }
    ngOnInit() { }
    ngAfterContentInit() {
        const sorted = this.passwordHintItems
            .toArray()
            .sort(this._makeFunctionTypeLast);
        this.passwordHintItems.reset(sorted);
        this.portals = this.passwordHintItems.map((hint) => hint.hintPortal);
    }
    _makeFunctionTypeLast(a, b) {
        if (a.type < b.type) {
            return 1;
        }
        if (a.type > b.type) {
            return -1;
        }
        return 0;
    }
}
PasswordHintsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PasswordHintsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PasswordHintsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: PasswordHintsComponent, selector: "ds-password-hints", queries: [{ propertyName: "passwordHintItems", predicate: PasswordHintItemComponent }], ngImport: i0, template: "<div\n  class=\"ds-passwordHints ds-borders ds-bgcolor-misty pt-8\"\n  [brClass]=\"[\n    [\n      'ds-brcolor-concrete',\n      'ds-brcolor-fog',\n      'ds-brcolor-fog',\n      'ds-brcolor-concrete'\n    ]\n  ]\"\n>\n  <ng-container *ngFor=\"let portal of portals\">\n    <ng-template [cdkPortalOutlet]=\"portal\"></ng-template>\n  </ng-container>\n</div>\n", directives: [{ type: i5.BrandClassDirective, selector: "[brClass]", inputs: ["brClass"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.CdkPortalOutlet, selector: "[cdkPortalOutlet]", inputs: ["cdkPortalOutlet"], outputs: ["attached"], exportAs: ["cdkPortalOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PasswordHintsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-password-hints', template: "<div\n  class=\"ds-passwordHints ds-borders ds-bgcolor-misty pt-8\"\n  [brClass]=\"[\n    [\n      'ds-brcolor-concrete',\n      'ds-brcolor-fog',\n      'ds-brcolor-fog',\n      'ds-brcolor-concrete'\n    ]\n  ]\"\n>\n  <ng-container *ngFor=\"let portal of portals\">\n    <ng-template [cdkPortalOutlet]=\"portal\"></ng-template>\n  </ng-container>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { passwordHintItems: [{
                type: ContentChildren,
                args: [PasswordHintItemComponent]
            }] } });

class SuffixDirective {
    constructor() { }
}
SuffixDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SuffixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SuffixDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: SuffixDirective, selector: "[dsSuffix]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dsSuffix]',
                }]
        }], ctorParameters: function () { return []; } });

const floatInStyles = {
    fontSize: '12px',
    top: 0,
    paddingTop: '7px',
    zIndex: 'auto',
    paddingBottom: 0,
};
const floatOutStyles = {
    fontSize: '16px',
    top: '14px',
    paddingTop: '0',
};
let nextId = 0;
class FormFieldComponent {
    constructor(_el, _changeDetectorRef, _ngZone, _datePickerService, _vcr, focusMonitor, window, cdkCore) {
        this._el = _el;
        this._changeDetectorRef = _changeDetectorRef;
        this._ngZone = _ngZone;
        this._datePickerService = _datePickerService;
        this._vcr = _vcr;
        this.focusMonitor = focusMonitor;
        this.window = window;
        this.cdkCore = cdkCore;
        this.id = `formfield-${nextId++}`;
        this.messagesId = this.id + '-messages';
        this.a11yDescriptionId = this.id + '-a11yDescription';
        this.destroyed$ = new Subject();
        this.datepickerClick$ = new Subject();
        this.datepickerButtonVisibility = false;
        this.hideLabelVisually = false;
        this.datePickerDateChangeSubscription = Subscription.EMPTY;
    }
    get datepickerComponentInstance() {
        return this._datepickerComponentInstance;
    }
    set datepickerComponentInstance(value) {
        this._datepickerComponentInstance = value;
        this.datepickerButtonVisibility = !!value;
    }
    get _control() {
        return (this._explicitFormFieldControl ||
            this.controlNonStatic ||
            this.controlStatic);
    }
    set _control(value) {
        this._explicitFormFieldControl = value;
    }
    get element() {
        return this._el;
    }
    get brand() {
        return this.cdkCore.brand;
    }
    get notDisabledNotErrorClass() {
        return this.brand !== 'fido'
            ? 'ds-brcolor-slate ds-bgcolor-white'
            : 'ds-brcolor-black ds-color-black';
    }
    ngOnInit() { }
    ngAfterContentInit() {
        this._validateControlChild();
        const control = this._control;
        this.inputType = this._control['type'];
        if (control.controlType) {
            this._el.nativeElement.classList.add(`ds-formField__type${control.controlType}`);
        }
        // Subscribe to changes in the child control state in order to update the form field UI.
        control.stateChanges
            .pipe(startWith(null))
            .pipe(takeUntil(this.destroyed$))
            .subscribe(() => {
            this._changeDetectorRef.markForCheck();
        });
        // Run change detection if the value changes.
        if (control.ngControl && control.ngControl.valueChanges) {
            control.ngControl.valueChanges
                .pipe(takeUntil(this.destroyed$))
                .subscribe(() => {
                this._changeDetectorRef.markForCheck();
            });
        }
        // Set selected option from autocomplete as input value
        if (this.autoComplete)
            this.selectAutoCompleteOption();
    }
    ngAfterViewInit() {
        this._validateControlChild();
        this._changeDetectorRef.detectChanges();
        this.focusMonitor
            .monitor(this.formFieldWrapper, true)
            .pipe(takeUntil(this.destroyed$))
            .subscribe((origin) => {
            this._ngZone.run(() => {
                this.inputAriaLabel();
                // To close autocomplete options on focusout
                if (this.autoComplete && this.window.isBrowser())
                    this.closeAutoCompleteOnFocusOut(origin);
            });
        });
        // Set focus to first autocomplete option on down arrow key press
        if (this.autoComplete && this.window.isBrowser()) {
            this.focusAutoComplete();
            fromEvent(document, 'click')
                .pipe(takeUntil(this.destroyed$))
                .subscribe((event) => {
                if (this.autoComplete?.options.length > 0 &&
                    !this.element.nativeElement.contains(event.target)) {
                    this.autoComplete?.options.reset([]);
                    this._changeDetectorRef.markForCheck();
                }
            });
        }
    }
    inputAriaLabel() {
        const a11yDescription = this._control.a11yDescription
            ? this._control.a11yDescription + ' '
            : '';
        this.dsInput.ariaLabel =
            this._el.nativeElement.getElementsByClassName('ds-formField_label')[0]
                .textContent +
                ' ' +
                a11yDescription +
                this._el.nativeElement.getElementsByClassName('ds-formFields__messages')[0].textContent +
                ' ';
    }
    selectAutoCompleteOption() {
        this.autoComplete.selectedValue
            .pipe(takeUntil(this.destroyed$))
            .subscribe((option) => {
            if (!!option) {
                this.dsInput.value = option ? option.value : '';
                this._changeDetectorRef.markForCheck();
            }
        });
    }
    closeAutoCompleteOnFocusOut(origin) {
        if (['keyboard', 'program', 'click', 'mouse'].indexOf(origin) === -1) {
            if (!this.isMouseOver) {
                setTimeout(() => {
                    if (this.autoComplete &&
                        this.autoComplete.options.length &&
                        !this._control.focused) {
                        this.autoComplete.options.reset([]);
                        this._changeDetectorRef.markForCheck();
                    }
                }, 100);
            }
        }
    }
    handleClick(e) {
        if ((e['keyCode'] === ESCAPE ||
            e['code'] === '27' ||
            e['key'] === 'escape') &&
            this.autoComplete &&
            this.autoComplete.options.length) {
            this.autoComplete.options.reset([]);
            this._changeDetectorRef.markForCheck();
        }
    }
    focusAutoComplete() {
        this.inputContainer.nativeElement.addEventListener('keyup', (event) => {
            if (this.autoComplete && this.autoComplete.options.length) {
                const code = event.keyCode || event.which;
                switch (code) {
                    case 40:
                        this.autoComplete.focusOption(0);
                        break;
                    default:
                        break;
                }
                this._changeDetectorRef.markForCheck();
            }
        });
    }
    ngOnDestroy() {
        this.datepickerClick$.complete();
        this.destroyed$.next(void 0);
        this.destroyed$.complete();
        this.datePickerDateChangeSubscription.unsubscribe();
        this.focusMonitor.stopMonitoring(this._el);
        this.focusMonitor.stopMonitoring(this.formFieldWrapper);
    }
    isEmpty(element) {
        return (element.innerHTML.trim().length === 0 && element.childNodes.length === 0);
    }
    /** Determines whether a class from the NgControl should be forwarded to the host element. */
    _shouldForward(prop) {
        const ngControl = this._control ? this._control.ngControl : null;
        return ngControl && ngControl[prop];
    }
    /** */
    togglePasswordHideAndShow(event) {
        this._control.onPasswordToggleButtonClick(event);
        if (this._control['type'] === 'password') {
            this._control['type'] = 'text';
            return;
        }
        this._control['type'] = 'password';
    }
    showDatepickerButton() {
        this.datepickerButtonVisibility = true;
        this._changeDetectorRef.detectChanges();
    }
    hideDatepickerButton() {
        this.datepickerButtonVisibility = false;
        this._changeDetectorRef.detectChanges();
    }
    openDatePicker(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.datepickerComponentInstance) {
            if (this.dsInput.isMobile()) {
                this.dsInput.element.click();
            }
            else {
                const dpid = new DatepickerInjectableData({
                    inputHostElement: this.dsInput.element,
                    datepickerHostButton: e.currentTarget,
                });
                this.datepickerComponentInstance.eventSource =
                    e instanceof KeyboardEvent ? 'keyboard' : 'mouse';
                const overlayRef = this._datePickerService.open({
                    ref: this.dptemplateRef,
                    componentClass: null,
                }, this._vcr, dpid, this.formFieldWrapper, [[DatepickerComponent, this.datepickerComponentInstance]]);
                return overlayRef;
            }
        }
        else {
            if (this.dsInput.isMobile()) {
                this.dsInput.element.click();
            }
            else {
                this.datepickerClick$.next(e);
            }
        }
    }
    isInitialTypePassword() {
        return this.inputType === 'password';
    }
    getRemainingCharacterCount() {
        return this._control.maxLength - this._control.value.length;
    }
    getSuccessStatus() {
        if (this.canShowSuccessIconForInput()) {
            return (!this.getErrorState() &&
                this.getErrorState() !== null &&
                (this._control.isTouched() || !this._control.empty));
        }
        return null;
    }
    canShowSuccessIconForInput() {
        return this._control.getNodeTypeAndInputType().nodeType !== 'select';
    }
    getSuffixType() {
        if (this.isInitialTypePassword() &&
            this._control.showPasswordToggleButton) {
            return 'password';
        }
        if (this.dsInput.isDateType) {
            return 'date';
        }
        if (this.inputSuffix) {
            return 'custom';
        }
        if (this._control.getNodeTypeAndInputType().nodeType === 'select') {
            return 'select';
        }
    }
    getErrorState() {
        if (this._control.hasNgControl) {
            return this._control.errorState;
        }
        if (this._control.customState === null) {
            return null;
        }
        return this._control.customState === 'error' ? true : false;
    }
    /** Throws an error if the form field's control is missing. */
    _validateControlChild() {
        if (!this._control) {
            throw Error('ds-form-field must contain a FormFieldControl.');
        }
        if (!this.inputLabel) {
            throw Error('ds-form-field must contain a InputLabelComponent.');
        }
    }
}
FormFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormFieldComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.NgZone }, { token: DatepickerService }, { token: i0.ViewContainerRef }, { token: i1.FocusMonitor }, { token: i1$1.WindowService }, { token: i2.CDKCoreService }], target: i0.ɵɵFactoryTarget.Component });
FormFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: FormFieldComponent, selector: "ds-form-field", inputs: { hideLabelVisually: "hideLabelVisually" }, host: { listeners: { "mouseover": "isMouseOver = true", "mouseout": "isMouseOver = false", "keydown": "handleClick($event)" }, properties: { "class.d-block": "true", "class.position-relative": "true", "class.-float": "_control.focused || !_control.empty", "class.-error": "getErrorState()", "class.-disabled": "_control.disabled", "class.ds-formField__autoFilled": "_control.autofilled", "class.ng-untouched": "_shouldForward(\"untouched\")", "class.ng-touched": "_shouldForward(\"touched\")", "class.ng-pristine": "_shouldForward(\"pristine\")", "class.ng-dirty": "_shouldForward(\"dirty\")", "class.ng-valid": "_shouldForward(\"valid\")", "class.ng-invalid": "_shouldForward(\"invalid\")", "class.ng-pending": "_shouldForward(\"pending\")", "class.-hasSuffix": "getSuffixType()", "class.dropdown-open": "autoComplete?.options.length > 0" }, classAttribute: "ds-formField" }, queries: [{ propertyName: "autoComplete", first: true, predicate: AutoCompleteComponent, descendants: true }, { propertyName: "inputSuffix", first: true, predicate: SuffixDirective, descendants: true, static: true }, { propertyName: "inputLabel", first: true, predicate: InputLabelComponent, descendants: true, static: true }, { propertyName: "controlNonStatic", first: true, predicate: FormFieldControl, descendants: true, static: true }, { propertyName: "controlStatic", first: true, predicate: FormFieldControl, descendants: true, static: true }, { propertyName: "passwordHints", first: true, predicate: PasswordHintsComponent, descendants: true, static: true }, { propertyName: "dsInput", first: true, predicate: InputFormDirective, descendants: true, static: true }, { propertyName: "datepickerComponentInstance", first: true, predicate: DatepickerComponent, descendants: true, static: true }, { propertyName: "errorMessages", predicate: ErrorComponent }, { propertyName: "successMessages", predicate: SuccessComponent }, { propertyName: "hints", predicate: HintComponent }], viewQueries: [{ propertyName: "dptemplateRef", first: true, predicate: ["datepickerTemplateRef"], descendants: true, static: true }, { propertyName: "formFieldWrapper", first: true, predicate: ["formFieldWrapper"], descendants: true, static: true }, { propertyName: "inputContainer", first: true, predicate: ["inputContainer"], descendants: true, static: true }], ngImport: i0, template: "<div\n  class=\"ds-formField__wrapper\"\n  #formFieldWrapper\n>\n  <!-- input container, includes input, label and suffix if any. -->\n  <div\n    class=\"ds-formField__inputContainer d-flex position-relative ds-bgcolor-white ds-borders\"\n    [ngClass]=\"{\n      'ds-brcolor-black ds-color-black':\n        !_control.disabled && !getErrorState() && brand === 'fido',\n      'ds-brcolor-slate':\n        !_control.disabled && !getErrorState() && brand !== 'fido',\n      '-active': _control.focused,\n      'bx-2 by-2': _control.focused || (autoComplete && autoComplete.hasFocus),\n      'ds-bgcolor-errorField ds-brcolor-error': getErrorState(),\n      '-textarea h-100':\n        _control.getNodeTypeAndInputType().nodeType === 'textarea',\n      '-select': _control.getNodeTypeAndInputType().nodeType === 'select',\n      'ds-bgcolor-misty ds-brcolor-concrete ds-color-concrete':\n        _control.disabled,\n      '-hideLabelVisually': hideLabelVisually\n    }\"\n    [brClass]=\"[['ds-corners', '', 'ds-corners', 'ds-corners']]\"\n    #inputContainer\n    (click)=\"_control.onContainerClick && _control.onContainerClick($event)\"\n  >\n    <span\n      class=\"ds-formField__labelWrapper position-absolute mb-0\"\n      [ngClass]=\"{ 'sr-only': hideLabelVisually }\"\n      [@floatAnimation]=\"_control.focused || !_control.empty\"\n    >\n      <label\n        [for]=\"_control.id\"\n        class=\"ds-formField_label\"\n        #inputLabel\n      >\n        <ng-content select=\"ds-input-label\"></ng-content>\n      </label>\n    </span>\n\n    <ng-content></ng-content>\n\n    <div\n      class=\"ds-formField__suffix justify-content-center align-items-center\"\n      [ngSwitch]=\"getSuffixType()\"\n      [ngClass]=\"{\n        'ds-formField__suffixSelect position-absolute t-0 ds-no-pointers':\n          _control.getNodeTypeAndInputType().nodeType === 'select'\n      }\"\n    >\n      <!-- Datepicker  -->\n      <ng-container *ngSwitchCase=\"'date'\">\n        <button\n          *ngIf=\"datepickerButtonVisibility\"\n          ds-button\n          type=\"button\"\n          variant=\"icon\"\n          (click)=\"openDatePicker($event)\"\n          (keydown.space)=\"openDatePicker($event)\"\n          [attr.aria-label]=\"dsInput.suffixTitle\"\n          [transparent]=\"true\"\n          [disabled]=\"_control.disabled\"\n        >\n          <ds-icon [name]=\"'calendar'\"></ds-icon>\n        </button>\n      </ng-container>\n\n      <!--  When input type is password -->\n      <button\n        ds-button\n        variant=\"icon\"\n        type=\"button\"\n        (click)=\"togglePasswordHideAndShow($event)\"\n        [attr.aria-pressed]=\"\n          _control.getNodeTypeAndInputType()['type'] === 'password'\n            ? 'false'\n            : 'true'\n        \"\n        *ngSwitchCase=\"'password'\"\n        [attr.aria-label]=\"dsInput.suffixTitle\"\n      >\n        <ds-icon\n          [name]=\"\n            _control.getNodeTypeAndInputType()['type'] === 'password'\n              ? 'hide'\n              : 'show'\n          \"\n        ></ds-icon>\n      </button>\n\n      <!-- When select box -->\n      <ds-icon\n        *ngSwitchCase=\"'select'\"\n        [name]=\"'chevron-down'\"\n      ></ds-icon>\n\n      <!-- Custom suffix -->\n      <ng-content\n        select=\"[dsSuffix]\"\n        *ngSwitchCase=\"'custom'\"\n      ></ng-content>\n    </div>\n  </div>\n  <!--  input container ends -->\n\n  <div class=\"ds-formField__autoComplete position-absolute w-100\">\n    <ng-content select=\"ds-auto-complete\"></ng-content>\n  </div>\n\n  <!-- TODO: remove `ds-formFields__messages` -->\n  <div\n    class=\"ds-formFields__messages\"\n    [id]=\"messagesId\"\n  >\n    <div\n      class=\"ds-formField__passwordHints\"\n      *ngIf=\"passwordHints\"\n    >\n      <ng-content select=\"ds-password-hints\"></ng-content>\n    </div>\n\n    <div\n      class=\"d-flex mt-4\"\n      *ngIf=\"\n        _control.getNodeTypeAndInputType().nodeType === 'textarea' &&\n        _control.maxLength\n      \"\n    >\n      <p\n        [brClass]=\"[\n          ['text-sm', 'text-sm', 'text-body-sm', 'text-sm'],\n          ['text-medium', 'text-medium', 'text-normal', 'text-medium'],\n          ['', '', 'mb-0', '']\n        ]\"\n      >\n        <span>{{\n          getRemainingCharacterCount() + ' ' + _control.characterCountMessage\n        }}</span>\n      </p>\n    </div>\n\n    <div\n      class=\"ds-formField__success\"\n      *ngIf=\"\n        successMessages.length > 0 &&\n        !getErrorState() &&\n        getErrorState() !== null\n      \"\n      [@enterAnimation]\n    >\n      <ng-content select=\"ds-success\"></ng-content>\n    </div>\n\n    <div\n      class=\"ds-formField__errors\"\n      *ngIf=\"\n        errorMessages.length > 0 && getErrorState() && getErrorState() !== null\n      \"\n      [@enterAnimation]\n    >\n      <ng-content select=\"ds-error\"></ng-content>\n    </div>\n    <div\n      class=\"ds-formField__hints\"\n      *ngIf=\"hints.length > 0\"\n    >\n      <ng-content select=\"ds-hint\"></ng-content>\n    </div>\n  </div>\n</div>\n\n<ng-template #datepickerTemplateRef>\n  <ng-content select=\"ds-datepicker\"></ng-content>\n</ng-template>\n", components: [{ type: i2$1.ButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["variant", "size", "alignIcon", "img", "transparent", "disabled", "tabIndex", "a11yDescription"] }, { type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.BrandClassDirective, selector: "[brClass]", inputs: ["brClass"] }, { type: i4.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i4.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], animations: [
        trigger('enterAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('500ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('500ms', style({ opacity: 0 })),
            ]),
        ]),
        trigger('floatAnimation', [
            transition('* => true', [
                style(floatOutStyles),
                animate('200ms', style(floatInStyles)),
            ]),
            transition('* => false', [
                style(floatInStyles),
                animate('200ms', style(floatOutStyles)),
            ]),
        ]),
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-form-field', animations: [
                        trigger('enterAnimation', [
                            transition(':enter', [
                                style({ opacity: 0 }),
                                animate('500ms', style({ opacity: 1 })),
                            ]),
                            transition(':leave', [
                                style({ opacity: 1 }),
                                animate('500ms', style({ opacity: 0 })),
                            ]),
                        ]),
                        trigger('floatAnimation', [
                            transition('* => true', [
                                style(floatOutStyles),
                                animate('200ms', style(floatInStyles)),
                            ]),
                            transition('* => false', [
                                style(floatInStyles),
                                animate('200ms', style(floatOutStyles)),
                            ]),
                        ]),
                    ], host: {
                        class: 'ds-formField',
                        '[class.d-block]': 'true',
                        '[class.position-relative]': 'true',
                        '[class.-float]': '_control.focused || !_control.empty',
                        '[class.-error]': 'getErrorState()',
                        '[class.-disabled]': '_control.disabled',
                        '[class.ds-formField__autoFilled]': '_control.autofilled',
                        '[class.ng-untouched]': '_shouldForward("untouched")',
                        '[class.ng-touched]': '_shouldForward("touched")',
                        '[class.ng-pristine]': '_shouldForward("pristine")',
                        '[class.ng-dirty]': '_shouldForward("dirty")',
                        '[class.ng-valid]': '_shouldForward("valid")',
                        '[class.ng-invalid]': '_shouldForward("invalid")',
                        '[class.ng-pending]': '_shouldForward("pending")',
                        '[class.-hasSuffix]': 'getSuffixType()',
                        '[class.dropdown-open]': 'autoComplete?.options.length > 0',
                        '(mouseover)': 'isMouseOver = true',
                        '(mouseout)': 'isMouseOver = false',
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"ds-formField__wrapper\"\n  #formFieldWrapper\n>\n  <!-- input container, includes input, label and suffix if any. -->\n  <div\n    class=\"ds-formField__inputContainer d-flex position-relative ds-bgcolor-white ds-borders\"\n    [ngClass]=\"{\n      'ds-brcolor-black ds-color-black':\n        !_control.disabled && !getErrorState() && brand === 'fido',\n      'ds-brcolor-slate':\n        !_control.disabled && !getErrorState() && brand !== 'fido',\n      '-active': _control.focused,\n      'bx-2 by-2': _control.focused || (autoComplete && autoComplete.hasFocus),\n      'ds-bgcolor-errorField ds-brcolor-error': getErrorState(),\n      '-textarea h-100':\n        _control.getNodeTypeAndInputType().nodeType === 'textarea',\n      '-select': _control.getNodeTypeAndInputType().nodeType === 'select',\n      'ds-bgcolor-misty ds-brcolor-concrete ds-color-concrete':\n        _control.disabled,\n      '-hideLabelVisually': hideLabelVisually\n    }\"\n    [brClass]=\"[['ds-corners', '', 'ds-corners', 'ds-corners']]\"\n    #inputContainer\n    (click)=\"_control.onContainerClick && _control.onContainerClick($event)\"\n  >\n    <span\n      class=\"ds-formField__labelWrapper position-absolute mb-0\"\n      [ngClass]=\"{ 'sr-only': hideLabelVisually }\"\n      [@floatAnimation]=\"_control.focused || !_control.empty\"\n    >\n      <label\n        [for]=\"_control.id\"\n        class=\"ds-formField_label\"\n        #inputLabel\n      >\n        <ng-content select=\"ds-input-label\"></ng-content>\n      </label>\n    </span>\n\n    <ng-content></ng-content>\n\n    <div\n      class=\"ds-formField__suffix justify-content-center align-items-center\"\n      [ngSwitch]=\"getSuffixType()\"\n      [ngClass]=\"{\n        'ds-formField__suffixSelect position-absolute t-0 ds-no-pointers':\n          _control.getNodeTypeAndInputType().nodeType === 'select'\n      }\"\n    >\n      <!-- Datepicker  -->\n      <ng-container *ngSwitchCase=\"'date'\">\n        <button\n          *ngIf=\"datepickerButtonVisibility\"\n          ds-button\n          type=\"button\"\n          variant=\"icon\"\n          (click)=\"openDatePicker($event)\"\n          (keydown.space)=\"openDatePicker($event)\"\n          [attr.aria-label]=\"dsInput.suffixTitle\"\n          [transparent]=\"true\"\n          [disabled]=\"_control.disabled\"\n        >\n          <ds-icon [name]=\"'calendar'\"></ds-icon>\n        </button>\n      </ng-container>\n\n      <!--  When input type is password -->\n      <button\n        ds-button\n        variant=\"icon\"\n        type=\"button\"\n        (click)=\"togglePasswordHideAndShow($event)\"\n        [attr.aria-pressed]=\"\n          _control.getNodeTypeAndInputType()['type'] === 'password'\n            ? 'false'\n            : 'true'\n        \"\n        *ngSwitchCase=\"'password'\"\n        [attr.aria-label]=\"dsInput.suffixTitle\"\n      >\n        <ds-icon\n          [name]=\"\n            _control.getNodeTypeAndInputType()['type'] === 'password'\n              ? 'hide'\n              : 'show'\n          \"\n        ></ds-icon>\n      </button>\n\n      <!-- When select box -->\n      <ds-icon\n        *ngSwitchCase=\"'select'\"\n        [name]=\"'chevron-down'\"\n      ></ds-icon>\n\n      <!-- Custom suffix -->\n      <ng-content\n        select=\"[dsSuffix]\"\n        *ngSwitchCase=\"'custom'\"\n      ></ng-content>\n    </div>\n  </div>\n  <!--  input container ends -->\n\n  <div class=\"ds-formField__autoComplete position-absolute w-100\">\n    <ng-content select=\"ds-auto-complete\"></ng-content>\n  </div>\n\n  <!-- TODO: remove `ds-formFields__messages` -->\n  <div\n    class=\"ds-formFields__messages\"\n    [id]=\"messagesId\"\n  >\n    <div\n      class=\"ds-formField__passwordHints\"\n      *ngIf=\"passwordHints\"\n    >\n      <ng-content select=\"ds-password-hints\"></ng-content>\n    </div>\n\n    <div\n      class=\"d-flex mt-4\"\n      *ngIf=\"\n        _control.getNodeTypeAndInputType().nodeType === 'textarea' &&\n        _control.maxLength\n      \"\n    >\n      <p\n        [brClass]=\"[\n          ['text-sm', 'text-sm', 'text-body-sm', 'text-sm'],\n          ['text-medium', 'text-medium', 'text-normal', 'text-medium'],\n          ['', '', 'mb-0', '']\n        ]\"\n      >\n        <span>{{\n          getRemainingCharacterCount() + ' ' + _control.characterCountMessage\n        }}</span>\n      </p>\n    </div>\n\n    <div\n      class=\"ds-formField__success\"\n      *ngIf=\"\n        successMessages.length > 0 &&\n        !getErrorState() &&\n        getErrorState() !== null\n      \"\n      [@enterAnimation]\n    >\n      <ng-content select=\"ds-success\"></ng-content>\n    </div>\n\n    <div\n      class=\"ds-formField__errors\"\n      *ngIf=\"\n        errorMessages.length > 0 && getErrorState() && getErrorState() !== null\n      \"\n      [@enterAnimation]\n    >\n      <ng-content select=\"ds-error\"></ng-content>\n    </div>\n    <div\n      class=\"ds-formField__hints\"\n      *ngIf=\"hints.length > 0\"\n    >\n      <ng-content select=\"ds-hint\"></ng-content>\n    </div>\n  </div>\n</div>\n\n<ng-template #datepickerTemplateRef>\n  <ng-content select=\"ds-datepicker\"></ng-content>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.NgZone }, { type: DatepickerService }, { type: i0.ViewContainerRef }, { type: i1.FocusMonitor }, { type: i1$1.WindowService }, { type: i2.CDKCoreService }]; }, propDecorators: { hideLabelVisually: [{
                type: Input
            }], errorMessages: [{
                type: ContentChildren,
                args: [ErrorComponent]
            }], successMessages: [{
                type: ContentChildren,
                args: [SuccessComponent]
            }], hints: [{
                type: ContentChildren,
                args: [HintComponent]
            }], autoComplete: [{
                type: ContentChild,
                args: [AutoCompleteComponent, { static: false }]
            }], inputSuffix: [{
                type: ContentChild,
                args: [SuffixDirective, { static: true }]
            }], inputLabel: [{
                type: ContentChild,
                args: [InputLabelComponent, { static: true }]
            }], controlNonStatic: [{
                type: ContentChild,
                args: [FormFieldControl, { static: true }]
            }], controlStatic: [{
                type: ContentChild,
                args: [FormFieldControl, { static: true }]
            }], passwordHints: [{
                type: ContentChild,
                args: [PasswordHintsComponent, { static: true }]
            }], dsInput: [{
                type: ContentChild,
                args: [InputFormDirective, { static: true }]
            }], datepickerComponentInstance: [{
                type: ContentChild,
                args: [DatepickerComponent, { static: true }]
            }], dptemplateRef: [{
                type: ViewChild,
                args: ['datepickerTemplateRef', { static: true }]
            }], formFieldWrapper: [{
                type: ViewChild,
                args: ['formFieldWrapper', { static: true }]
            }], inputContainer: [{
                type: ViewChild,
                args: ['inputContainer', { static: true }]
            }], handleClick: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

var InputState;
(function (InputState) {
    InputState[InputState["ready"] = 0] = "ready";
    InputState[InputState["reset"] = 1] = "reset";
})(InputState || (InputState = {}));
class CodeInputComponent {
    constructor(focusMonitor, window) {
        this.focusMonitor = focusMonitor;
        this.window = window;
        this.inputs = [];
        this.inputsStates = [];
        this.length = 4;
        this.isNonNumeric = false;
        this.focusPreviousAfterClearing = true;
        this.inputType = 'tel';
        this.codeChanged = new EventEmitter();
        this.codeCompleted = new EventEmitter();
    }
    ngOnInit() {
        this.initializePlaceholders();
    }
    ngAfterViewInit() {
        this.inputContainersList.changes.subscribe(() => {
            this.onInputLengthChanges();
        });
        this.setInputElements();
    }
    ngOnChanges(changes) {
        if (changes.code) {
            this.onInputCodeChanges();
        }
        else if (changes.length) {
            this.initializePlaceholders();
        }
    }
    onMobileInput(e) {
        // Android does not provide key value on keydown event so,
        // checking if digit or not here and removing if its not digit
        if (this.window.isAndroidDevice()) {
            const value = e.target.value;
            const key = value.charAt(value.length - 1);
            if (!this.canInputValue(key)) {
                this.mobileInput.nativeElement.value =
                    value.slice(0, -1);
            }
        }
        const values = e.target.value.split('');
        this.inputs.forEach((input) => {
            input.value = '';
        });
        for (let i = 0; i < values.length; i++) {
            this.inputs[i].value = values[i];
        }
        this.emitChanges();
    }
    onMobileKeydown(e) {
        if (!this.canInputValue(e.key) &&
            e.key.toLowerCase() !== 'backspace' &&
            e.key.toLowerCase() !== 'tab' &&
            !((e.ctrlKey === true || e.metaKey === true) &&
                e.key.toLowerCase() === 'v')) {
            e.preventDefault();
        }
    }
    onInput(e, i) {
        const next = i + 1;
        const target = e.target;
        const value = e.data || target.value;
        if (this.isEmpty(value)) {
            return;
        }
        // only digits are allowed if isNonNumeric flag is absent/false
        if (!this.canInputValue(value)) {
            e.preventDefault();
            e.stopPropagation();
            this.setInputValue(target, null);
            this.setStateForInput(target, InputState.reset);
            return;
        }
        this.setInputValue(target, value.toString().charAt(0));
        this.emitChanges();
        if (next > this.length - 1) {
            return;
        }
        this.inputs[next].focus();
    }
    onPaste(e, i) {
        e.preventDefault();
        e.stopPropagation();
        const data = e.clipboardData ? e.clipboardData.getData('text') : undefined;
        if (this.isEmpty(data)) {
            return;
        }
        // transform the pasted string in to character array
        const values = data.split('');
        let valIndex = 0;
        for (let j = i; j < this.inputs.length; j++) {
            // break if valIndex reaches total length of pasted data
            if (valIndex === values.length) {
                break;
            }
            const input = this.inputs[j];
            input.focus();
            const val = values[valIndex];
            // Cancel the loop when a value cannot be used
            if (!this.canInputValue(val)) {
                this.setInputValue(input, null);
                this.setStateForInput(input, InputState.reset);
                return;
            }
            this.setInputValue(input, val.toString());
            valIndex++;
        }
        this.emitChanges();
    }
    async onKeydown(e, i) {
        const target = e.target;
        const isTargetEmpty = this.isEmpty(target.value);
        const prev = i - 1;
        // processing only backspace events
        const isBackspaceKey = await this.isBackspaceKey(e);
        if (!isBackspaceKey) {
            return;
        }
        e.preventDefault();
        this.setInputValue(target, null);
        if (!isTargetEmpty) {
            this.emitChanges();
        }
        if (prev < 0) {
            return;
        }
        if (isTargetEmpty || this.focusPreviousAfterClearing) {
            this.inputs[prev].focus();
        }
    }
    isInputElementEmptyAt(index) {
        const input = this.inputs[index];
        if (!input) {
            return true;
        }
        return this.isEmpty(input.value);
    }
    onInputCodeChanges() {
        if (!this.inputs.length) {
            return;
        }
        if (this.isEmpty(this.code)) {
            this.inputs.forEach((input) => {
                this.setInputValue(input, null);
            });
            return;
        }
        const chars = this.code.toString().trim().split('');
        // checking if all the values are correct
        for (const char of chars) {
            if (!this.canInputValue(char)) {
                return;
            }
        }
        this.inputs.forEach((input, index) => {
            this.setInputValue(input, chars[index]);
        });
    }
    onInputLengthChanges() {
        this.inputs = [];
        this.inputsStates = [];
        this.setInputElements();
    }
    clear() {
        this.mobileInput.nativeElement.value = '';
        this.inputsList.forEach((input) => {
            input.nativeElement.value = '';
        });
    }
    emitChanges() {
        setTimeout(() => this.emitCode(), 50);
    }
    emitCode() {
        const code = this.getCurrentFilledCode();
        this.codeChanged.emit(code);
        if (code.length >= this.length) {
            this.codeCompleted.emit(code);
        }
    }
    getCurrentFilledCode() {
        let code = '';
        this.inputs.forEach((input) => {
            if (!this.isEmpty(input.value)) {
                code += input.value;
            }
        });
        return code;
    }
    isBackspaceKey(e) {
        const isBackspace = (e.key && e.key.toLowerCase() === 'backspace') ||
            (e.keyCode && e.keyCode === 8);
        if (isBackspace) {
            return Promise.resolve(true);
        }
        // process only key with placeholder keycode on android devices
        if (!e.keyCode || e.keyCode !== 229) {
            return Promise.resolve(false);
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                const input = e.target;
                const isReset = this.getStateForInput(input) === InputState.reset;
                if (isReset) {
                    this.setStateForInput(input, InputState.ready);
                }
                // if backspace key pressed the caret will have position 0 (for single value field)
                resolve(input.selectionStart === 0 && !isReset);
            });
        });
    }
    setInputValue(input, value) {
        const isEmpty = this.isEmpty(value);
        input.value = isEmpty ? null : value;
        if (isEmpty) {
            input.classList.remove('has-value');
        }
        else {
            input.classList.add('has-value');
        }
        this.mobileInput.nativeElement.value = this.getCurrentFilledCode();
    }
    canInputValue(value) {
        if (this.isEmpty(value)) {
            return false;
        }
        const isDigitsValue = /^[0-9]+$/.test(value.toString());
        return isDigitsValue || this.isNonNumeric;
    }
    initializePlaceholders() {
        this.placeHolders = Array(this.length).fill(1);
    }
    setInputElements() {
        // Set up focus monitor on input elements
        this.inputContainersList.forEach((input) => {
            this.focusMonitor.monitor(input.nativeElement, true);
        });
        this.inputsList.forEach((item) => {
            this.inputs.push(item.nativeElement);
            this.inputsStates.push(InputState.ready);
        });
        this.onInputCodeChanges();
    }
    setStateForInput(input, state) {
        const index = this.inputs.indexOf(input);
        if (index < 0) {
            return;
        }
        this.inputsStates[index] = state;
    }
    getStateForInput(input) {
        const index = this.inputs.indexOf(input);
        return this.inputsStates[index];
    }
    isEmpty(value) {
        return value === null || value === undefined || !value.toString().length;
    }
}
CodeInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CodeInputComponent, deps: [{ token: i1.FocusMonitor }, { token: i1$1.WindowService }], target: i0.ɵɵFactoryTarget.Component });
CodeInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CodeInputComponent, selector: "ds-code-input", inputs: { a11yLabel: "a11yLabel", code: "code", length: "length", isNonNumeric: "isNonNumeric", focusPreviousAfterClearing: "focusPreviousAfterClearing", inputType: "inputType" }, outputs: { codeChanged: "codeChanged", codeCompleted: "codeCompleted" }, host: { classAttribute: "d-flex" }, viewQueries: [{ propertyName: "codeInputWrapper", first: true, predicate: ["codeInputWrapper"], descendants: true }, { propertyName: "mobileInput", first: true, predicate: ["inputMobile"], descendants: true, static: true }, { propertyName: "inputsList", predicate: ["input"], descendants: true }, { propertyName: "inputContainersList", predicate: ["inputContainer"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div\n  #codeInputWrapper\n  class=\"d-flex ds-codeInput__wrapper w-100 w-md-auto\"\n>\n  <label class=\"sr-only\">{{ a11yLabel }}</label>\n  <div\n    #inputContainer\n    class=\"d-flex d-sm-none ds-codeInput__mobileInputContainer w-100\"\n  >\n    <ds-form-field\n      [hideLabelVisually]=\"true\"\n      class=\"w-100\"\n    >\n      <ds-input-label>{{ a11yLabel }}</ds-input-label>\n      <input\n        #inputMobile\n        dsInput\n        autocomplete=\"off\"\n        class=\"text-center\"\n        showPasswordToggleButton=\"false\"\n        [attr.maxlength]=\"placeHolders.length\"\n        [type]=\"inputType\"\n        (input)=\"onMobileInput($event)\"\n        (keydown)=\"onMobileKeydown($event)\"\n      />\n    </ds-form-field>\n  </div>\n  <div\n    #inputContainer\n    *ngFor=\"let holder of placeHolders; index as i; last as isLast\"\n    class=\"d-none d-sm-flex mr-16 ds-corners position-relative ds-borders ds-brcolor-slate ds-bgcolor-white ds-codeInput__inputContainer\"\n    [ngClass]=\"{\n      'mr-0': isLast\n    }\"\n  >\n    <input\n      #input\n      [type]=\"inputType\"\n      class=\"mb-0 text-body ds-corners text-center ds-keyboard-element-focus\"\n      (paste)=\"onPaste($event, i)\"\n      (input)=\"onInput($event, i)\"\n      (keydown)=\"onKeydown($event, i)\"\n    />\n  </div>\n</div>\n", components: [{ type: FormFieldComponent, selector: "ds-form-field", inputs: ["hideLabelVisually"] }, { type: InputLabelComponent, selector: "ds-input-label", inputs: ["optional"] }], directives: [{ type: InputFormDirective, selector: "input[dsInput], textarea[dsInput], select[dsNativeControl]", inputs: ["maxLength", "a11yDescription", "suffixTitle", "errorStateMatcher", "showPasswordToggleButton", "placeholder", "value", "id", "required", "disabled", "type", "readonly", "characterCountMessage", "customState"], outputs: ["passwordToggleButtonClick"], exportAs: ["dsInput"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    Required()
], CodeInputComponent.prototype, "a11yLabel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CodeInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-code-input', host: {
                        class: 'd-flex',
                    }, encapsulation: ViewEncapsulation.None, template: "<div\n  #codeInputWrapper\n  class=\"d-flex ds-codeInput__wrapper w-100 w-md-auto\"\n>\n  <label class=\"sr-only\">{{ a11yLabel }}</label>\n  <div\n    #inputContainer\n    class=\"d-flex d-sm-none ds-codeInput__mobileInputContainer w-100\"\n  >\n    <ds-form-field\n      [hideLabelVisually]=\"true\"\n      class=\"w-100\"\n    >\n      <ds-input-label>{{ a11yLabel }}</ds-input-label>\n      <input\n        #inputMobile\n        dsInput\n        autocomplete=\"off\"\n        class=\"text-center\"\n        showPasswordToggleButton=\"false\"\n        [attr.maxlength]=\"placeHolders.length\"\n        [type]=\"inputType\"\n        (input)=\"onMobileInput($event)\"\n        (keydown)=\"onMobileKeydown($event)\"\n      />\n    </ds-form-field>\n  </div>\n  <div\n    #inputContainer\n    *ngFor=\"let holder of placeHolders; index as i; last as isLast\"\n    class=\"d-none d-sm-flex mr-16 ds-corners position-relative ds-borders ds-brcolor-slate ds-bgcolor-white ds-codeInput__inputContainer\"\n    [ngClass]=\"{\n      'mr-0': isLast\n    }\"\n  >\n    <input\n      #input\n      [type]=\"inputType\"\n      class=\"mb-0 text-body ds-corners text-center ds-keyboard-element-focus\"\n      (paste)=\"onPaste($event, i)\"\n      (input)=\"onInput($event, i)\"\n      (keydown)=\"onKeydown($event, i)\"\n    />\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1.FocusMonitor }, { type: i1$1.WindowService }]; }, propDecorators: { a11yLabel: [{
                type: Input
            }], code: [{
                type: Input
            }], length: [{
                type: Input
            }], isNonNumeric: [{
                type: Input
            }], focusPreviousAfterClearing: [{
                type: Input
            }], inputType: [{
                type: Input
            }], codeChanged: [{
                type: Output
            }], codeCompleted: [{
                type: Output
            }], codeInputWrapper: [{
                type: ViewChild,
                args: ['codeInputWrapper', { static: false }]
            }], mobileInput: [{
                type: ViewChild,
                args: ['inputMobile', { static: true }]
            }], inputsList: [{
                type: ViewChildren,
                args: ['input']
            }], inputContainersList: [{
                type: ViewChildren,
                args: ['inputContainer']
            }] } });

const CalendarHeaderControls = ['next', 'previous'];
class CalendarHeaderComponent {
    constructor(_dpid) {
        this._dpid = _dpid;
        this.controls = ['next', 'previous'];
        this.next = new EventEmitter();
        this.previous = new EventEmitter();
    }
    get a11y() {
        return {
            next: this._dpid.source.a11yDescriptionNext,
            previous: this._dpid.source.a11yDescriptionPrevious,
        };
    }
    get month() {
        return this.date.locale(this.dpid.language + '-ca').format('MMMM');
    }
    get year() {
        return this.date.format('YYYY');
    }
    get dpid() {
        return this._dpid.source;
    }
    flexAlignments() {
        if (this.controls.length === 2)
            return '';
        if (this.controls.find((c) => c === 'previous')) {
            return 'flex-row-reverse';
        }
    }
    iconMap() {
        return {
            next: 'chevron-right-outlined',
            previous: 'chevron-left-outlined',
        };
    }
    controlClick(event, control) {
        this[control].emit(event);
    }
    sortControls() {
        return Array.from(this.controls).sort().reverse();
    }
}
CalendarHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarHeaderComponent, deps: [{ token: DatepickerInjectableData }], target: i0.ɵɵFactoryTarget.Component });
CalendarHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CalendarHeaderComponent, selector: "ds-calendar-header", inputs: { date: "date", controls: "controls" }, outputs: { next: "next", previous: "previous" }, ngImport: i0, template: "<div\n  class=\"calendar-navigation d-flex justify-content-between align-items-center mb-16\"\n  [ngClass]=\"flexAlignments()\"\n>\n  <div\n    class=\"empty-block w-48\"\n    *ngIf=\"controls.length < 2\"\n  ></div>\n  <div>\n    <div\n      id=\"calendar-month-title\"\n      class=\"text-bold\"\n      aria-live=\"polite\"\n      [ngClass]=\"{ 'pl-16 ml-4': controls.length === 2 }\"\n    >\n      {{ month | uppercase }} {{ year }}\n    </div>\n  </div>\n  <div class=\"d-flex justify-content-between\">\n    <button\n      *ngFor=\"let control of sortControls()\"\n      [attr.aria-label]=\"a11y[control]\"\n      ds-button\n      variant=\"icon\"\n      (click)=\"controlClick($event, control)\"\n    >\n      <ds-icon [name]=\"iconMap()[control]\"></ds-icon>\n    </button>\n  </div>\n</div>\n", components: [{ type: i2$1.ButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["variant", "size", "alignIcon", "img", "transparent", "disabled", "tabIndex", "a11yDescription"] }, { type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "uppercase": i4.UpperCasePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-calendar-header', template: "<div\n  class=\"calendar-navigation d-flex justify-content-between align-items-center mb-16\"\n  [ngClass]=\"flexAlignments()\"\n>\n  <div\n    class=\"empty-block w-48\"\n    *ngIf=\"controls.length < 2\"\n  ></div>\n  <div>\n    <div\n      id=\"calendar-month-title\"\n      class=\"text-bold\"\n      aria-live=\"polite\"\n      [ngClass]=\"{ 'pl-16 ml-4': controls.length === 2 }\"\n    >\n      {{ month | uppercase }} {{ year }}\n    </div>\n  </div>\n  <div class=\"d-flex justify-content-between\">\n    <button\n      *ngFor=\"let control of sortControls()\"\n      [attr.aria-label]=\"a11y[control]\"\n      ds-button\n      variant=\"icon\"\n      (click)=\"controlClick($event, control)\"\n    >\n      <ds-icon [name]=\"iconMap()[control]\"></ds-icon>\n    </button>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: DatepickerInjectableData }]; }, propDecorators: { date: [{
                type: Input
            }], controls: [{
                type: Input
            }], next: [{
                type: Output
            }], previous: [{
                type: Output
            }] } });

function isLessThanMin(cellDate, date) {
    if (!date)
        return false;
    return cellDate.isBefore(date, 'day');
}
function isGreaterThanMax(cellDate, date) {
    if (!date)
        return false;
    return cellDate.isAfter(date, 'day');
}
function isBlocked(cellDate, dates) {
    if (dates.length === 0)
        return false;
    return !!dates.find((d) => d.isSame(cellDate, 'day'));
}
function isDisabled(cellDate, dpid) {
    return (isBlocked(cellDate, dpid.blockedDates.getValue()) ||
        isLessThanMin(cellDate, dpid.minDate.getValue()) ||
        isGreaterThanMax(cellDate, dpid.maxDate.getValue()));
}

class CalendarDayComponent {
    constructor(cdr, _dpid) {
        this.cdr = cdr;
        this._dpid = _dpid;
        this.destroy$ = new Subject();
        this._hideUpcoming = false;
        this.hoverDateChange = new EventEmitter();
        this.selectedDatesChange = new EventEmitter();
    }
    get currentMonth() {
        return this._currentMonth;
    }
    set currentMonth(value) {
        this._currentMonth = value;
        this.cdr.markForCheck();
    }
    get focusDate() {
        return this._focusDate;
    }
    set focusDate(value) {
        this._focusDate = value;
    }
    get button() {
        return this._button.nativeElement;
    }
    get day() {
        return this.date.format('D');
    }
    get isTodaysDate() {
        return this.date.isSame(_djs__default(), 'day');
    }
    get isDateFromCurrentMonth() {
        return this.currentMonth.isSame(this.date, 'month');
    }
    get isSelected() {
        const dates = this.selectedDates || [];
        if (dates.length === 0)
            return false;
        const date = dates.find((d) => d.isSame(this.date, 'day'));
        return !!date;
    }
    get isFocused() {
        return this.focusDate?.isSame(this.date, 'day');
    }
    get eventSource() {
        return this.dpid.datepickerHostEvent instanceof KeyboardEvent
            ? 'keyboard'
            : 'mouse';
    }
    get dpid() {
        return this._dpid.source;
    }
    get isHidden() {
        return this.hideUpcoming && !this.isDateFromCurrentMonth;
    }
    get isInRange() {
        if (!this.selectedDates[0] || !this.selectedDates[1])
            return false;
        const fromDate = this.selectedDates[0];
        const toDate = this.selectedDates[1];
        return (this.date.isAfter(fromDate, 'day') && this.date.isBefore(toDate, 'day'));
    }
    get isRangeStart() {
        if (!this.selectedDates[0] || !this.selectedDates[1])
            return false;
        return this.selectedDates[0].isSame(this.date, 'day');
    }
    get isRangeEnd() {
        if (!this.selectedDates[1])
            return false;
        return this.selectedDates[1].isSame(this.date, 'day');
    }
    get ariaLabel() {
        let title;
        this.dpid.language === 'en'
            ? (title = this.date.format('dddd, MMMM D, YYYY'))
            : (title = this.date.locale('fr-ca').format('dddd, MMMM D, YYYY'));
        if (this.isTodaysDate && this.dpid.currentDateTitle) {
            title += '. ' + this.dpid.currentDateTitle;
        }
        if (this.disabled && this.dpid.blockedDateTitle) {
            title += '. ' + this.dpid.blockedDateTitle;
        }
        return title;
    }
    ngOnInit() { }
    ngOnChanges(changes) { }
    ngAfterViewInit() {
        if (!this.isHidden && !this.mouseEnter$) {
            this.subscribePointerEvents();
        }
    }
    subscribePointerEvents() {
        this.mouseEnter$ = fromEvent(this.button, 'mouseenter');
        this.mouseEnter$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.hoverDateChange.emit(this.date);
        });
    }
    selectDate() {
        if (!this.disabled) {
            this.selectedDatesChange.emit([this.date]);
        }
    }
    ngOnDestroy() {
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
CalendarDayComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarDayComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: DatepickerInjectableData, optional: true }], target: i0.ɵɵFactoryTarget.Component });
CalendarDayComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CalendarDayComponent, selector: "td[ds-calendar-day]", inputs: { currentMonth: "currentMonth", date: "date", hoverDate: "hoverDate", highlight: "highlight", focusDate: "focusDate", hideUpcoming: "hideUpcoming", disabled: "disabled", selectedDates: "selectedDates" }, outputs: { hoverDateChange: "hoverDateChange", selectedDatesChange: "selectedDatesChange" }, viewQueries: [{ propertyName: "_button", first: true, predicate: ["button"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"cellWrapper\"\n  [ngClass]=\"{\n    '-upcoming': !isDateFromCurrentMonth,\n    '-today': isTodaysDate,\n    '-selected': isSelected,\n    '-disabled': disabled,\n    '-focused': isFocused,\n    '-inRange': isInRange,\n    '-rangeStart': isRangeStart,\n    '-rangeEnd': isRangeEnd\n  }\"\n  *ngIf=\"!isHidden\"\n>\n  <button\n    class=\"datepicker-date full-screen h-100 py-4 w-100\"\n    [ngClass]=\"{\n      'ds-pointer': !disabled\n    }\"\n    [focus]=\"isFocused\"\n    [eventSource]=\"eventSource\"\n    #button\n    (click)=\"selectDate()\"\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-disabled]=\"disabled || undefined\"\n    type=\"button\"\n  >\n    <div class=\"h-100 w-100\">\n      <div\n        class=\"align-items-center d-flex justify-content-center\"\n        aria-hidden=\"true\"\n      >\n        {{ day }}\n      </div>\n    </div>\n  </button>\n</div>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.FocusDirective, selector: "[focus]", inputs: ["focus", "eventSource"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarDayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[ds-calendar-day]', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"cellWrapper\"\n  [ngClass]=\"{\n    '-upcoming': !isDateFromCurrentMonth,\n    '-today': isTodaysDate,\n    '-selected': isSelected,\n    '-disabled': disabled,\n    '-focused': isFocused,\n    '-inRange': isInRange,\n    '-rangeStart': isRangeStart,\n    '-rangeEnd': isRangeEnd\n  }\"\n  *ngIf=\"!isHidden\"\n>\n  <button\n    class=\"datepicker-date full-screen h-100 py-4 w-100\"\n    [ngClass]=\"{\n      'ds-pointer': !disabled\n    }\"\n    [focus]=\"isFocused\"\n    [eventSource]=\"eventSource\"\n    #button\n    (click)=\"selectDate()\"\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-disabled]=\"disabled || undefined\"\n    type=\"button\"\n  >\n    <div class=\"h-100 w-100\">\n      <div\n        class=\"align-items-center d-flex justify-content-center\"\n        aria-hidden=\"true\"\n      >\n        {{ day }}\n      </div>\n    </div>\n  </button>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: DatepickerInjectableData, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { currentMonth: [{
                type: Input
            }], date: [{
                type: Input
            }], hoverDate: [{
                type: Input
            }], highlight: [{
                type: Input
            }], focusDate: [{
                type: Input
            }], hideUpcoming: [{
                type: Input
            }], disabled: [{
                type: Input
            }], selectedDates: [{
                type: Input
            }], hoverDateChange: [{
                type: Output
            }], selectedDatesChange: [{
                type: Output
            }], _button: [{
                type: ViewChild,
                args: ['button', { static: false }]
            }] } });

class CalendarMonthComponent {
    constructor(_dpid, cdr) {
        this._dpid = _dpid;
        this.cdr = cdr;
        this.destroy$ = new Subject();
        this._selectedDates = [];
        this.hoverDateChange = new EventEmitter();
        this.selectedDatesChange = new EventEmitter();
    }
    get focusDate() {
        return this._focusDate;
    }
    set focusDate(value) {
        this._focusDate = value;
    }
    get weekdays() {
        return new Array(7)
            .fill('')
            .map((v, i) => this.date.locale(`${this.dpid.language}-ca`).weekday(i).format('dddd'));
    }
    get numberOfRows() {
        return new Array(6).fill('');
    }
    get numberOfCols() {
        return new Array(7).fill('');
    }
    get monthStart() {
        return this.date.startOf('month');
    }
    get firstCalendarDay() {
        return this.monthStart.subtract(this.monthStart.day(), 'day');
    }
    get dpid() {
        return this._dpid.source;
    }
    getCellDate(row, col) {
        const daysToAdd = col + 7 * row;
        return this.firstCalendarDay.add(daysToAdd, 'day');
    }
    getWeekLetter(day) {
        return day.substring(0, 1);
    }
    onSelectedDate(dates) {
        this.selectedDatesChange.emit(dates);
    }
    isFirstMonthDay(date) {
        return this.monthStart.isSame(date, 'day');
    }
    isLastMonthDay(date) {
        return this.monthStart.endOf('month').isSame(date, 'day');
    }
    isDisabled(cellDate) {
        return isDisabled(cellDate, this.dpid);
    }
    ngOnInit() {
        combineLatest([
            this.dpid.minDate,
            this.dpid.maxDate,
            this.dpid.blockedDates,
        ])
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            this.cdr.detectChanges();
        });
    }
    ngOnDestroy() {
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
CalendarMonthComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarMonthComponent, deps: [{ token: DatepickerInjectableData }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
CalendarMonthComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CalendarMonthComponent, selector: "ds-calendar-month", inputs: { date: "date", hoverDate: "hoverDate", hideUpcoming: "hideUpcoming", focusDate: "focusDate", selectedDates: "selectedDates", highlightRange: "highlightRange" }, outputs: { hoverDateChange: "hoverDateChange", selectedDatesChange: "selectedDatesChange" }, ngImport: i0, template: "<table\n  role=\"grid\"\n  aria-labelledby=\"calendar-month-title\"\n  class=\"w-100\"\n>\n  <thead\n    class=\"text-bold\"\n    role=\"presentation\"\n  >\n    <tr>\n      <th\n        *ngFor=\"let wday of weekdays\"\n        class=\"text-center pb-8\"\n        scope=\"col\"\n        [attr.abbr]=\"wday\"\n      >\n        {{ wday | slice: 0:1 }}\n      </th>\n    </tr>\n  </thead>\n  <tbody role=\"presentation\">\n    <tr\n      *ngFor=\"let row of numberOfRows; let i = index\"\n      role=\"row\"\n    >\n      <ng-container *ngFor=\"let col of numberOfCols; let j = index\">\n        <ng-container\n          *ngTemplateOutlet=\"\n            cell;\n            context: { $implicit: getCellDate(i, j), row: i, col: j }\n          \"\n        ></ng-container>\n      </ng-container>\n    </tr>\n  </tbody>\n</table>\n\n<ng-template\n  #cell\n  let-cellDate\n  let-row=\"row\"\n  let-col=\"col\"\n>\n  <td\n    ds-calendar-day\n    [currentMonth]=\"date\"\n    [date]=\"cellDate\"\n    [hideUpcoming]=\"hideUpcoming\"\n    [(hoverDate)]=\"hoverDate\"\n    [focusDate]=\"focusDate\"\n    [disabled]=\"isDisabled(cellDate)\"\n    [(selectedDates)]=\"selectedDates\"\n    (selectedDatesChange)=\"onSelectedDate($event)\"\n    [ngClass]=\"{\n      '-first-month-day': isFirstMonthDay(cellDate),\n      '-last-month-day': isLastMonthDay(cellDate)\n    }\"\n    role=\"gridcell\"\n  ></td>\n</ng-template>\n", components: [{ type: CalendarDayComponent, selector: "td[ds-calendar-day]", inputs: ["currentMonth", "date", "hoverDate", "highlight", "focusDate", "hideUpcoming", "disabled", "selectedDates"], outputs: ["hoverDateChange", "selectedDatesChange"] }], directives: [{ type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "slice": i4.SlicePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarMonthComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-calendar-month', changeDetection: ChangeDetectionStrategy.OnPush, template: "<table\n  role=\"grid\"\n  aria-labelledby=\"calendar-month-title\"\n  class=\"w-100\"\n>\n  <thead\n    class=\"text-bold\"\n    role=\"presentation\"\n  >\n    <tr>\n      <th\n        *ngFor=\"let wday of weekdays\"\n        class=\"text-center pb-8\"\n        scope=\"col\"\n        [attr.abbr]=\"wday\"\n      >\n        {{ wday | slice: 0:1 }}\n      </th>\n    </tr>\n  </thead>\n  <tbody role=\"presentation\">\n    <tr\n      *ngFor=\"let row of numberOfRows; let i = index\"\n      role=\"row\"\n    >\n      <ng-container *ngFor=\"let col of numberOfCols; let j = index\">\n        <ng-container\n          *ngTemplateOutlet=\"\n            cell;\n            context: { $implicit: getCellDate(i, j), row: i, col: j }\n          \"\n        ></ng-container>\n      </ng-container>\n    </tr>\n  </tbody>\n</table>\n\n<ng-template\n  #cell\n  let-cellDate\n  let-row=\"row\"\n  let-col=\"col\"\n>\n  <td\n    ds-calendar-day\n    [currentMonth]=\"date\"\n    [date]=\"cellDate\"\n    [hideUpcoming]=\"hideUpcoming\"\n    [(hoverDate)]=\"hoverDate\"\n    [focusDate]=\"focusDate\"\n    [disabled]=\"isDisabled(cellDate)\"\n    [(selectedDates)]=\"selectedDates\"\n    (selectedDatesChange)=\"onSelectedDate($event)\"\n    [ngClass]=\"{\n      '-first-month-day': isFirstMonthDay(cellDate),\n      '-last-month-day': isLastMonthDay(cellDate)\n    }\"\n    role=\"gridcell\"\n  ></td>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: DatepickerInjectableData }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { date: [{
                type: Input
            }], hoverDate: [{
                type: Input
            }], hideUpcoming: [{
                type: Input
            }], focusDate: [{
                type: Input
            }], selectedDates: [{
                type: Input
            }], highlightRange: [{
                type: Input
            }], hoverDateChange: [{
                type: Output
            }], selectedDatesChange: [{
                type: Output
            }] } });

class CalendarDualComponent {
    constructor(_dpid) {
        this._dpid = _dpid;
        this.selectedDates = [];
        this.destroy$ = new Subject();
        this.dates = null;
        this.dateChange = new EventEmitter();
        this.focusBlur = new EventEmitter();
        this.fromInput = _dpid.source.fromField.input;
        this.toInput = _dpid.source.toField.input;
    }
    get dayjs() {
        return _djs__default();
    }
    get dpid() {
        return this._dpid.source;
    }
    get fromDate() {
        return this.fromInput.selectedDate;
    }
    get toDate() {
        return this.toInput.selectedDate;
    }
    get focusDate() {
        return this._focusDate;
    }
    set focusDate(value) {
        if (!this.dates) {
            if (this.fromDate) {
                this.dates = [this.fromDate, this.fromDate.add(1, 'month')];
            }
            else if (this.toDate) {
                this.dates = [this.toDate.subtract(1, 'month'), this.toDate];
            }
            else {
                this.dates = [_djs__default(), _djs__default().add(1, 'month')];
            }
        }
        else {
            let fromDate = this.dates[0].clone();
            let toDate = this.dates[1].clone();
            if (value.isBefore(this.dates[0], 'month')) {
                fromDate = fromDate.subtract(2, 'month');
                toDate = toDate.subtract(2, 'month');
            }
            else if (value.isAfter(this.dates[1], 'month')) {
                fromDate = fromDate.add(2, 'month');
                toDate = toDate.add(2, 'month');
            }
            this.dates = [fromDate, toDate];
        }
        this._focusDate = value;
    }
    ngOnInit() {
        const dates = [];
        if (this.dpid.fromField.input.selectedDate) {
            dates.push(this.dpid.fromField.input.selectedDate);
        }
        if (this.dpid.toField.input.selectedDate) {
            dates.push(this.dpid.toField.input.selectedDate);
        }
        this.selectedDates = dates;
    }
    onPrevious() {
        this.dateChange.emit(this.dates[0].startOf('month').subtract(1, 'month'));
    }
    onNext() {
        this.dateChange.emit(this.dates[1].startOf('month').add(1, 'month'));
    }
    isOnDisplay(date) {
        return (date.isSame(this.dates[0], 'month') || date.isSame(this.dates[1], 'month'));
    }
    isSameOrBefore(a, b) {
        return a.isBefore(b, 'day') || a.isSame(b, 'day');
    }
    onSelectedDates(dates) {
        if (this.fromDate && this.toDate) {
            this.fromInput.selectedDate = dates[0];
            this.toInput.selectedDate = null;
        }
        else if (this.fromDate && dates[0].isBefore(this.fromDate, 'day')) {
            this.fromInput.selectedDate = dates[0];
        }
        else if (this.fromDate && !this.toDate) {
            this.toInput.selectedDate = dates[0];
            this.dpid.datepickerHostButton.focus();
        }
        else if (!this.fromDate && this.toDate) {
            this.fromInput.selectedDate = dates[0];
            this.toInput.selectedDate = null;
        }
        else {
            this.fromInput.selectedDate = dates[0];
        }
        const dats = [this.fromDate, this.toDate];
        this.selectedDates = dats.filter(Boolean);
    }
    ngOnDestroy() {
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
CalendarDualComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarDualComponent, deps: [{ token: DatepickerInjectableData, optional: true }], target: i0.ɵɵFactoryTarget.Component });
CalendarDualComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CalendarDualComponent, selector: "ds-calendar-dual", inputs: { date: "date", focusDate: "focusDate" }, outputs: { dateChange: "dateChange", focusBlur: "focusBlur" }, host: { properties: { "class.d-flex": "true" } }, ngImport: i0, template: "<div class=\"pr-8\">\n  <ds-calendar-header\n    [date]=\"dates[0]\"\n    [controls]=\"['previous']\"\n    (previous)=\"onPrevious()\"\n  ></ds-calendar-header>\n  <div class=\"d-flex\">\n    <ds-calendar-month\n      [date]=\"dates[0]\"\n      [focusDate]=\"focusDate\"\n      [hideUpcoming]=\"true\"\n      [selectedDates]=\"selectedDates\"\n      (selectedDatesChange)=\"onSelectedDates($event)\"\n    ></ds-calendar-month>\n  </div>\n</div>\n<div class=\"pl-8\">\n  <ds-calendar-header\n    [date]=\"dates[1]\"\n    [controls]=\"['next']\"\n    (next)=\"onNext()\"\n  ></ds-calendar-header>\n  <div class=\"d-flex\">\n    <ds-calendar-month\n      [date]=\"dates[1]\"\n      [focusDate]=\"focusDate\"\n      [hideUpcoming]=\"true\"\n      [selectedDates]=\"selectedDates\"\n      (selectedDatesChange)=\"onSelectedDates($event)\"\n    ></ds-calendar-month>\n  </div>\n</div>\n", components: [{ type: CalendarHeaderComponent, selector: "ds-calendar-header", inputs: ["date", "controls"], outputs: ["next", "previous"] }, { type: CalendarMonthComponent, selector: "ds-calendar-month", inputs: ["date", "hoverDate", "hideUpcoming", "focusDate", "selectedDates", "highlightRange"], outputs: ["hoverDateChange", "selectedDatesChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarDualComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-calendar-dual', changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class.d-flex]': 'true',
                    }, template: "<div class=\"pr-8\">\n  <ds-calendar-header\n    [date]=\"dates[0]\"\n    [controls]=\"['previous']\"\n    (previous)=\"onPrevious()\"\n  ></ds-calendar-header>\n  <div class=\"d-flex\">\n    <ds-calendar-month\n      [date]=\"dates[0]\"\n      [focusDate]=\"focusDate\"\n      [hideUpcoming]=\"true\"\n      [selectedDates]=\"selectedDates\"\n      (selectedDatesChange)=\"onSelectedDates($event)\"\n    ></ds-calendar-month>\n  </div>\n</div>\n<div class=\"pl-8\">\n  <ds-calendar-header\n    [date]=\"dates[1]\"\n    [controls]=\"['next']\"\n    (next)=\"onNext()\"\n  ></ds-calendar-header>\n  <div class=\"d-flex\">\n    <ds-calendar-month\n      [date]=\"dates[1]\"\n      [focusDate]=\"focusDate\"\n      [hideUpcoming]=\"true\"\n      [selectedDates]=\"selectedDates\"\n      (selectedDatesChange)=\"onSelectedDates($event)\"\n    ></ds-calendar-month>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: DatepickerInjectableData, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { date: [{
                type: Input
            }], focusDate: [{
                type: Input
            }], dateChange: [{
                type: Output
            }], focusBlur: [{
                type: Output
            }] } });

class CalendarSingleComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.selectedDates = [];
        this._dayjs = _djs.default();
        this.destroy$ = new Subject();
        this.dateChange = new EventEmitter();
        this.focusBlur = new EventEmitter();
    }
    get dayjs() {
        return this._dayjs;
    }
    ngOnInit() {
        if (this.field.input.selectedDate) {
            this.selectedDates = [this.field.input.selectedDate];
        }
    }
    onPrevious() {
        this.dateChange.emit(this.date.startOf('month').subtract(1, 'month'));
    }
    onNext() {
        this.dateChange.emit(this.date.startOf('month').add(1, 'month'));
    }
    onSelectedDates(dates) {
        this.selectedDates = dates;
        this.field.input.selectedDate = dates[0];
        this.cdr.detectChanges();
        this.field.input.element.focus();
    }
    ngOnDestroy() {
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
CalendarSingleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarSingleComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
CalendarSingleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CalendarSingleComponent, selector: "ds-calendar-single", inputs: { date: "date", field: "field" }, outputs: { dateChange: "dateChange", focusBlur: "focusBlur" }, ngImport: i0, template: "<ds-calendar-header\n  [date]=\"date\"\n  (previous)=\"onPrevious()\"\n  (next)=\"onNext()\"\n></ds-calendar-header>\n<div>\n  <ds-calendar-month\n    [date]=\"date\"\n    [focusDate]=\"date\"\n    [selectedDates]=\"selectedDates\"\n    (selectedDatesChange)=\"onSelectedDates($event)\"\n  ></ds-calendar-month>\n</div>\n", components: [{ type: CalendarHeaderComponent, selector: "ds-calendar-header", inputs: ["date", "controls"], outputs: ["next", "previous"] }, { type: CalendarMonthComponent, selector: "ds-calendar-month", inputs: ["date", "hoverDate", "hideUpcoming", "focusDate", "selectedDates", "highlightRange"], outputs: ["hoverDateChange", "selectedDatesChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarSingleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-calendar-single', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ds-calendar-header\n  [date]=\"date\"\n  (previous)=\"onPrevious()\"\n  (next)=\"onNext()\"\n></ds-calendar-header>\n<div>\n  <ds-calendar-month\n    [date]=\"date\"\n    [focusDate]=\"date\"\n    [selectedDates]=\"selectedDates\"\n    (selectedDatesChange)=\"onSelectedDates($event)\"\n  ></ds-calendar-month>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { date: [{
                type: Input
            }], field: [{
                type: Input
            }], dateChange: [{
                type: Output
            }], focusBlur: [{
                type: Output
            }] } });

_djs.extend(weekDay__default);
class CalendarContainerComponent {
    constructor(window, cdr, _dpid) {
        this.window = window;
        this.cdr = cdr;
        this._dpid = _dpid;
        this.destroy$ = new Subject();
    }
    get dpid() {
        return this._dpid.source;
    }
    ngOnInit() {
        if (isBrowser()) {
            fromEvent(document, 'keydown')
                .pipe(takeUntil(this.destroy$))
                .subscribe(this.processKey.bind(this));
        }
    }
    onMonthChange(date) {
        this.dpid.focusDate.next(date);
    }
    isDisabledDate(date) {
        return isDisabled(date, this.dpid);
    }
    processKey(e) {
        e.preventDefault();
        let fd = this.dpid.focusDate.getValue();
        if (e.keyCode === RIGHT_ARROW) {
            fd = fd.add(1, 'day');
        }
        else if (e.keyCode === LEFT_ARROW) {
            fd = fd.subtract(1, 'day');
        }
        else if (e.keyCode === UP_ARROW) {
            fd = fd.subtract(7, 'day');
        }
        else if (e.keyCode === DOWN_ARROW) {
            fd = fd.add(7, 'day');
        }
        else if (!e.altKey && e.keyCode === PAGE_UP) {
            fd = fd.subtract(1, 'month');
        }
        else if (!e.altKey && e.keyCode === PAGE_DOWN) {
            fd = fd.add(1, 'month');
        }
        else if (e.keyCode === HOME) {
            fd = fd.startOf('month');
        }
        else if (e.keyCode === END) {
            fd = fd.endOf('month');
        }
        else if (e.altKey && e.keyCode === PAGE_UP) {
            fd = fd.subtract(1, 'year');
        }
        else if (e.altKey && e.keyCode === PAGE_DOWN) {
            fd = fd.add(1, 'year');
        }
        else if (!e.shiftKey && e.keyCode === TAB) {
            // Tab
            this.dpid.datepickerHostButton.focus();
        }
        else if (e.shiftKey && e.keyCode === 9) {
            // Shift+Tab
            this.focusInputElement();
        }
        else if (e.keyCode === 32 || e.keyCode === 13) {
            // Space or Enter
            this.spaceOrEnter();
        }
        else if (e.keyCode === ESCAPE) {
            // ESC
            this.focusInputElement();
        }
        this.dpid.focusDate.next(fd);
    }
    spaceOrEnter() {
        if (this.isDisabledDate(this.dpid.focusDate.getValue()))
            return;
        (this.singleCalendar || this.dualCalendar).onSelectedDates([
            this.dpid.focusDate.getValue(),
        ]);
        this.cdr.detectChanges();
    }
    focusInputElement() {
        if (this.dpid.type === 'date') {
            this.dpid.field.input.element.focus();
        }
        else {
            this.dpid.toField.input.element.focus();
        }
    }
    ngOnDestroy() {
        this.dpid.focusDate.complete();
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
CalendarContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarContainerComponent, deps: [{ token: i1$1.WindowService }, { token: i0.ChangeDetectorRef }, { token: DatepickerInjectableData, optional: true }], target: i0.ɵɵFactoryTarget.Component });
CalendarContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CalendarContainerComponent, selector: "ds-calendar-container", host: { properties: { "class.d-flex": "true" } }, viewQueries: [{ propertyName: "dualCalendar", first: true, predicate: CalendarDualComponent, descendants: true }, { propertyName: "singleCalendar", first: true, predicate: CalendarSingleComponent, descendants: true }], ngImport: i0, template: "<div class=\"p-16\">\n  <ds-calendar-single\n    *ngIf=\"dpid.type === 'date' || window.isMobile(true)\"\n    [date]=\"dpid.focusDate | async\"\n    [field]=\"dpid[dpid.fieldType]\"\n    (dateChange)=\"onMonthChange($event)\"\n  ></ds-calendar-single>\n  <ds-calendar-dual\n    *ngIf=\"dpid.type !== 'date' && !window.isMobile(true)\"\n    [focusDate]=\"dpid.focusDate | async\"\n    (dateChange)=\"onMonthChange($event)\"\n  ></ds-calendar-dual>\n</div>\n", components: [{ type: CalendarSingleComponent, selector: "ds-calendar-single", inputs: ["date", "field"], outputs: ["dateChange", "focusBlur"] }, { type: CalendarDualComponent, selector: "ds-calendar-dual", inputs: ["date", "focusDate"], outputs: ["dateChange", "focusBlur"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i4.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CalendarContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-calendar-container', host: {
                        '[class.d-flex]': 'true',
                    }, template: "<div class=\"p-16\">\n  <ds-calendar-single\n    *ngIf=\"dpid.type === 'date' || window.isMobile(true)\"\n    [date]=\"dpid.focusDate | async\"\n    [field]=\"dpid[dpid.fieldType]\"\n    (dateChange)=\"onMonthChange($event)\"\n  ></ds-calendar-single>\n  <ds-calendar-dual\n    *ngIf=\"dpid.type !== 'date' && !window.isMobile(true)\"\n    [focusDate]=\"dpid.focusDate | async\"\n    (dateChange)=\"onMonthChange($event)\"\n  ></ds-calendar-dual>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.WindowService }, { type: i0.ChangeDetectorRef }, { type: DatepickerInjectableData, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { dualCalendar: [{
                type: ViewChild,
                args: [CalendarDualComponent, { static: false }]
            }], singleCalendar: [{
                type: ViewChild,
                args: [CalendarSingleComponent, { static: false }]
            }] } });

class DatepickerFieldDirective {
    constructor(formField, bpo) {
        this.formField = formField;
        this.bpo = bpo;
        this.destroy$ = new Subject();
        this.type = 'date';
    }
    ngAfterContentInit() {
        if (this.type === 'date') {
            this.formField.showDatepickerButton();
        }
        else {
            this.bpo
                .observe([
                MediaBreakpoints.Desktop,
                MediaBreakpoints.Tablet,
                MediaBreakpoints.Mobile,
            ])
                .pipe(takeUntil(this.destroy$))
                .subscribe((media) => {
                if (!media.breakpoints[MediaBreakpoints.Desktop]) {
                    this.formField.showDatepickerButton();
                }
                else {
                    this.formField.hideDatepickerButton();
                }
            });
        }
    }
    ngOnDestroy() {
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
DatepickerFieldDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerFieldDirective, deps: [{ token: FormFieldComponent, self: true }, { token: i2$3.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Directive });
DatepickerFieldDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: DatepickerFieldDirective, selector: "ds-form-field[ds-datepicker-field]", queries: [{ propertyName: "input", first: true, predicate: DatepickerDirective, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerFieldDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ds-form-field[ds-datepicker-field]',
                }]
        }], ctorParameters: function () { return [{ type: FormFieldComponent, decorators: [{
                    type: Self
                }] }, { type: i2$3.BreakpointObserver }]; }, propDecorators: { input: [{
                type: ContentChild,
                args: [DatepickerDirective, { static: false }]
            }] } });
class DatepickerFromDirective extends DatepickerFieldDirective {
    constructor(formField, bpo) {
        super(formField, bpo);
        this.formField = formField;
        this.bpo = bpo;
        this.type = 'date-range';
    }
}
DatepickerFromDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerFromDirective, deps: [{ token: FormFieldComponent, self: true }, { token: i2$3.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Directive });
DatepickerFromDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: DatepickerFromDirective, selector: "ds-form-field[ds-datepicker-from]", usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerFromDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ds-form-field[ds-datepicker-from]',
                }]
        }], ctorParameters: function () { return [{ type: FormFieldComponent, decorators: [{
                    type: Self
                }] }, { type: i2$3.BreakpointObserver }]; } });
class DatepickerToDirective extends DatepickerFieldDirective {
    constructor(formField, bpo) {
        super(formField, bpo);
        this.formField = formField;
        this.bpo = bpo;
        this.type = 'date-range';
    }
}
DatepickerToDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerToDirective, deps: [{ token: FormFieldComponent, self: true }, { token: i2$3.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Directive });
DatepickerToDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: DatepickerToDirective, selector: "ds-form-field[ds-datepicker-to]", usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerToDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ds-form-field[ds-datepicker-to]',
                }]
        }], ctorParameters: function () { return [{ type: FormFieldComponent, decorators: [{
                    type: Self
                }] }, { type: i2$3.BreakpointObserver }]; } });

class DatepickerContainerComponent {
    constructor(window, datepickerService, vcr, _changeDetectorRef) {
        this.window = window;
        this.datepickerService = datepickerService;
        this.vcr = vcr;
        this._changeDetectorRef = _changeDetectorRef;
        this.MediaBreakpoints = MediaBreakpoints;
        this.destroy$ = new Subject();
        this.blockedDates$ = new BehaviorSubject([]);
        this.minDate$ = new BehaviorSubject(null);
        this.maxDate$ = new BehaviorSubject(null);
        this.language = 'en';
        this._blockedDates = [];
    }
    get blockedDates() {
        return this._blockedDates;
    }
    set blockedDates(value) {
        this._blockedDates = value;
        const dates = value.filter((v) => v instanceof Date).map((v) => _djs__default(v));
        this.blockedDates$.next(dates);
        this.setConfigForInputs(value, this.minDate, this.maxDate);
    }
    get minDate() {
        return this._minDate;
    }
    set minDate(value) {
        if (value && !(value instanceof Date)) {
            throw new Error(`minDate should be JavaScript Date object`);
        }
        this._minDate = value;
        this.minDate$.next(value ? _djs__default(value) : null);
        this.setConfigForInputs(this.blockedDates, value, this.maxDate);
    }
    get maxDate() {
        return this._maxDate;
    }
    set maxDate(value) {
        if (value && !(value instanceof Date)) {
            throw new Error(`maxDate should be JavaScript Date object`);
        }
        this._maxDate = value;
        this.maxDate$.next(value ? _djs__default(value) : null);
        this.setConfigForInputs(this.blockedDates, this.minDate, value);
    }
    get type() {
        return this.isRangePicker() ? 'date-range' : 'date';
    }
    get disabled() {
        return (this.field?.formField?.dsInput?.disabled ||
            this.fromField?.formField?.dsInput?.disabled ||
            this.toField?.formField?.dsInput?.disabled);
    }
    openDatepickerCalendar(e, fieldType) {
        e.preventDefault();
        e.stopPropagation();
        this.eventSource = e instanceof KeyboardEvent ? 'keyboard' : 'mouse';
        const dpData = {
            inputHostElement: null,
            datepickerHostButton: e.currentTarget,
            datepickerHostEvent: e,
            a11yDescriptionNext: this.a11yDescriptionNext,
            a11yDescriptionPrevious: this.a11yDescriptionPrevious,
            blockedDateTitle: this.blockedDateTitle,
            currentDateTitle: this.currentDateTitle,
            eventSource: null,
            language: this.language,
            selectedDate: null,
            type: this.type,
            focusDate: new BehaviorSubject(this.getDateFromInputValue() || _djs__default()),
            fromField: this.fromField,
            toField: this.toField,
            field: this.field,
            fieldType: fieldType,
            blockedDates: this.blockedDates$,
            minDate: this.minDate$,
            maxDate: this.maxDate$,
        };
        const dpid = new DatepickerInjectableData(dpData);
        this.overlayRef = this.datepickerService.open({
            componentClass: CalendarContainerComponent,
        }, this.vcr, dpid, this.getHookContainer(fieldType));
    }
    getHookContainer(fieldType) {
        if (this.window.isDesktop(true) || fieldType === 'field') {
            return this.containerRef;
        }
        else if (fieldType === 'fromField') {
            return this.fromContainer;
        }
        else {
            return this.toContainer;
        }
    }
    ngOnInit() { }
    ngAfterContentInit() {
        this.setConfigForInputs(this.blockedDates, this.minDate, this.maxDate);
        if (this.field) {
            this.field?.formField.datepickerClick$
                .pipe(takeUntil(this.destroy$))
                .subscribe((e) => {
                this.openDatepickerCalendar(e, 'field');
            });
        }
        else if (this.fromField && this.toField) {
            this.fromField.formField.datepickerClick$
                .pipe(takeUntil(this.destroy$))
                .subscribe((e) => this.openDatepickerCalendar(e, 'fromField'));
            this.toField.formField.datepickerClick$
                .pipe(takeUntil(this.destroy$))
                .subscribe((e) => this.openDatepickerCalendar(e, 'toField'));
        }
        // Run change detection if the control state changes
        this.stateChangeDetection();
        // Run change detection if the form control value changes
        this.ngControlChangeDetection();
    }
    stateChangeDetection() {
        combineLatest([
            this.fromField?.formField?._control?.stateChanges,
            this.toField?.formField?._control?.stateChanges,
            this.field?.formField?._control?.stateChanges,
        ].filter(Boolean))
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            this._changeDetectorRef.markForCheck();
        });
    }
    ngControlChangeDetection() {
        combineLatest([
            this.fromField?.formField?.dsInput?.ngControl?.valueChanges,
            this.toField?.formField?.dsInput?.ngControl?.valueChanges,
            this.field?.formField?.dsInput?.ngControl?.valueChanges,
        ].filter(Boolean))
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            this._changeDetectorRef.markForCheck();
        });
    }
    getDateFromInputValue() {
        return (this.field || this.fromField || this.toField).input.selectedDate;
    }
    setConfigForInputs(blockedDates, minDate, maxDate) {
        this.setInputConfig(this.field, blockedDates, minDate, maxDate);
        this.setInputConfig(this.fromField, blockedDates, minDate, maxDate);
        this.setInputConfig(this.toField, blockedDates, minDate, maxDate);
    }
    setInputConfig(field, blockedDates, minDate, maxDate) {
        if (field) {
            field.input.config = {
                blockedDates,
                minDate,
                maxDate,
            };
        }
    }
    selectedDateChangeHandler(e) { }
    blurKeyDetectionHandler(e) {
        this.datepickerService.close();
    }
    isRangePicker() {
        return !!this.fromField && !!this.toField;
    }
    ngOnDestroy() {
        this.blockedDates$.complete();
        this.minDate$.complete();
        this.maxDate$.complete();
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
DatepickerContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerContainerComponent, deps: [{ token: i1$1.WindowService }, { token: DatepickerService }, { token: i0.ViewContainerRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DatepickerContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: DatepickerContainerComponent, selector: "ds-datepicker-container", inputs: { blockedDateTitle: "blockedDateTitle", currentDateTitle: "currentDateTitle", language: "language", a11yDescriptionPrevious: "a11yDescriptionPrevious", a11yDescriptionNext: "a11yDescriptionNext", blockedDates: "blockedDates", minDate: "minDate", maxDate: "maxDate" }, host: { properties: { "class.-range-picker": "isRangePicker()", "class.w-100": "true", "class.d-flex": "true", "class.align-items-stretch": "true" } }, queries: [{ propertyName: "fromField", first: true, predicate: DatepickerFromDirective, descendants: true }, { propertyName: "toField", first: true, predicate: DatepickerToDirective, descendants: true }, { propertyName: "field", first: true, predicate: DatepickerFieldDirective, descendants: true }], viewQueries: [{ propertyName: "containerRef", first: true, predicate: ["containerRef"], descendants: true }, { propertyName: "fromContainer", first: true, predicate: ["fromContainer"], descendants: true }, { propertyName: "toContainer", first: true, predicate: ["toContainer"], descendants: true }], ngImport: i0, template: "<div class=\"w-100\">\n  <div\n    class=\"d-flex flex-column flex-md-row align-items-stretch w-100\"\n    *ngIf=\"isRangePicker()\"\n    #containerRef\n  >\n    <div\n      cdkMonitorSubtreeFocus\n      class=\"dp-field-wrapper d-flex flex-column flex-md-row align-items-stretch w-100\"\n    >\n      <div\n        class=\"flex-grow-1 ds-dp-from\"\n        #fromContainer\n      >\n        <ng-content select=\"[ds-datepicker-from]\"></ng-content>\n      </div>\n      <div\n        class=\"flex-grow-1 mt-8 mt-md-0 ds-dp-to\"\n        #toContainer\n      >\n        <ng-content select=\"[ds-datepicker-to]\"></ng-content>\n      </div>\n    </div>\n    <button\n      *ifMediaMatch=\"[MediaBreakpoints.Desktop]\"\n      ds-button\n      #trigger\n      type=\"button\"\n      variant=\"icon\"\n      [disabled]=\"disabled || undefined\"\n      [transparent]=\"true\"\n      (click)=\"openDatepickerCalendar($event)\"\n      (keydown.space)=\"openDatepickerCalendar($event)\"\n    >\n      <ds-icon [name]=\"'calendar'\"></ds-icon>\n    </button>\n  </div>\n  <div\n    *ngIf=\"!isRangePicker()\"\n    #containerRef\n    class=\"w-100\"\n  >\n    <div>\n      <ng-content select=\"[ds-datepicker-field]\"></ng-content>\n    </div>\n  </div>\n  <div>\n    <ng-content select=\"ds-error\"></ng-content>\n  </div>\n</div>\n", components: [{ type: i2$1.ButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["variant", "size", "alignIcon", "img", "transparent", "disabled", "tabIndex", "a11yDescription"] }, { type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$1.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }, { type: i5.MediaMatchDirective, selector: "[ifMediaMatch]", inputs: ["ifMediaMatch", "ifMediaMatchThen", "ifMediaMatchElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DatepickerContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-datepicker-container', changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class.-range-picker]': 'isRangePicker()',
                        '[class.w-100]': 'true',
                        '[class.d-flex]': 'true',
                        '[class.align-items-stretch]': 'true',
                    }, template: "<div class=\"w-100\">\n  <div\n    class=\"d-flex flex-column flex-md-row align-items-stretch w-100\"\n    *ngIf=\"isRangePicker()\"\n    #containerRef\n  >\n    <div\n      cdkMonitorSubtreeFocus\n      class=\"dp-field-wrapper d-flex flex-column flex-md-row align-items-stretch w-100\"\n    >\n      <div\n        class=\"flex-grow-1 ds-dp-from\"\n        #fromContainer\n      >\n        <ng-content select=\"[ds-datepicker-from]\"></ng-content>\n      </div>\n      <div\n        class=\"flex-grow-1 mt-8 mt-md-0 ds-dp-to\"\n        #toContainer\n      >\n        <ng-content select=\"[ds-datepicker-to]\"></ng-content>\n      </div>\n    </div>\n    <button\n      *ifMediaMatch=\"[MediaBreakpoints.Desktop]\"\n      ds-button\n      #trigger\n      type=\"button\"\n      variant=\"icon\"\n      [disabled]=\"disabled || undefined\"\n      [transparent]=\"true\"\n      (click)=\"openDatepickerCalendar($event)\"\n      (keydown.space)=\"openDatepickerCalendar($event)\"\n    >\n      <ds-icon [name]=\"'calendar'\"></ds-icon>\n    </button>\n  </div>\n  <div\n    *ngIf=\"!isRangePicker()\"\n    #containerRef\n    class=\"w-100\"\n  >\n    <div>\n      <ng-content select=\"[ds-datepicker-field]\"></ng-content>\n    </div>\n  </div>\n  <div>\n    <ng-content select=\"ds-error\"></ng-content>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.WindowService }, { type: DatepickerService }, { type: i0.ViewContainerRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { blockedDateTitle: [{
                type: Input
            }], currentDateTitle: [{
                type: Input
            }], language: [{
                type: Input
            }], a11yDescriptionPrevious: [{
                type: Input
            }], a11yDescriptionNext: [{
                type: Input
            }], blockedDates: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], fromField: [{
                type: ContentChild,
                args: [DatepickerFromDirective, {
                        static: false,
                    }]
            }], toField: [{
                type: ContentChild,
                args: [DatepickerToDirective, {
                        static: false,
                    }]
            }], field: [{
                type: ContentChild,
                args: [DatepickerFieldDirective, {
                        static: false,
                    }]
            }], containerRef: [{
                type: ViewChild,
                args: ['containerRef', { static: false }]
            }], fromContainer: [{
                type: ViewChild,
                args: ['fromContainer', { static: false }]
            }], toContainer: [{
                type: ViewChild,
                args: ['toContainer', { static: false }]
            }] } });

class FileInputDirective {
    constructor(_element, cdr, windowService) {
        this._element = _element;
        this.cdr = cdr;
        this.windowService = windowService;
        this._maxSize = null;
        this.destroy$ = new Subject();
        this.cachedFiles = new DataTransfer().files;
        this.fileChange = new EventEmitter();
    }
    get type() {
        return this.element.type || this._type;
    }
    set type(value) {
        if (value !== 'file') {
            console.warn(`Input type ${value} is not supported by dsFile. Falling back to type 'file'.`);
        }
        this._type = 'file'; // always set to file
        this.element.type = 'file';
    }
    /** Max size accepts value in KiloByte */
    get maxSize() {
        return this._maxSize;
    }
    set maxSize(value) {
        this._maxSize = coerceNumberProperty(value) * 1024; // Convert KB to Byte for native compatibility
    }
    get files() {
        if (!this.windowService.isBrowser())
            return null;
        return this.cachedFiles;
    }
    set files(fileList) {
        if (!this.windowService.isBrowser())
            return;
        this.element.files = fileList;
        this.cachedFiles = fileList;
        this.fileChange.emit(fileList);
        this.cdr.detectChanges();
    }
    get element() {
        return this._element.nativeElement;
    }
    ngOnInit() { }
    setFiles(files) {
        this.files = this.createFileRefList(files);
    }
    onFileChange(e) {
        const fileList = e.target.files;
        this.pushFiles(fileList);
    }
    coerceFileList(files) {
        if (!this.windowService.isBrowser())
            return null;
        const dt = new DataTransfer();
        files.forEach((f) => dt.items.add(f));
        return dt.files;
    }
    remove(file) {
        const filtered = Array.from(this.files).filter((f) => !this.isSameFile(f, file));
        this.setFiles(filtered);
    }
    createFileRefList(files) {
        const filesArr = Array.from(files);
        for (const file of filesArr) {
            const type = this.isFileTypeValid(file);
            const size = this.isFileSizeValid(file);
            file.meta = {
                valid: type && size,
                accept: this.accept,
                originalFile: file,
                name: file.name.split('.').slice(0, -1).join('.'),
                extension: file.name.split('.').pop(),
                errors: { type: !type, size: !size },
            };
        }
        return this.coerceFileList(filesArr);
    }
    pushFiles(files) {
        const appendedFiles = this.uniqueAppend(Array.from(files));
        this.setFiles(appendedFiles);
    }
    isFileTypeValid(file) {
        if (!this.accept)
            return true;
        const regex = new RegExp(this.accept.replace(/,/g, '|'));
        return regex.test(file.type);
    }
    isFileSizeValid(file) {
        if (this.maxSize === null)
            return true;
        return file.size <= this.maxSize;
    }
    uniqueAppend(fList) {
        const files = Array.from(this.files);
        const uniqueFiles = [];
        for (let i = 0; i < fList.length; i++) {
            const file = fList[i];
            if (!files.find((f) => this.isSameFile(f, file))) {
                uniqueFiles.push(file);
            }
        }
        return files.concat(uniqueFiles);
    }
    isSameFile(a, b) {
        return (a.name === b.name &&
            a.lastModified === b.lastModified &&
            a.size === b.size &&
            a.type === b.type);
    }
    ngOnDestroy() {
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
FileInputDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FileInputDirective, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1$1.WindowService }], target: i0.ɵɵFactoryTarget.Directive });
FileInputDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: FileInputDirective, selector: "input[dsFile]", inputs: { type: "type", accept: "accept", maxSize: "maxSize" }, outputs: { fileChange: "fileChange" }, host: { listeners: { "change": "onFileChange($event)" }, properties: { "attr.input": "file" } }, exportAs: ["dsFile"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FileInputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[dsFile]',
                    exportAs: 'dsFile',
                    host: {
                        '(change)': 'onFileChange($event)',
                        '[attr.input]': 'file',
                    },
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1$1.WindowService }]; }, propDecorators: { fileChange: [{
                type: Output
            }], type: [{
                type: Input
            }], accept: [{
                type: Input
            }], maxSize: [{
                type: Input
            }] } });

class FileUploadComponent {
    constructor(ngZone, cdr, cdkCore, utilsService, windowService, ngControl) {
        this.ngZone = ngZone;
        this.cdr = cdr;
        this.cdkCore = cdkCore;
        this.utilsService = utilsService;
        this.windowService = windowService;
        this.ngControl = ngControl;
        this.dragActive = false;
        this.destroy$ = new Subject();
        this.onTouched = () => { };
        this._controlValueAccessorChangeFn = () => { };
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
        this.brand = this.cdkCore.brand;
        this.setupResizeObserver();
    }
    ngOnInit() {
        this.subscribeDragEvents();
        this.cdkCore.config$.pipe(takeUntil(this.destroy$)).subscribe((o) => {
            this.brand = o.brand;
        });
    }
    ngAfterContentInit() {
        this.fileInput.fileChange
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.onFileChange());
        if (this.resizeObserver) {
            this.resizeObserver.observe(this.fileNameGroup.nativeElement);
        }
        if (!this.ngControl) {
            return;
        }
        const required = this.fileInput.element.required;
        if (required) {
            this.ngControl.control.setValidators(Validators.compose([Validators.required, this.fileValidator.bind(this)]));
        }
        else {
            this.ngControl.control.setValidators(this.fileValidator.bind(this));
        }
        this.ngControl.control.updateValueAndValidity();
    }
    setupResizeObserver() {
        const resizeObs = this.utilsService.getResizeObserver();
        if (!resizeObs) {
            return;
        }
        this.resizeObserver = new resizeObs(() => {
            this.ngZone.runOutsideAngular(() => {
                this.resizeObserverHandler();
            });
        });
    }
    writeValue(obj) {
        if (this.fileInput) {
            this.fileInput.files = obj;
        }
    }
    registerOnChange(fn) {
        this._controlValueAccessorChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.fileInput.element.disabled = isDisabled;
    }
    openFileDialog(e) {
        this.fileInput.element.click();
        this.onTouched();
    }
    remove(file) {
        this.fileInput.remove(file);
        this._controlValueAccessorChangeFn(this.fileInput.files);
    }
    resizeObserverHandler() {
        const rect = this.fileNameGroup.nativeElement.getBoundingClientRect();
        this.fileNameGroup.nativeElement.style.setProperty('--file-upload-filegroup-width', `${rect.width - 48}px`);
    }
    subscribeDragEvents() {
        this.ngZone.runOutsideAngular(() => {
            fromEvent(this.dragDropContainer.nativeElement, 'dragenter')
                .pipe(takeUntil(this.destroy$))
                .subscribe((e) => this.dragEnter(e));
            fromEvent(this.overlay.nativeElement, 'dragover')
                .pipe(takeUntil(this.destroy$))
                .subscribe((e) => this.dragOver(e));
            fromEvent(this.overlay.nativeElement, 'dragleave')
                .pipe(takeUntil(this.destroy$))
                .subscribe((e) => this.dragExit(e));
            fromEvent(this.overlay.nativeElement, 'drop')
                .pipe(takeUntil(this.destroy$))
                .subscribe((e) => this.drop(e));
        });
    }
    fileValidator(control) {
        if (!this.windowService.isBrowser())
            return null;
        const value = control.value ||
            new DataTransfer().files;
        const unsupportedFiles = Array.from(value).filter((f) => !(f.meta || {}).valid);
        if (unsupportedFiles.length > 0) {
            return {
                invalidFiles: unsupportedFiles,
            };
        }
        return null;
    }
    onFileChange() {
        this._controlValueAccessorChangeFn(this.fileInput.files);
        this.cdr.detectChanges();
    }
    dragOver(e) {
        e.preventDefault();
    }
    dragEnter(e) {
        e.preventDefault();
        this.dragActive = true;
        this.onTouched();
        this.cdr.detectChanges();
    }
    dragExit(e) {
        e.preventDefault();
        this.dragActive = false;
        this.cdr.detectChanges();
    }
    drop(e) {
        e.preventDefault();
        this.dragActive = false;
        this.fileInput.pushFiles(e.dataTransfer.files);
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        this.destroy$.next(void 0);
        this.destroy$.complete();
        this.resizeObserver.unobserve(this.fileNameGroup.nativeElement);
        this.resizeObserver.disconnect();
    }
}
FileUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FileUploadComponent, deps: [{ token: i0.NgZone }, { token: i0.ChangeDetectorRef }, { token: i2.CDKCoreService }, { token: i1$1.UtilsService }, { token: i1$1.WindowService }, { token: i3$3.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
FileUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: FileUploadComponent, selector: "ds-file-upload", inputs: { data: "data" }, queries: [{ propertyName: "fileInput", first: true, predicate: FileInputDirective, descendants: true }], viewQueries: [{ propertyName: "dragDropContainer", first: true, predicate: ["dragDropContainer"], descendants: true, static: true }, { propertyName: "fileNameGroup", first: true, predicate: ["fileNameGroup"], descendants: true, static: true }, { propertyName: "overlay", first: true, predicate: ["overlay"], descendants: true, static: true }], ngImport: i0, template: "<div>\n  <div\n    class=\"\n      drag-drop-container\n      d-flex\n      align-items-md-stretch\n      justify-content-center\n      flex-column-reverse flex-md-row-reverse\n      py-md-40\n      position-relative\n      ds-bgcolor-md-snow\n    \"\n    [ngClass]=\"{ '-dragActive': dragActive }\"\n    #dragDropContainer\n  >\n    <div\n      class=\"\n        overlay\n        position-absolute\n        ds-bgcolor-white-40\n        z-1\n        top-0\n        d-flex\n        justify-content-center\n        align-items-center\n        flex-column\n      \"\n      #overlay\n      aria-hidden=\"true\"\n    >\n      <ng-container\n        *ngTemplateOutlet=\"brand === 'fido' ? fidoUploadIcon : rogersUploadIcon\"\n      ></ng-container>\n      <span class=\"mt-8\">{{ data.overlayCopy }}</span>\n    </div>\n    <div class=\"mt-16 mt-md-0 d-flex align-items-stretch\" *ngIf=\"data?.note\">\n      <div\n        class=\"\n          hr-verticle\n          ds-borders\n          b-0\n          br-1\n          ds-brcolor-concrete\n          d-none d-md-block\n        \"\n      ></div>\n      <div\n        class=\"d-flex align-items-center pr-md-40 pl-md-48 mb-0 text-body-lg\"\n        [brClass]=\"[\n          ['text-medium', 'text-normal', 'text-medium', 'text-medium']\n        ]\"\n      >\n        {{ data?.note }}\n      </div>\n    </div>\n    <div class=\"d-flex align-items-stretch\">\n      <div class=\"pr-md-48 pl-md-40\">\n        <button\n          ds-button\n          type=\"button\"\n          variant=\"secondary\"\n          [a11yDescription]=\"data?.btnFile?.a11yDescription\"\n          (click)=\"openFileDialog($event)\"\n        >\n          {{ data?.btnFile?.copy }}\n        </button>\n        <div\n          class=\"mt-16 d-none d-md-block text-md-center text-body-lg mb-0\"\n          [brClass]=\"[\n            ['text-medium', 'text-normal', 'text-medium', 'text-medium']\n          ]\"\n          [attr.aria-hidden]=\"true\"\n        >\n          {{ data?.dragAndDropCopy }}\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-12 col-sm-9 col-md-10 col-lg-8 p-0\" #fileNameGroup>\n    <fieldset\n      class=\"file-list-container b-0\"\n      *ngIf=\"fileInput.files.length > 0\"\n    >\n      <legend class=\"cdk-visually-hidden\">{{ data.fileListHeading }}</legend>\n      <ng-container *ngFor=\"let file of fileInput.files\">\n        <div class=\"mt-24 mt-md-32\">\n          <div\n            class=\"d-flex justify-content-between ds-borders ds-bgcolor-white\"\n            [brClass]=\"[\n              ['ds-corners', '', 'ds-corners', 'ds-corners'],\n              [\n                'ds-brcolor-slate',\n                'ds-brcolor-black',\n                'ds-brcolor-slate',\n                'ds-brcolor-slate'\n              ]\n            ]\"\n            [ngClass]=\"{\n              'ds-brcolor-error': !file?.meta?.valid,\n              'ds-bgcolor-error-10': !file?.meta?.valid\n            }\"\n          >\n            <div class=\"d-flex align-items-center pl-16 file-upload-filename\">\n              <div class=\"ds-no-overflow\">{{ file?.meta?.name }}</div>\n              <div>.{{ file?.meta?.extension }}</div>\n            </div>\n            <button\n              ds-button\n              type=\"button\"\n              variant=\"icon\"\n              [transparent]=\"true\"\n              [a11yDescription]=\"data?.btnRemove?.a11yDescription\"\n              (click)=\"remove(file)\"\n            >\n              {{ data?.btnRemove?.copy }} {{ file.name }}\n              <ds-icon name=\"close\"></ds-icon>\n            </button>\n          </div>\n          <ds-error\n            *ngIf=\"file?.meta?.errors?.type\"\n            [errorMessage]=\"data.fileNotSupportedCopy\"\n          ></ds-error>\n          <ds-error\n            *ngIf=\"file?.meta?.errors?.size\"\n            [errorMessage]=\"data.fileSizeErrorCopy\"\n          ></ds-error>\n        </div>\n      </ng-container>\n    </fieldset>\n  </div>\n</div>\n<ng-template>\n  <ng-content select=\"[dsFile]\"></ng-content>\n</ng-template>\n\n<ng-template #rogersUploadIcon>\n  <svg\n    width=\"37px\"\n    height=\"40px\"\n    viewBox=\"0 0 37 40\"\n    version=\"1.1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n  >\n    <title>RDS / 48px / Upload</title>\n    <g\n      id=\"Data-Importer\"\n      stroke=\"none\"\n      stroke-width=\"1\"\n      fill=\"none\"\n      fill-rule=\"evenodd\"\n    >\n      <g\n        id=\"RDS-/-Data-Importer\"\n        transform=\"translate(-1339.000000, -889.000000)\"\n        fill=\"#414042\"\n        fill-rule=\"nonzero\"\n      >\n        <g\n          id=\"States-&amp;-Style-Variants\"\n          transform=\"translate(555.000000, 392.000000)\"\n        >\n          <g\n            id=\"Drag-&amp;-drop-effect\"\n            transform=\"translate(226.000000, 453.000000)\"\n          >\n            <g\n              id=\"Pictogram-Colour\"\n              transform=\"translate(552.000000, 40.000000)\"\n            >\n              <path\n                d=\"M42.75,25.8937831 L42.75,40.8937831 C42.75,42.0920438 41.81331,43.0715288 40.6322046,43.1399636 L40.5,43.1437831 L8.25,43.1437831 C7.05173934,43.1437831 6.07225434,42.2070932 6.00381952,41.0259877 L6,40.8937831 L6,25.8937831 C6.82842712,25.8937831 7.5,26.565356 7.5,27.3937831 L7.5,40.8937831 C7.5,41.27841 7.78953014,41.5954135 8.16253416,41.6387373 L8.25,41.6437831 L40.5,41.6437831 C40.8846269,41.6437831 41.2016304,41.354253 41.2449542,40.981249 L41.25,40.8937831 L41.25,27.3937831 C41.25,26.614087 41.8448881,25.9733344 42.60554,25.9006497 L42.75,25.8937831 Z M27.0106214,37.1525631 L28.31982,37.8846825 C27.9585379,38.5307384 27.3020681,38.9607485 26.5605462,39.0282528 L26.3880116,39.0373291 L26.3663756,37.5374851 C26.6369454,37.533582 26.8804248,37.3853846 27.0106214,37.1525631 Z M24.8959605,37.5375663 L24.8959605,39.0375663 L23.3959605,39.0375663 L23.3959605,37.5375663 L24.8959605,37.5375663 Z M25.4026561,5.3057291 C25.5704461,5.42416911 25.72103,5.56488302 25.8503536,5.72381658 L25.9432966,5.8463696 L32.0484156,14.4952881 C32.7650256,15.5104856 32.5229726,16.914393 31.5077751,17.631003 C31.1703417,17.8691913 30.7747143,18.0093242 30.3646172,18.0375242 L30.2102379,18.0428253 L28.605,18.0427213 L28.6051189,30.0428253 L27.1051189,30.0428253 L27.1051189,16.5428253 L30.2102379,16.5428253 C30.3651247,16.5428253 30.5162127,16.4948718 30.6427503,16.4055512 C30.9551187,16.1850558 31.0478959,15.7693517 30.8724432,15.4405418 L30.8229638,15.3603129 L24.7178448,6.7113944 C24.6684948,6.64148189 24.6075438,6.5805309 24.5376313,6.5311809 C24.2252629,6.31068551 23.8024916,6.36247311 23.5514205,6.63790525 L23.492393,6.7113944 L17.3872741,15.3603129 C17.2979535,15.4868504 17.25,15.6379385 17.25,15.7928253 C17.25,16.1774522 17.5395301,16.4944557 17.9125342,16.5377795 L18,16.5428253 L21.1051189,16.5428253 L21.1051189,37.5428253 C20.2766918,37.5428253 19.6051189,36.8712524 19.6051189,36.0428253 L19.605,18.0427213 L18,18.0428253 C16.7573593,18.0428253 15.75,17.035466 15.75,15.7928253 C15.75,15.3797939 15.8636675,14.9757668 16.0771252,14.6244681 L16.1618223,14.4952881 L22.2669412,5.8463696 C22.9835512,4.83117209 24.3874586,4.5891191 25.4026561,5.3057291 Z M28.6051189,34.5428253 L28.6051189,36.0428253 L27.1051189,36.0428253 L27.1051189,34.5428253 L28.6051189,34.5428253 Z M28.6051189,31.5428253 L28.6051189,33.0428253 L27.1051189,33.0428253 L27.1051189,31.5428253 L28.6051189,31.5428253 Z\"\n              ></path>\n            </g>\n          </g>\n        </g>\n      </g>\n    </g>\n  </svg>\n</ng-template>\n\n<ng-template #fidoUploadIcon>\n  <svg\n    width=\"48px\"\n    height=\"32px\"\n    viewBox=\"0 0 48 32\"\n    version=\"1.1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n  >\n    <title>Actions / FDS / 48 / Backup</title>\n    <g\n      id=\"Data-Importer\"\n      stroke=\"none\"\n      stroke-width=\"1\"\n      fill=\"none\"\n      fill-rule=\"evenodd\"\n    >\n      <g\n        id=\"FDS-/-Data-Importer\"\n        transform=\"translate(-1333.000000, -893.000000)\"\n        fill-rule=\"nonzero\"\n      >\n        <g\n          id=\"States-&amp;-Style-Variants\"\n          transform=\"translate(555.000000, 392.000000)\"\n        >\n          <g\n            id=\"Drag-&amp;-drop-effect\"\n            transform=\"translate(226.000000, 453.000000)\"\n          >\n            <g id=\"Group\" transform=\"translate(552.000000, 40.000000)\">\n              <rect id=\"Bounding-Box\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect>\n              <path\n                d=\"M38.7,20.08 C37.34,13.18 31.28,8 24,8 C18.22,8 13.2,11.28 10.7,16.08 C4.68,16.72 0,21.82 0,28 C0,34.62 5.38,40 12,40 L38,40 C43.52,40 48,35.52 48,30 C48,24.72 43.9,20.44 38.7,20.08 Z M38,36 L12,36 C7.58,36 4,32.42 4,28 C4,23.9 7.06,20.48 11.12,20.06 L13.26,19.84 L14.26,17.94 C16.16,14.28 19.88,12 24,12 C29.24,12 33.76,15.72 34.78,20.86 L35.38,23.86 L38.44,24.08 C41.56,24.28 44,26.9 44,30 C44,33.3 41.3,36 38,36 Z M16,26 L21.1,26 L21.1,32 L26.9,32 L26.9,26 L32,26 L24,18 L16,26 Z\"\n                id=\"\uD83C\uDFA8-Icon-Colour\"\n                fill=\"#000000\"\n              ></path>\n            </g>\n          </g>\n        </g>\n      </g>\n    </g>\n  </svg>\n</ng-template>\n", components: [{ type: i2$1.ButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["variant", "size", "alignIcon", "img", "transparent", "disabled", "tabIndex", "a11yDescription"] }, { type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }, { type: ErrorComponent, selector: "ds-error", inputs: ["errorMessage"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.BrandClassDirective, selector: "[brClass]", inputs: ["brClass"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-file-upload', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\n  <div\n    class=\"\n      drag-drop-container\n      d-flex\n      align-items-md-stretch\n      justify-content-center\n      flex-column-reverse flex-md-row-reverse\n      py-md-40\n      position-relative\n      ds-bgcolor-md-snow\n    \"\n    [ngClass]=\"{ '-dragActive': dragActive }\"\n    #dragDropContainer\n  >\n    <div\n      class=\"\n        overlay\n        position-absolute\n        ds-bgcolor-white-40\n        z-1\n        top-0\n        d-flex\n        justify-content-center\n        align-items-center\n        flex-column\n      \"\n      #overlay\n      aria-hidden=\"true\"\n    >\n      <ng-container\n        *ngTemplateOutlet=\"brand === 'fido' ? fidoUploadIcon : rogersUploadIcon\"\n      ></ng-container>\n      <span class=\"mt-8\">{{ data.overlayCopy }}</span>\n    </div>\n    <div class=\"mt-16 mt-md-0 d-flex align-items-stretch\" *ngIf=\"data?.note\">\n      <div\n        class=\"\n          hr-verticle\n          ds-borders\n          b-0\n          br-1\n          ds-brcolor-concrete\n          d-none d-md-block\n        \"\n      ></div>\n      <div\n        class=\"d-flex align-items-center pr-md-40 pl-md-48 mb-0 text-body-lg\"\n        [brClass]=\"[\n          ['text-medium', 'text-normal', 'text-medium', 'text-medium']\n        ]\"\n      >\n        {{ data?.note }}\n      </div>\n    </div>\n    <div class=\"d-flex align-items-stretch\">\n      <div class=\"pr-md-48 pl-md-40\">\n        <button\n          ds-button\n          type=\"button\"\n          variant=\"secondary\"\n          [a11yDescription]=\"data?.btnFile?.a11yDescription\"\n          (click)=\"openFileDialog($event)\"\n        >\n          {{ data?.btnFile?.copy }}\n        </button>\n        <div\n          class=\"mt-16 d-none d-md-block text-md-center text-body-lg mb-0\"\n          [brClass]=\"[\n            ['text-medium', 'text-normal', 'text-medium', 'text-medium']\n          ]\"\n          [attr.aria-hidden]=\"true\"\n        >\n          {{ data?.dragAndDropCopy }}\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-12 col-sm-9 col-md-10 col-lg-8 p-0\" #fileNameGroup>\n    <fieldset\n      class=\"file-list-container b-0\"\n      *ngIf=\"fileInput.files.length > 0\"\n    >\n      <legend class=\"cdk-visually-hidden\">{{ data.fileListHeading }}</legend>\n      <ng-container *ngFor=\"let file of fileInput.files\">\n        <div class=\"mt-24 mt-md-32\">\n          <div\n            class=\"d-flex justify-content-between ds-borders ds-bgcolor-white\"\n            [brClass]=\"[\n              ['ds-corners', '', 'ds-corners', 'ds-corners'],\n              [\n                'ds-brcolor-slate',\n                'ds-brcolor-black',\n                'ds-brcolor-slate',\n                'ds-brcolor-slate'\n              ]\n            ]\"\n            [ngClass]=\"{\n              'ds-brcolor-error': !file?.meta?.valid,\n              'ds-bgcolor-error-10': !file?.meta?.valid\n            }\"\n          >\n            <div class=\"d-flex align-items-center pl-16 file-upload-filename\">\n              <div class=\"ds-no-overflow\">{{ file?.meta?.name }}</div>\n              <div>.{{ file?.meta?.extension }}</div>\n            </div>\n            <button\n              ds-button\n              type=\"button\"\n              variant=\"icon\"\n              [transparent]=\"true\"\n              [a11yDescription]=\"data?.btnRemove?.a11yDescription\"\n              (click)=\"remove(file)\"\n            >\n              {{ data?.btnRemove?.copy }} {{ file.name }}\n              <ds-icon name=\"close\"></ds-icon>\n            </button>\n          </div>\n          <ds-error\n            *ngIf=\"file?.meta?.errors?.type\"\n            [errorMessage]=\"data.fileNotSupportedCopy\"\n          ></ds-error>\n          <ds-error\n            *ngIf=\"file?.meta?.errors?.size\"\n            [errorMessage]=\"data.fileSizeErrorCopy\"\n          ></ds-error>\n        </div>\n      </ng-container>\n    </fieldset>\n  </div>\n</div>\n<ng-template>\n  <ng-content select=\"[dsFile]\"></ng-content>\n</ng-template>\n\n<ng-template #rogersUploadIcon>\n  <svg\n    width=\"37px\"\n    height=\"40px\"\n    viewBox=\"0 0 37 40\"\n    version=\"1.1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n  >\n    <title>RDS / 48px / Upload</title>\n    <g\n      id=\"Data-Importer\"\n      stroke=\"none\"\n      stroke-width=\"1\"\n      fill=\"none\"\n      fill-rule=\"evenodd\"\n    >\n      <g\n        id=\"RDS-/-Data-Importer\"\n        transform=\"translate(-1339.000000, -889.000000)\"\n        fill=\"#414042\"\n        fill-rule=\"nonzero\"\n      >\n        <g\n          id=\"States-&amp;-Style-Variants\"\n          transform=\"translate(555.000000, 392.000000)\"\n        >\n          <g\n            id=\"Drag-&amp;-drop-effect\"\n            transform=\"translate(226.000000, 453.000000)\"\n          >\n            <g\n              id=\"Pictogram-Colour\"\n              transform=\"translate(552.000000, 40.000000)\"\n            >\n              <path\n                d=\"M42.75,25.8937831 L42.75,40.8937831 C42.75,42.0920438 41.81331,43.0715288 40.6322046,43.1399636 L40.5,43.1437831 L8.25,43.1437831 C7.05173934,43.1437831 6.07225434,42.2070932 6.00381952,41.0259877 L6,40.8937831 L6,25.8937831 C6.82842712,25.8937831 7.5,26.565356 7.5,27.3937831 L7.5,40.8937831 C7.5,41.27841 7.78953014,41.5954135 8.16253416,41.6387373 L8.25,41.6437831 L40.5,41.6437831 C40.8846269,41.6437831 41.2016304,41.354253 41.2449542,40.981249 L41.25,40.8937831 L41.25,27.3937831 C41.25,26.614087 41.8448881,25.9733344 42.60554,25.9006497 L42.75,25.8937831 Z M27.0106214,37.1525631 L28.31982,37.8846825 C27.9585379,38.5307384 27.3020681,38.9607485 26.5605462,39.0282528 L26.3880116,39.0373291 L26.3663756,37.5374851 C26.6369454,37.533582 26.8804248,37.3853846 27.0106214,37.1525631 Z M24.8959605,37.5375663 L24.8959605,39.0375663 L23.3959605,39.0375663 L23.3959605,37.5375663 L24.8959605,37.5375663 Z M25.4026561,5.3057291 C25.5704461,5.42416911 25.72103,5.56488302 25.8503536,5.72381658 L25.9432966,5.8463696 L32.0484156,14.4952881 C32.7650256,15.5104856 32.5229726,16.914393 31.5077751,17.631003 C31.1703417,17.8691913 30.7747143,18.0093242 30.3646172,18.0375242 L30.2102379,18.0428253 L28.605,18.0427213 L28.6051189,30.0428253 L27.1051189,30.0428253 L27.1051189,16.5428253 L30.2102379,16.5428253 C30.3651247,16.5428253 30.5162127,16.4948718 30.6427503,16.4055512 C30.9551187,16.1850558 31.0478959,15.7693517 30.8724432,15.4405418 L30.8229638,15.3603129 L24.7178448,6.7113944 C24.6684948,6.64148189 24.6075438,6.5805309 24.5376313,6.5311809 C24.2252629,6.31068551 23.8024916,6.36247311 23.5514205,6.63790525 L23.492393,6.7113944 L17.3872741,15.3603129 C17.2979535,15.4868504 17.25,15.6379385 17.25,15.7928253 C17.25,16.1774522 17.5395301,16.4944557 17.9125342,16.5377795 L18,16.5428253 L21.1051189,16.5428253 L21.1051189,37.5428253 C20.2766918,37.5428253 19.6051189,36.8712524 19.6051189,36.0428253 L19.605,18.0427213 L18,18.0428253 C16.7573593,18.0428253 15.75,17.035466 15.75,15.7928253 C15.75,15.3797939 15.8636675,14.9757668 16.0771252,14.6244681 L16.1618223,14.4952881 L22.2669412,5.8463696 C22.9835512,4.83117209 24.3874586,4.5891191 25.4026561,5.3057291 Z M28.6051189,34.5428253 L28.6051189,36.0428253 L27.1051189,36.0428253 L27.1051189,34.5428253 L28.6051189,34.5428253 Z M28.6051189,31.5428253 L28.6051189,33.0428253 L27.1051189,33.0428253 L27.1051189,31.5428253 L28.6051189,31.5428253 Z\"\n              ></path>\n            </g>\n          </g>\n        </g>\n      </g>\n    </g>\n  </svg>\n</ng-template>\n\n<ng-template #fidoUploadIcon>\n  <svg\n    width=\"48px\"\n    height=\"32px\"\n    viewBox=\"0 0 48 32\"\n    version=\"1.1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n  >\n    <title>Actions / FDS / 48 / Backup</title>\n    <g\n      id=\"Data-Importer\"\n      stroke=\"none\"\n      stroke-width=\"1\"\n      fill=\"none\"\n      fill-rule=\"evenodd\"\n    >\n      <g\n        id=\"FDS-/-Data-Importer\"\n        transform=\"translate(-1333.000000, -893.000000)\"\n        fill-rule=\"nonzero\"\n      >\n        <g\n          id=\"States-&amp;-Style-Variants\"\n          transform=\"translate(555.000000, 392.000000)\"\n        >\n          <g\n            id=\"Drag-&amp;-drop-effect\"\n            transform=\"translate(226.000000, 453.000000)\"\n          >\n            <g id=\"Group\" transform=\"translate(552.000000, 40.000000)\">\n              <rect id=\"Bounding-Box\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect>\n              <path\n                d=\"M38.7,20.08 C37.34,13.18 31.28,8 24,8 C18.22,8 13.2,11.28 10.7,16.08 C4.68,16.72 0,21.82 0,28 C0,34.62 5.38,40 12,40 L38,40 C43.52,40 48,35.52 48,30 C48,24.72 43.9,20.44 38.7,20.08 Z M38,36 L12,36 C7.58,36 4,32.42 4,28 C4,23.9 7.06,20.48 11.12,20.06 L13.26,19.84 L14.26,17.94 C16.16,14.28 19.88,12 24,12 C29.24,12 33.76,15.72 34.78,20.86 L35.38,23.86 L38.44,24.08 C41.56,24.28 44,26.9 44,30 C44,33.3 41.3,36 38,36 Z M16,26 L21.1,26 L21.1,32 L26.9,32 L26.9,26 L32,26 L24,18 L16,26 Z\"\n                id=\"\uD83C\uDFA8-Icon-Colour\"\n                fill=\"#000000\"\n              ></path>\n            </g>\n          </g>\n        </g>\n      </g>\n    </g>\n  </svg>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: i0.ChangeDetectorRef }, { type: i2.CDKCoreService }, { type: i1$1.UtilsService }, { type: i1$1.WindowService }, { type: i3$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }]; }, propDecorators: { data: [{
                type: Input
            }], fileInput: [{
                type: ContentChild,
                args: [FileInputDirective, { static: false }]
            }], dragDropContainer: [{
                type: ViewChild,
                args: ['dragDropContainer', { static: true }]
            }], fileNameGroup: [{
                type: ViewChild,
                args: ['fileNameGroup', { static: true }]
            }], overlay: [{
                type: ViewChild,
                args: ['overlay', { static: true }]
            }] } });

class FormGroupComponent {
    constructor() { }
    ngOnInit() { }
}
FormGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: FormGroupComponent, selector: "ds-form-group", inputs: { legend: "legend", showLegend: "showLegend" }, ngImport: i0, template: "<fieldset class=\"b-0\">\n  <legend\n    class=\"text-body mb-0\"\n    [ngClass]=\"{ 'cdk-visually-hidden': !showLegend }\"\n  >\n    <ng-container *ngIf=\"legend; else legendTemplate\">\n      {{ legend }}\n    </ng-container>\n  </legend>\n  <ng-content></ng-content>\n</fieldset>\n\n<ng-template #legendTemplate>\n  <ng-content select=\"[legend]\"></ng-content>\n</ng-template>\n", directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
__decorate([
    Default(false)
], FormGroupComponent.prototype, "showLegend", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-form-group', template: "<fieldset class=\"b-0\">\n  <legend\n    class=\"text-body mb-0\"\n    [ngClass]=\"{ 'cdk-visually-hidden': !showLegend }\"\n  >\n    <ng-container *ngIf=\"legend; else legendTemplate\">\n      {{ legend }}\n    </ng-container>\n  </legend>\n  <ng-content></ng-content>\n</fieldset>\n\n<ng-template #legendTemplate>\n  <ng-content select=\"[legend]\"></ng-content>\n</ng-template>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { legend: [{
                type: Input
            }], showLegend: [{
                type: Input
            }] } });

class AutoCompleteHighlight {
    constructor() {
        this.regexToStripTags = /(<([^>]+)>)/gi;
    }
    transform(text, value) {
        const str = text.replace(this.regexToStripTags, '');
        const regex = new RegExp(`(${value})`, 'ig');
        return str.replace(regex, `<strong>$1</strong>`);
    }
}
AutoCompleteHighlight.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AutoCompleteHighlight, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
AutoCompleteHighlight.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AutoCompleteHighlight, name: "autoCompleteHighlight" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AutoCompleteHighlight, decorators: [{
            type: Pipe,
            args: [{ name: 'autoCompleteHighlight' }]
        }], ctorParameters: function () { return []; } });

var IncrementalCounterAction;
(function (IncrementalCounterAction) {
    IncrementalCounterAction["init"] = "init";
    IncrementalCounterAction["add"] = "add";
    IncrementalCounterAction["subtract"] = "subtract";
})(IncrementalCounterAction || (IncrementalCounterAction = {}));

const MinimumAllowedValue = 0;
const MaximumAllowedValue = 999;
const DefaultInitialValue = 0;
class IncrementalCounterComponent {
    constructor(cdr, focusMonitor) {
        this.cdr = cdr;
        this.focusMonitor = focusMonitor;
        this.state$ = new BehaviorSubject(null);
        this.disableSubtract$ = new BehaviorSubject(true);
        this.disableAdd$ = new BehaviorSubject(true);
        this.interval = 1;
        this.valueChanged = new EventEmitter();
        this.valueError = new EventEmitter();
    }
    get minValue() {
        return this._minValue || MinimumAllowedValue;
    }
    set minValue(value) {
        if (value < MinimumAllowedValue) {
            this.valueError.emit(`minValue can't be less than ${MinimumAllowedValue}`);
            return;
        }
        this._minValue = value;
    }
    get maxValue() {
        return this._maxValue || MaximumAllowedValue;
    }
    set maxValue(value) {
        if (value > MaximumAllowedValue) {
            this.valueError.emit(`maxValue can't be greater than ${MaximumAllowedValue}`);
            return;
        }
        this._maxValue = value;
    }
    get initialValue() {
        return this._initialValue || DefaultInitialValue;
    }
    set initialValue(value) {
        if (value < this.minValue || value > this.maxValue) {
            this.valueError.emit(`initialValue can't be less than minValue or greater than maxValue`);
            return;
        }
        this._initialValue = value;
    }
    ngOnInit() {
        this.state$.next({
            action: IncrementalCounterAction.init,
            value: this.initialValue,
            ariaLiveLabel: '',
        });
        this.cdr.markForCheck();
        this.subscribeToValueChanges();
    }
    subscribeToValueChanges() {
        this.state$.subscribe((state) => {
            if (state.value > this.minValue) {
                this.disableSubtract$.next(false);
            }
            if (state.value < this.maxValue) {
                this.disableAdd$.next(false);
            }
            this.checkRemainder(state.value);
            this.checkTotal(state.value);
            this.cdr.detectChanges();
            this.valueChanged.emit({
                action: state.action,
                value: state.value,
            });
        });
    }
    checkTotal(newValue) {
        // If user can't do another addition, disable the add button
        const total = newValue + this.interval;
        if (total > this.maxValue) {
            this.disableAdd$.next(true);
            if (this.temporaryFocusHolder) {
                this.focusMonitor.focusVia(this.temporaryFocusHolder, 'keyboard');
            }
        }
    }
    checkRemainder(newValue) {
        // If user can't do another subtraction, disable the subtract button
        const remainder = newValue - this.interval;
        if (remainder < this.minValue) {
            this.disableSubtract$.next(true);
            if (this.temporaryFocusHolder) {
                this.focusMonitor.focusVia(this.temporaryFocusHolder, 'keyboard');
            }
        }
    }
    add() {
        const currentValue = this.state$.getValue().value;
        const newValue = currentValue + this.interval;
        this.state$.next({
            action: IncrementalCounterAction.add,
            value: newValue,
            ariaLiveLabel: this.a11y.addedAriaLiveLabel
                .replace('{0}', this.interval.toString())
                .replace('{1}', newValue.toString()),
        });
        this.checkTotal(newValue);
    }
    subtract() {
        const currentValue = this.state$.getValue().value;
        const newValue = currentValue - this.interval;
        this.state$.next({
            action: IncrementalCounterAction.subtract,
            value: newValue,
            ariaLiveLabel: this.a11y.subtractedAriaLiveLabel
                .replace('{0}', this.interval.toString())
                .replace('{1}', newValue.toString()),
        });
        this.checkRemainder(newValue);
    }
    ngOnDestroy() {
        this.state$.unsubscribe();
    }
}
IncrementalCounterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: IncrementalCounterComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1.FocusMonitor }], target: i0.ɵɵFactoryTarget.Component });
IncrementalCounterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: IncrementalCounterComponent, selector: "ds-incremental-counter", inputs: { a11y: "a11y", minValue: "minValue", maxValue: "maxValue", initialValue: "initialValue", interval: "interval" }, outputs: { valueChanged: "valueChanged", valueError: "valueError" }, viewQueries: [{ propertyName: "temporaryFocusHolder", first: true, predicate: ["temporaryFocusHolder"], descendants: true }], ngImport: i0, template: "<div\n  class=\"ds-incremental-counter d-flex align-items-center\"\n  [attr.aria-label]=\"a11y.label\"\n  *ngIf=\"state$ | async as state\"\n>\n  <span class=\"sr-only\" aria-live=\"assertive\" [innerText]=\"state.ariaLiveLabel\">\n  </span>\n  <span #temporaryFocusHolder tabindex=\"-1\"></span>\n  <button\n    ds-button\n    variant=\"secondary\"\n    class=\"ds-corners-left\"\n    [attr.aria-label]=\"a11y.subtractButtonTitle\"\n    [disabled]=\"disableSubtract$ | async\"\n    (click)=\"subtract()\"\n  >\n    <ds-icon name=\"minus\"></ds-icon>\n  </button>\n  <span\n    class=\"display-text text-body-lg text-bold mb-0 ds-border-y ds-brcolor-concrete d-flex align-items-center justify-content-center\"\n    [innerText]=\"state.value\"\n  ></span>\n  <button\n    ds-button\n    variant=\"secondary\"\n    class=\"ds-corners-right\"\n    [attr.aria-label]=\"a11y.addButtonTitle\"\n    [disabled]=\"disableAdd$ | async\"\n    (click)=\"add()\"\n  >\n    <ds-icon name=\"plus\"></ds-icon>\n  </button>\n</div>\n", components: [{ type: i2$1.ButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["variant", "size", "alignIcon", "img", "transparent", "disabled", "tabIndex", "a11yDescription"] }, { type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i4.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    Required()
], IncrementalCounterComponent.prototype, "a11y", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: IncrementalCounterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-incremental-counter', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"ds-incremental-counter d-flex align-items-center\"\n  [attr.aria-label]=\"a11y.label\"\n  *ngIf=\"state$ | async as state\"\n>\n  <span class=\"sr-only\" aria-live=\"assertive\" [innerText]=\"state.ariaLiveLabel\">\n  </span>\n  <span #temporaryFocusHolder tabindex=\"-1\"></span>\n  <button\n    ds-button\n    variant=\"secondary\"\n    class=\"ds-corners-left\"\n    [attr.aria-label]=\"a11y.subtractButtonTitle\"\n    [disabled]=\"disableSubtract$ | async\"\n    (click)=\"subtract()\"\n  >\n    <ds-icon name=\"minus\"></ds-icon>\n  </button>\n  <span\n    class=\"display-text text-body-lg text-bold mb-0 ds-border-y ds-brcolor-concrete d-flex align-items-center justify-content-center\"\n    [innerText]=\"state.value\"\n  ></span>\n  <button\n    ds-button\n    variant=\"secondary\"\n    class=\"ds-corners-right\"\n    [attr.aria-label]=\"a11y.addButtonTitle\"\n    [disabled]=\"disableAdd$ | async\"\n    (click)=\"add()\"\n  >\n    <ds-icon name=\"plus\"></ds-icon>\n  </button>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.FocusMonitor }]; }, propDecorators: { a11y: [{
                type: Input
            }], minValue: [{
                type: Input
            }], maxValue: [{
                type: Input
            }], initialValue: [{
                type: Input
            }], interval: [{
                type: Input
            }], valueChanged: [{
                type: Output
            }], valueError: [{
                type: Output
            }], temporaryFocusHolder: [{
                type: ViewChild,
                args: ['temporaryFocusHolder', { static: false }]
            }] } });

class DSEmailDirective {
    validate(control) {
        return DSValidators.email(control);
    }
}
DSEmailDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DSEmailDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
DSEmailDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: DSEmailDirective, selector: "[dsEmail][formControlName],[dsEmail][formControl],[dsEmail][ngModel]", providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: DSEmailDirective,
            multi: true,
        },
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DSEmailDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dsEmail][formControlName],[dsEmail][formControl],[dsEmail][ngModel]',
                    providers: [
                        {
                            provide: NG_VALIDATORS,
                            useExisting: DSEmailDirective,
                            multi: true,
                        },
                    ],
                }]
        }] });

let uidRadioGroup = 0;
let uidRadio = 0;
const DS_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioGroupComponent),
    multi: true,
};
class RadioChange {
    constructor(source, value) {
        this.source = source;
        this.value = value;
    }
}
class RadioGroupComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this._value = null;
        this._name = `ds-radio-group-${uidRadioGroup++}`;
        this._selected = null;
        this._isInitialized = false;
        this._disabled = false;
        this._required = false;
        this.change = new EventEmitter();
        this._controlValueAccessorChangeFn = () => { };
        this.onTouched = () => { };
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
        this.updateRadioButtonNames();
    }
    get value() {
        return this._value;
    }
    set value(newValue) {
        if (this._value !== newValue) {
            this._value = newValue;
            this.updateSelectedRadioFromValue();
            this.checkSelectedRadioButton();
        }
    }
    get selected() {
        return this._selected;
    }
    set selected(selected) {
        this._selected = selected;
        this.value = selected ? selected.value : null;
        this.checkSelectedRadioButton();
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        this.markRadiosForCheck();
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
        this.markRadiosForCheck();
    }
    ngOnInit() { }
    ngAfterContentInit() {
        this._isInitialized = true;
    }
    checkSelectedRadioButton() {
        if (this._selected && !this._selected.checked) {
            this._selected.checked = true;
        }
    }
    writeValue(obj) {
        this.value = obj;
        this.cdr.markForCheck();
    }
    registerOnChange(fn) {
        this._controlValueAccessorChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.cdr.markForCheck();
    }
    emitChangeEvent() {
        if (this._isInitialized) {
            this.change.emit(new RadioChange(this._selected || null, this._value));
        }
    }
    markRadiosForCheck() {
        if (this.radioList) {
            this.radioList.forEach((radio) => radio.markForCheck());
        }
    }
    touch() {
        if (this.onTouched) {
            this.onTouched();
        }
    }
    updateSelectedRadioFromValue() {
        const isAlreadySelected = this._selected !== null && this._selected.value === this._value;
        if (this.radioList && !isAlreadySelected) {
            this._selected = null;
            this.radioList.forEach((radio) => {
                radio.checked = this.value === radio.value;
                if (radio.checked) {
                    this._selected = radio;
                }
            });
        }
    }
    updateRadioButtonNames() {
        if (this.radioList) {
            this.radioList.forEach((radio) => {
                radio.name = this.name;
                radio.markForCheck();
            });
        }
    }
}
RadioGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RadioGroupComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
RadioGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: RadioGroupComponent, selector: "ds-radio-group", inputs: { ariaLabel: "ariaLabel", ariaLabelledby: "ariaLabelledby", name: "name", value: "value", selected: "selected", disabled: "disabled", required: "required" }, outputs: { change: "change" }, host: { properties: { "attr.role": "\"radiogroup\"", "attr.aria-label": "ariaLabel", "attr.aria-labelledby": "ariaLabelledby" } }, providers: [DS_RADIO_GROUP_CONTROL_VALUE_ACCESSOR], queries: [{ propertyName: "radioList", predicate: i0.forwardRef(function () { return RadioComponent; }), descendants: true }], ngImport: i0, template: ` <ng-content></ng-content> `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RadioGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ds-radio-group',
                    template: ` <ng-content></ng-content> `,
                    host: {
                        '[attr.role]': '"radiogroup"',
                        '[attr.aria-label]': 'ariaLabel',
                        '[attr.aria-labelledby]': 'ariaLabelledby',
                    },
                    providers: [DS_RADIO_GROUP_CONTROL_VALUE_ACCESSOR],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { ariaLabel: [{
                type: Input
            }], ariaLabelledby: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], selected: [{
                type: Input
            }], disabled: [{
                type: Input
            }], required: [{
                type: Input
            }], change: [{
                type: Output
            }], radioList: [{
                type: ContentChildren,
                args: [forwardRef(() => RadioComponent), { descendants: true }]
            }] } });
class RadioComponent {
    constructor(radioGroup, cdr, focusMonitor, radioDispatcher, element, windowService) {
        this.cdr = cdr;
        this.focusMonitor = focusMonitor;
        this.radioDispatcher = radioDispatcher;
        this.element = element;
        this.windowService = windowService;
        this.destroyed$ = new Subject();
        this.uniqueInputId = `ds-radio-input-id-${uidRadio++}`;
        this._id = '';
        this._checked = false;
        this._value = null;
        this.caption = null;
        this.change = new EventEmitter();
        this.removeUniqueSelectionListener = () => { };
        this.radioGroup = radioGroup;
        this.removeUniqueSelectionListener = radioDispatcher.listen((id, name) => {
            if (id !== this.id && name === this.name) {
                this.checked = false;
            }
        });
    }
    set id(id) {
        this._id = id || this.uniqueInputId;
        if (id) {
            this.hostId = id + '-host';
        }
    }
    get id() {
        return this._id;
    }
    get checked() {
        return this._checked;
    }
    set checked(value) {
        const newCheckedState = coerceBooleanProperty(value);
        if (this._checked !== newCheckedState) {
            this._checked = newCheckedState;
            if (newCheckedState &&
                this.radioGroup &&
                this.radioGroup.value !== this.value) {
                this.radioGroup.selected = this;
            }
            else if (!newCheckedState &&
                this.radioGroup &&
                this.radioGroup.value === this.value) {
                this.radioGroup.selected = null;
            }
            if (newCheckedState) {
                this.radioDispatcher.notify(this.id, this.name);
            }
            this.cdr.markForCheck();
        }
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
            if (this.radioGroup !== null) {
                if (!this.checked) {
                    this.checked = this.radioGroup.value === value;
                }
                if (this.checked) {
                    this.radioGroup.selected = this;
                }
            }
        }
    }
    get disabled() {
        return (this._disabled || (this.radioGroup !== null && this.radioGroup.disabled));
    }
    set disabled(value) {
        const newDisabledState = coerceBooleanProperty(value);
        if (this._disabled !== newDisabledState) {
            this._disabled = newDisabledState;
            this.cdr.markForCheck();
        }
    }
    get required() {
        return this._required || (this.radioGroup && this.radioGroup.required);
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    get inputId() {
        return this.id || this.uniqueInputId;
    }
    ngOnInit() {
        if (this.radioGroup) {
            this.checked = this.radioGroup.value === this._value;
            this.name = this.radioGroup.name;
        }
    }
    ngAfterViewInit() {
        this.focusMonitor
            .monitor(this.element, true)
            .pipe(takeUntil(this.destroyed$))
            .subscribe((focusOrigin) => {
            if (!focusOrigin && this.radioGroup) {
                this.radioGroup.touch();
            }
        });
    }
    ngOnDestroy() {
        this.destroyed$.next(void 0);
        this.destroyed$.complete();
        this.focusMonitor.stopMonitoring(this.element);
        this.removeUniqueSelectionListener();
    }
    isChrome() {
        return this.windowService.getBrowsers()['isChrome'];
    }
    onInputClick(event) {
        event.stopPropagation();
    }
    onInputChange(event) {
        event.stopPropagation();
        const groupValueChanged = this.radioGroup && this.value !== this.radioGroup.value;
        this.checked = true;
        this.emitChangeEvent();
        if (this.radioGroup) {
            this.radioGroup._controlValueAccessorChangeFn(this.value);
            this.radioGroup.value = this.value;
            if (groupValueChanged) {
                this.radioGroup.emitChangeEvent();
            }
        }
    }
    focus() {
        this.focusMonitor.focusVia(this.inputElement, 'keyboard');
    }
    markForCheck() {
        this.cdr.markForCheck();
    }
    emitChangeEvent() {
        this.change.emit(new RadioChange(this, this._value));
    }
}
RadioComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RadioComponent, deps: [{ token: RadioGroupComponent, optional: true }, { token: i0.ChangeDetectorRef }, { token: i1.FocusMonitor }, { token: i3$4.UniqueSelectionDispatcher }, { token: i0.ElementRef }, { token: i1$1.WindowService }], target: i0.ɵɵFactoryTarget.Component });
RadioComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: RadioComponent, selector: "ds-radio-button", inputs: { id: "id", name: "name", caption: "caption", checked: "checked", value: "value", disabled: "disabled", required: "required", standalone: "standalone" }, outputs: { change: "change" }, host: { listeners: { "focus": "inputElement.nativeElement.focus()" }, properties: { "attr.tabindex": "this.isChrome() ? \"null\" : \"-1\"", "attr.id": "this.hostId" }, classAttribute: "ds-radioButton" }, viewQueries: [{ propertyName: "inputElement", first: true, predicate: ["input"], descendants: true, static: true }], ngImport: i0, template: "<label\n  [attr.for]=\"inputId\"\n  class=\"ds-radioLabel d-inline-flex align-items-start\"\n  [ngClass]=\"{ '-standalone justify-content-center': standalone }\"\n  #label\n>\n  <input\n    #input\n    type=\"radio\"\n    class=\"ds-radioButton__input cdk-visually-hidden\"\n    [id]=\"inputId\"\n    [checked]=\"checked\"\n    [disabled]=\"disabled\"\n    [tabIndex]=\"disabled ? -1 : 0\"\n    [attr.aria-label]=\"caption\"\n    [attr.aria-labelledby]=\"inputId + '-label-container'\"\n    [attr.name]=\"name\"\n    [required]=\"required\"\n    (change)=\"onInputChange($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <div class=\"ds-radioButton__outerCircle my-12\">\n    <div class=\"ds-radioButton__innerCircle\"></div>\n  </div>\n  <div\n    class=\"ds-radioLabel__container ml-8 text-semi text-body my-12\"\n    [id]=\"inputId + '-label-container'\"\n    [ngClass]=\"{ 'sr-only': standalone }\"\n    [brClass]=\"[['text-semi', '', '', 'text-semi']]\"\n  >\n    <!-- Add an invisible span so JAWS can read the label -->\n    <span style=\"display: none\">&nbsp;</span>\n    <ng-content></ng-content>\n  </div>\n</label>\n", directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.BrandClassDirective, selector: "[brClass]", inputs: ["brClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
__decorate([
    Default(false)
], RadioComponent.prototype, "standalone", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-radio-button', encapsulation: ViewEncapsulation.None, host: {
                        class: 'ds-radioButton',
                        '[attr.tabindex]': 'this.isChrome() ? "null" : "-1"',
                        '(focus)': 'inputElement.nativeElement.focus()',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, template: "<label\n  [attr.for]=\"inputId\"\n  class=\"ds-radioLabel d-inline-flex align-items-start\"\n  [ngClass]=\"{ '-standalone justify-content-center': standalone }\"\n  #label\n>\n  <input\n    #input\n    type=\"radio\"\n    class=\"ds-radioButton__input cdk-visually-hidden\"\n    [id]=\"inputId\"\n    [checked]=\"checked\"\n    [disabled]=\"disabled\"\n    [tabIndex]=\"disabled ? -1 : 0\"\n    [attr.aria-label]=\"caption\"\n    [attr.aria-labelledby]=\"inputId + '-label-container'\"\n    [attr.name]=\"name\"\n    [required]=\"required\"\n    (change)=\"onInputChange($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <div class=\"ds-radioButton__outerCircle my-12\">\n    <div class=\"ds-radioButton__innerCircle\"></div>\n  </div>\n  <div\n    class=\"ds-radioLabel__container ml-8 text-semi text-body my-12\"\n    [id]=\"inputId + '-label-container'\"\n    [ngClass]=\"{ 'sr-only': standalone }\"\n    [brClass]=\"[['text-semi', '', '', 'text-semi']]\"\n  >\n    <!-- Add an invisible span so JAWS can read the label -->\n    <span style=\"display: none\">&nbsp;</span>\n    <ng-content></ng-content>\n  </div>\n</label>\n" }]
        }], ctorParameters: function () { return [{ type: RadioGroupComponent, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }, { type: i1.FocusMonitor }, { type: i3$4.UniqueSelectionDispatcher }, { type: i0.ElementRef }, { type: i1$1.WindowService }]; }, propDecorators: { hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], id: [{
                type: Input
            }], name: [{
                type: Input
            }], caption: [{
                type: Input
            }], checked: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], required: [{
                type: Input
            }], standalone: [{
                type: Input
            }], change: [{
                type: Output
            }], inputElement: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }] } });

let uid$3 = 0;
const DS_SELECTION_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectionCheckboxComponent),
    multi: true,
};
class SelectionCheckboxComponent extends CheckboxComponent {
    constructor(element, cdr, focusMonitor, cdkCore, windowService) {
        super(element, cdr, focusMonitor, cdkCore);
        this.windowService = windowService;
        this.uniqueId = `ds-selection-checkbox-id-${uid$3++}`;
        this.hasPadding = true;
    }
    set id(id) {
        this._id = id || this.uniqueId;
        if (id) {
            this.hostId = id + '-host';
        }
    }
    get id() {
        return this._id;
    }
    isChrome() {
        return this.windowService.getBrowsers()['isChrome'];
    }
}
SelectionCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SelectionCheckboxComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1.FocusMonitor }, { token: i2.CDKCoreService }, { token: i1$1.WindowService }], target: i0.ɵɵFactoryTarget.Component });
SelectionCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: SelectionCheckboxComponent, selector: "ds-selection-checkbox", inputs: { type: "type", id: "id", hasPadding: "hasPadding", checkedCopy: "checkedCopy" }, host: { listeners: { "focus": "inputElement.nativeElement.focus()" }, properties: { "attr.tabindex": "this.isChrome() ? \"null\" : \"-1\"", "style.outline": "\"none\"", "class.w-100": "!this.hasPadding" } }, providers: [DS_SELECTION_CHECKBOX_CONTROL_VALUE_ACCESSOR], usesInheritance: true, ngImport: i0, template: "<label\n  [attr.for]=\"inputId\"\n  class=\"ds-selection d-flex ds-pointer position-relative -checkbox\"\n  [ngClass]=\"{\n    '-disabled': disabled,\n    '-complex': type === 'complex'\n  }\"\n  #label\n>\n  <input\n    #input\n    type=\"checkbox\"\n    class=\"cdk-visually-hidden\"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [attr.aria-label]=\"caption\"\n    [tabIndex]=\"disabled ? -1 : 0\"\n    [attr.aria-checked]=\"checked ? 'true' : 'false'\"\n    [attr.aria-labelledby]=\"inputId + '-label'\"\n    (change)=\"onInteractionEvent($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <span\n    class=\"ds-selection__label ds-no-overflow text-body mb-0 w-100\"\n    [ngClass]=\"{ 'py-12 px-16 px-md-24 ': hasPadding && type === 'simple' }\"\n    [id]=\"inputId + '-label'\"\n  >\n    <span class=\"ds-selection__input ds-icon-interactive-default\">\n      <span\n        [ngClass]=\"{\n          'rds-icon-check': brand === 'rogers',\n          'fds-icon-check': brand === 'fido',\n          'cds-icon-check': brand === 'chatr',\n          'sds-icon-check': brand === 'r4b'\n        }\"\n      ></span>\n      <span\n        *ngIf=\"type === 'complex'\"\n        class=\"ds-selection__inputCopy text-overline\"\n        [innerHTML]=\"checkedCopy\"\n      ></span>\n    </span>\n    <span>\n      <span style=\"display: none\">&nbsp;</span>\n      <ng-content></ng-content>\n    </span>\n  </span>\n</label>\n", directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
__decorate([
    Default('simple')
], SelectionCheckboxComponent.prototype, "type", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SelectionCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-selection-checkbox', host: {
                        '(focus)': 'inputElement.nativeElement.focus()',
                        '[attr.tabindex]': 'this.isChrome() ? "null" : "-1"',
                        '[style.outline]': '"none"',
                        '[class.w-100]': '!this.hasPadding',
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, providers: [DS_SELECTION_CHECKBOX_CONTROL_VALUE_ACCESSOR], template: "<label\n  [attr.for]=\"inputId\"\n  class=\"ds-selection d-flex ds-pointer position-relative -checkbox\"\n  [ngClass]=\"{\n    '-disabled': disabled,\n    '-complex': type === 'complex'\n  }\"\n  #label\n>\n  <input\n    #input\n    type=\"checkbox\"\n    class=\"cdk-visually-hidden\"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [attr.aria-label]=\"caption\"\n    [tabIndex]=\"disabled ? -1 : 0\"\n    [attr.aria-checked]=\"checked ? 'true' : 'false'\"\n    [attr.aria-labelledby]=\"inputId + '-label'\"\n    (change)=\"onInteractionEvent($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <span\n    class=\"ds-selection__label ds-no-overflow text-body mb-0 w-100\"\n    [ngClass]=\"{ 'py-12 px-16 px-md-24 ': hasPadding && type === 'simple' }\"\n    [id]=\"inputId + '-label'\"\n  >\n    <span class=\"ds-selection__input ds-icon-interactive-default\">\n      <span\n        [ngClass]=\"{\n          'rds-icon-check': brand === 'rogers',\n          'fds-icon-check': brand === 'fido',\n          'cds-icon-check': brand === 'chatr',\n          'sds-icon-check': brand === 'r4b'\n        }\"\n      ></span>\n      <span\n        *ngIf=\"type === 'complex'\"\n        class=\"ds-selection__inputCopy text-overline\"\n        [innerHTML]=\"checkedCopy\"\n      ></span>\n    </span>\n    <span>\n      <span style=\"display: none\">&nbsp;</span>\n      <ng-content></ng-content>\n    </span>\n  </span>\n</label>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1.FocusMonitor }, { type: i2.CDKCoreService }, { type: i1$1.WindowService }]; }, propDecorators: { type: [{
                type: Input
            }], id: [{
                type: Input
            }], hasPadding: [{
                type: Input
            }], checkedCopy: [{
                type: Input
            }] } });

class SelectionComponent extends RadioComponent {
    constructor(radioGroup, cdr, focusMonitor, radioDispatcher, element, windowService, cdkCore) {
        super(radioGroup, cdr, focusMonitor, radioDispatcher, element, windowService);
        this.cdkCore = cdkCore;
        this.destroy$ = new Subject();
        this.hasPadding = false;
        this._cdr = cdr;
        this._windowService = windowService;
    }
    get brand() {
        return this.cdkCore.brand;
    }
    ngOnInit() {
        super.ngOnInit();
        this.cdkCore.config$.pipe(takeUntil(this.destroy$)).subscribe((c) => {
            this._cdr.markForCheck();
        });
    }
    isChrome() {
        return this._windowService.getBrowsers()['isChrome'];
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
SelectionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SelectionComponent, deps: [{ token: RadioGroupComponent, optional: true }, { token: i0.ChangeDetectorRef }, { token: i1.FocusMonitor }, { token: i3$4.UniqueSelectionDispatcher }, { token: i0.ElementRef }, { token: i1$1.WindowService }, { token: i2.CDKCoreService }], target: i0.ɵɵFactoryTarget.Component });
SelectionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: SelectionComponent, selector: "ds-selection", inputs: { type: "type", color: "color", hasPadding: "hasPadding", checkedCopy: "checkedCopy" }, host: { listeners: { "focus": "inputElement.nativeElement.focus()" }, properties: { "attr.tabindex": "this.isChrome() ? \"null\" : \"-1\"", "style.outline": "\"none\"" } }, usesInheritance: true, ngImport: i0, template: "<label\n  [attr.for]=\"inputId\"\n  class=\"ds-selection d-flex ds-pointer position-relative -radio\"\n  [ngClass]=\"{\n    '-disabled': disabled,\n    '-color': type === 'color',\n    '-complex': type === 'complex'\n  }\"\n  #label\n>\n  <input\n    #input\n    type=\"radio\"\n    class=\"cdk-visually-hidden\"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [attr.aria-label]=\"caption\"\n    [tabIndex]=\"disabled ? -1 : 0\"\n    [attr.aria-checked]=\"checked ? 'true' : 'false'\"\n    [attr.aria-labelledby]=\"inputId + '-label'\"\n    (change)=\"onInputChange($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <span\n    class=\"ds-selection__label ds-no-overflow text-body mb-0 w-100\"\n    [ngClass]=\"{\n      'py-12 px-16 px-md-24 ': hasPadding === true && type === 'simple'\n    }\"\n    [id]=\"inputId + '-label'\"\n  >\n    <span\n      [style.background]=\"color\"\n      class=\"ds-selection__input ds-icon-interactive-default\"\n      *ngIf=\"type !== 'simple'\"\n    >\n      <span\n        *ngIf=\"type === 'complex'\"\n        [ngClass]=\"{\n          'rds-icon-check': brand === 'rogers',\n          'fds-icon-check': brand === 'fido',\n          'cds-icon-check': brand === 'chatr',\n          'sds-icon-check': brand === 'r4b'\n        }\"\n      ></span>\n      <span\n        *ngIf=\"type === 'complex'\"\n        class=\"ds-selection__inputCopy text-overline\"\n        [innerHTML]=\"checkedCopy\"\n      ></span>\n    </span>\n    <span\n      [ngClass]=\"{\n        'sr-only d-none': type === 'color'\n      }\"\n    >\n      <span style=\"display: none\">&nbsp;</span>\n      <ng-content></ng-content>\n    </span>\n  </span>\n</label>\n", directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    Default('simple')
], SelectionComponent.prototype, "type", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SelectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-selection', host: {
                        '(focus)': 'inputElement.nativeElement.focus()',
                        '[attr.tabindex]': 'this.isChrome() ? "null" : "-1"',
                        '[style.outline]': '"none"',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, template: "<label\n  [attr.for]=\"inputId\"\n  class=\"ds-selection d-flex ds-pointer position-relative -radio\"\n  [ngClass]=\"{\n    '-disabled': disabled,\n    '-color': type === 'color',\n    '-complex': type === 'complex'\n  }\"\n  #label\n>\n  <input\n    #input\n    type=\"radio\"\n    class=\"cdk-visually-hidden\"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [attr.aria-label]=\"caption\"\n    [tabIndex]=\"disabled ? -1 : 0\"\n    [attr.aria-checked]=\"checked ? 'true' : 'false'\"\n    [attr.aria-labelledby]=\"inputId + '-label'\"\n    (change)=\"onInputChange($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <span\n    class=\"ds-selection__label ds-no-overflow text-body mb-0 w-100\"\n    [ngClass]=\"{\n      'py-12 px-16 px-md-24 ': hasPadding === true && type === 'simple'\n    }\"\n    [id]=\"inputId + '-label'\"\n  >\n    <span\n      [style.background]=\"color\"\n      class=\"ds-selection__input ds-icon-interactive-default\"\n      *ngIf=\"type !== 'simple'\"\n    >\n      <span\n        *ngIf=\"type === 'complex'\"\n        [ngClass]=\"{\n          'rds-icon-check': brand === 'rogers',\n          'fds-icon-check': brand === 'fido',\n          'cds-icon-check': brand === 'chatr',\n          'sds-icon-check': brand === 'r4b'\n        }\"\n      ></span>\n      <span\n        *ngIf=\"type === 'complex'\"\n        class=\"ds-selection__inputCopy text-overline\"\n        [innerHTML]=\"checkedCopy\"\n      ></span>\n    </span>\n    <span\n      [ngClass]=\"{\n        'sr-only d-none': type === 'color'\n      }\"\n    >\n      <span style=\"display: none\">&nbsp;</span>\n      <ng-content></ng-content>\n    </span>\n  </span>\n</label>\n" }]
        }], ctorParameters: function () { return [{ type: RadioGroupComponent, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }, { type: i1.FocusMonitor }, { type: i3$4.UniqueSelectionDispatcher }, { type: i0.ElementRef }, { type: i1$1.WindowService }, { type: i2.CDKCoreService }]; }, propDecorators: { type: [{
                type: Input
            }], color: [{
                type: Input
            }], hasPadding: [{
                type: Input
            }], checkedCopy: [{
                type: Input
            }] } });

class InputBase {
    constructor(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
        this._parentForm = _parentForm;
        this._parentFormGroup = _parentFormGroup;
        this.ngControl = ngControl;
    }
}
const InputMixinBase = mixinErrorState(InputBase);
class SliderDirective extends InputMixinBase {
    constructor(_element, ngControl, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, cdr, focusMonitor) {
        super(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl);
        this._element = _element;
        this.ngControl = ngControl;
        this.cdr = cdr;
        this.focusMonitor = focusMonitor;
        this.valueChange = new Subject();
        this.propChanges = new Subject();
        this.change = new EventEmitter();
    }
    set type(value) {
        if (value !== 'range') {
            throw new Error(`Input type "${this.type}" is not supported by dsSlider`);
        }
        this._type = value || 'range';
        this.element.type = value;
        this.propChanges.next(void 0);
        this.cdr.markForCheck();
    }
    get type() {
        return this._type || 'range';
    }
    set min(value) {
        this._min = coerceNumberProperty(value);
        this.element.min = value.toString();
        this.propChanges.next(void 0);
        this.cdr.markForCheck();
    }
    get min() {
        return this._min || 0;
    }
    set max(value) {
        this._max = coerceNumberProperty(value);
        this.element.max = value.toString();
        this.propChanges.next(void 0);
        this.cdr.markForCheck();
    }
    get max() {
        return this._max || 0;
    }
    set step(value) {
        this._step = coerceNumberProperty(value);
        this.element.step = value.toString();
        this.propChanges.next(void 0);
        this.cdr.markForCheck();
    }
    get step() {
        return this._step || 0;
    }
    set value(value) {
        this._value = coerceNumberProperty(value);
        this.element.value = `${value}`;
        this.valueChange.next(void 0);
        this.propChanges.next(void 0);
        this.cdr.markForCheck();
    }
    get value() {
        return this._value || 0;
    }
    get element() {
        return this._element.nativeElement;
    }
    nativeChange(event) {
        this.valueChange.next(void 0);
    }
    ngOnInit() {
        this.focusMonitor.monitor(this.element, false);
    }
    ngOnChanges(changes) {
        this.propChanges.next(changes);
    }
    stepUp() {
        this.element.stepUp();
        this.valueChange.next(void 0);
        this.change.emit(this.createEvent());
    }
    stepDown() {
        this.element.stepDown();
        this.valueChange.next(void 0);
        this.change.emit(this.createEvent());
    }
    createEvent() {
        const event = new CustomEvent('change', {
            detail: {
                target: this.element,
            },
        });
        return event;
    }
    ngOnDestroy() {
        this.valueChange.complete();
        this.propChanges.complete();
        this.focusMonitor.stopMonitoring(this.element);
    }
}
SliderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SliderDirective, deps: [{ token: i0.ElementRef }, { token: i3$3.NgControl, optional: true, self: true }, { token: i3$3.NgForm, optional: true }, { token: i3$3.FormGroupDirective, optional: true }, { token: ErrorStateMatcher }, { token: i0.ChangeDetectorRef }, { token: i1.FocusMonitor }], target: i0.ɵɵFactoryTarget.Directive });
SliderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: SliderDirective, selector: "input[dsSlider]", inputs: { type: "type", min: "min", max: "max", step: "step", value: "value" }, outputs: { change: "change" }, host: { listeners: { "change": "nativeChange($event)" }, properties: { "class.ds-slider-input": "true", "class.w-100": "true" } }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SliderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[dsSlider]',
                    host: {
                        '[class.ds-slider-input]': 'true',
                        '[class.w-100]': 'true',
                    },
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i3$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i3$3.NgForm, decorators: [{
                    type: Optional
                }] }, { type: i3$3.FormGroupDirective, decorators: [{
                    type: Optional
                }] }, { type: ErrorStateMatcher }, { type: i0.ChangeDetectorRef }, { type: i1.FocusMonitor }]; }, propDecorators: { type: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], step: [{
                type: Input
            }], value: [{
                type: Input
            }], change: [{
                type: Output
            }], nativeChange: [{
                type: HostListener,
                args: ['change', ['$event']]
            }] } });

class SliderComponent {
    constructor(ngZone, _element, cdr, windowService) {
        this.ngZone = ngZone;
        this._element = _element;
        this.cdr = cdr;
        this.windowService = windowService;
        this.destroy$ = new Subject();
        this._showTicks = true;
        this.currentValue = 0;
        this.isSafariBrowser = false;
        this.numberOfTicks = [];
    }
    set showTicks(value) {
        this._showTicks = coerceBooleanProperty(value);
        this.cdr.markForCheck();
    }
    get showTicks() {
        return this._showTicks && this.sliderInput.step > 0;
    }
    get element() {
        return this._element.nativeElement;
    }
    setNumberOfTicks() {
        if (this.sliderInput.step) {
            const step = this.sliderInput.step;
            const length = this.sliderInput.max - this.sliderInput.min;
            const arr = new Array(Math.floor(length / step + 1)).fill(0);
            this.numberOfTicks = arr;
        }
        else {
            this.numberOfTicks = [];
        }
    }
    ngOnInit() {
        this.isSafariBrowser = this.windowService.getBrowsers()['isSafari'];
    }
    ngAfterContentInit() {
        this.setSliderProgress(this.sliderInput.element);
        this.setNumberOfTicks();
        this.setBottomLabelPositions();
        this.subscribeToSliderChanges();
        this.subscribeToPropChanges();
        this.cdr.detectChanges();
    }
    subscribeToSliderChanges() {
        merge(fromEvent(this.sliderInput.element, 'input'), this.sliderInput.valueChange, this.sliderInput.propChanges)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.setSliderProgress(this.sliderInput.element));
    }
    subscribeToPropChanges() {
        this.sliderInput.propChanges
            .pipe(takeUntil(this.destroy$), debounceTime(5))
            .subscribe((changes) => {
            this.setNumberOfTicks();
            this.cdr.detectChanges();
        });
    }
    setSliderProgress(element) {
        this.ngZone.runOutsideAngular(() => {
            const val = +element.value;
            this.currentValue = val;
            const trackProgressPercent = ((val - this.sliderInput.min) /
                (this.sliderInput.max - this.sliderInput.min)) *
                100;
            const label = this.floatingLabel.nativeElement;
            this.element.style.setProperty('--slider-track-progress', `${trackProgressPercent}`);
            this.element.style.setProperty('--slider-track-progress-percent', `${trackProgressPercent}%`);
            Promise.resolve().then(() => {
                label.style.setProperty('--floating-label-width', `${label.getBoundingClientRect().width / 2}px`);
            });
        });
        this.cdr.detectChanges();
    }
    setBottomLabelPositions() {
        Promise.resolve().then(() => {
            const leftLabelWidth = this.leftLabel.nativeElement.getBoundingClientRect().width;
            this.leftLabel.nativeElement.style.left = `-${leftLabelWidth / 2}px`;
            const rightLabelWidth = this.rightLabel.nativeElement.getBoundingClientRect().width;
            this.rightLabel.nativeElement.style.right = `-${rightLabelWidth / 2}px`;
            this.cdr.detectChanges();
        });
    }
    stepUp() {
        this.sliderInput.stepUp();
    }
    stepDown() {
        this.sliderInput.stepDown();
    }
    isMin() {
        return this.sliderInput.value === this.sliderInput.min;
    }
    isMax() {
        return this.sliderInput.value === this.sliderInput.max;
    }
    ngOnDestroy() {
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
SliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SliderComponent, deps: [{ token: i0.NgZone }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1$1.WindowService }], target: i0.ɵɵFactoryTarget.Component });
SliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: SliderComponent, selector: "ds-slider", inputs: { data: "data", showTicks: "showTicks" }, host: { properties: { "class.ds-slider": "true", "class.d-block": "true" } }, queries: [{ propertyName: "sliderInput", first: true, predicate: SliderDirective, descendants: true, static: true }], viewQueries: [{ propertyName: "floatingLabel", first: true, predicate: ["floatingLabel"], descendants: true, static: true }, { propertyName: "leftLabel", first: true, predicate: ["leftLabel"], descendants: true, static: true }, { propertyName: "rightLabel", first: true, predicate: ["rightLabel"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"ds-slider__container\" #sliderContainer>\n  <div class=\"d-flex align-items-center\">\n    <span\n      [ngClass]=\"[\n        showTicks ? 'mt-12' : 'mt-24',\n        isSafariBrowser ? 'mr-24' : 'mr-16'\n      ]\"\n    >\n      <button\n        ds-button\n        type=\"button\"\n        variant=\"icon\"\n        (click)=\"stepDown()\"\n        [disabled]=\"currentValue === sliderInput.min\"\n        [attr.aria-label]=\"data.decrementCaption\"\n      >\n        <ds-icon name=\"minus\"></ds-icon>\n      </button>\n    </span>\n    <div class=\"w-100\">\n      <div class=\"ds-slider__trackContainer\">\n        <div class=\"ds-slider__floatingLabelContainer pb-24\">\n          <div\n            class=\"ds-slider__floatingLabel text-body-sm mb-0\"\n            aria-live=\"polite\"\n            #floatingLabel\n          >\n            <ng-content select=\"[ds-slide-label]\"></ng-content>\n          </div>\n        </div>\n        <div class=\"mb-16\">\n          <ng-content select=\"[dsSlider]\"></ng-content>\n        </div>\n        <div\n          class=\"ds-slider__ticks mb-8 d-flex justify-content-between\"\n          *ngIf=\"showTicks\"\n        >\n          <div\n            class=\"ds-slider__tick ds-bgcolor-concrete\"\n            *ngFor=\"let tick of numberOfTicks\"\n          ></div>\n        </div>\n      </div>\n      <div class=\"ds-slider__labelContainer position-relative\">\n        <div class=\"ds-slider__leftLabel text-body-sm mb-0\" #leftLabel>\n          <ng-content select=\"[ds-slide-left-label]\"></ng-content>\n        </div>\n        <div class=\"ds-slider__rightLabel text-body-sm mb-0\" #rightLabel>\n          <ng-content select=\"[ds-slide-right-label]\"></ng-content>\n        </div>\n      </div>\n    </div>\n    <span\n      [ngClass]=\"[\n        showTicks ? 'mt-12' : 'mt-24',\n        isSafariBrowser ? 'ml-24' : 'ml-16'\n      ]\"\n    >\n      <button\n        ds-button\n        type=\"button\"\n        variant=\"icon\"\n        (click)=\"stepUp()\"\n        [disabled]=\"currentValue === sliderInput.max\"\n        [attr.aria-label]=\"data.incrementCaption\"\n      >\n        <ds-icon name=\"plus\"></ds-icon>\n      </button>\n    </span>\n  </div>\n</div>\n", components: [{ type: i2$1.ButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["variant", "size", "alignIcon", "img", "transparent", "disabled", "tabIndex", "a11yDescription"] }, { type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-slider', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class.ds-slider]': 'true',
                        '[class.d-block]': 'true',
                    }, template: "<div class=\"ds-slider__container\" #sliderContainer>\n  <div class=\"d-flex align-items-center\">\n    <span\n      [ngClass]=\"[\n        showTicks ? 'mt-12' : 'mt-24',\n        isSafariBrowser ? 'mr-24' : 'mr-16'\n      ]\"\n    >\n      <button\n        ds-button\n        type=\"button\"\n        variant=\"icon\"\n        (click)=\"stepDown()\"\n        [disabled]=\"currentValue === sliderInput.min\"\n        [attr.aria-label]=\"data.decrementCaption\"\n      >\n        <ds-icon name=\"minus\"></ds-icon>\n      </button>\n    </span>\n    <div class=\"w-100\">\n      <div class=\"ds-slider__trackContainer\">\n        <div class=\"ds-slider__floatingLabelContainer pb-24\">\n          <div\n            class=\"ds-slider__floatingLabel text-body-sm mb-0\"\n            aria-live=\"polite\"\n            #floatingLabel\n          >\n            <ng-content select=\"[ds-slide-label]\"></ng-content>\n          </div>\n        </div>\n        <div class=\"mb-16\">\n          <ng-content select=\"[dsSlider]\"></ng-content>\n        </div>\n        <div\n          class=\"ds-slider__ticks mb-8 d-flex justify-content-between\"\n          *ngIf=\"showTicks\"\n        >\n          <div\n            class=\"ds-slider__tick ds-bgcolor-concrete\"\n            *ngFor=\"let tick of numberOfTicks\"\n          ></div>\n        </div>\n      </div>\n      <div class=\"ds-slider__labelContainer position-relative\">\n        <div class=\"ds-slider__leftLabel text-body-sm mb-0\" #leftLabel>\n          <ng-content select=\"[ds-slide-left-label]\"></ng-content>\n        </div>\n        <div class=\"ds-slider__rightLabel text-body-sm mb-0\" #rightLabel>\n          <ng-content select=\"[ds-slide-right-label]\"></ng-content>\n        </div>\n      </div>\n    </div>\n    <span\n      [ngClass]=\"[\n        showTicks ? 'mt-12' : 'mt-24',\n        isSafariBrowser ? 'ml-24' : 'ml-16'\n      ]\"\n    >\n      <button\n        ds-button\n        type=\"button\"\n        variant=\"icon\"\n        (click)=\"stepUp()\"\n        [disabled]=\"currentValue === sliderInput.max\"\n        [attr.aria-label]=\"data.incrementCaption\"\n      >\n        <ds-icon name=\"plus\"></ds-icon>\n      </button>\n    </span>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1$1.WindowService }]; }, propDecorators: { data: [{
                type: Input
            }], showTicks: [{
                type: Input
            }], sliderInput: [{
                type: ContentChild,
                args: [SliderDirective, { static: true }]
            }], floatingLabel: [{
                type: ViewChild,
                args: ['floatingLabel', { static: true }]
            }], leftLabel: [{
                type: ViewChild,
                args: ['leftLabel', { static: true }]
            }], rightLabel: [{
                type: ViewChild,
                args: ['rightLabel', { static: true }]
            }] } });

let uid$2 = 0;
class SwitchComponent extends CheckboxComponent {
    constructor(element, cdr, focusMonitor, cdkCore) {
        super(element, cdr, focusMonitor, cdkCore);
        this.uniqueId = `ds-switch-id-${uid$2++}`;
    }
    get inputId() {
        return this.id || this.uniqueId;
    }
    set id(id) {
        this._id = id || this.uniqueId;
        if (id) {
            this.hostId = id + '-host';
        }
    }
    get id() {
        return this._id;
    }
    ngOnInit() { }
}
SwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SwitchComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1.FocusMonitor }, { token: i2.CDKCoreService }], target: i0.ɵɵFactoryTarget.Component });
SwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: SwitchComponent, selector: "ds-switch", inputs: { id: "id" }, host: { classAttribute: "ds-switch" }, providers: [DS_CHECKBOX_CONTROL_VALUE_ACCESSOR], usesInheritance: true, ngImport: i0, template: "<label\n  [attr.for]=\"inputId\"\n  [ngClass]=\"{ '-disabled': disabled }\"\n  class=\"ds-switchLabel d-inline-flex align-items-center w-100 h-100 py-8\"\n  #label\n>\n  <input\n    type=\"checkbox\"\n    #input\n    class=\"ds-switch__input cdk-visually-hidden\"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [tabIndex]=\"0\"\n    [attr.aria-checked]=\"checked ? 'true' : 'false'\"\n    (change)=\"onInteractionEvent($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <div\n    class=\"ds-toggleArea d-flex align-items-center h-100 w-100 p-4 position-relative ds-no-overflow\"\n  >\n    <div class=\"ds-toggleArea__label\">\n      <!-- Add an invisible span so JAWS can read the label -->\n      <span style=\"display: none\">&nbsp;</span>\n      <ng-container [ngSwitch]=\"checked\">\n        <ng-container *ngSwitchCase=\"true\">\n          <ng-content select=\"[ds-switch-on]\"></ng-content>\n        </ng-container>\n        <ng-container *ngSwitchCase=\"false\">\n          <ng-content select=\"[ds-switch-off]\"></ng-content>\n        </ng-container>\n      </ng-container>\n    </div>\n    <div class=\"ds-toggleArea__toggle position-absolute\"></div>\n  </div>\n</label>\n", directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i4.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-switch', encapsulation: ViewEncapsulation.None, host: {
                        class: 'ds-switch',
                    }, providers: [DS_CHECKBOX_CONTROL_VALUE_ACCESSOR], template: "<label\n  [attr.for]=\"inputId\"\n  [ngClass]=\"{ '-disabled': disabled }\"\n  class=\"ds-switchLabel d-inline-flex align-items-center w-100 h-100 py-8\"\n  #label\n>\n  <input\n    type=\"checkbox\"\n    #input\n    class=\"ds-switch__input cdk-visually-hidden\"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [tabIndex]=\"0\"\n    [attr.aria-checked]=\"checked ? 'true' : 'false'\"\n    (change)=\"onInteractionEvent($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <div\n    class=\"ds-toggleArea d-flex align-items-center h-100 w-100 p-4 position-relative ds-no-overflow\"\n  >\n    <div class=\"ds-toggleArea__label\">\n      <!-- Add an invisible span so JAWS can read the label -->\n      <span style=\"display: none\">&nbsp;</span>\n      <ng-container [ngSwitch]=\"checked\">\n        <ng-container *ngSwitchCase=\"true\">\n          <ng-content select=\"[ds-switch-on]\"></ng-content>\n        </ng-container>\n        <ng-container *ngSwitchCase=\"false\">\n          <ng-content select=\"[ds-switch-off]\"></ng-content>\n        </ng-container>\n      </ng-container>\n    </div>\n    <div class=\"ds-toggleArea__toggle position-absolute\"></div>\n  </div>\n</label>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1.FocusMonitor }, { type: i2.CDKCoreService }]; }, propDecorators: { id: [{
                type: Input
            }] } });

let uid$1 = 0;
const DS_TAG_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TagCheckboxComponent),
    multi: true,
};
class TagCheckboxComponent extends CheckboxComponent {
    constructor(windowService, element, cdr, focusMonitor, cdkCore) {
        super(element, cdr, focusMonitor, cdkCore);
        this.windowService = windowService;
        this.uniqueId = `ds-tag-checkbox-id-${uid$1++}`;
        this.isAppleMobileDevice = false;
        this.isWindowBrowser = false;
        const browsers = windowService.getBrowsers();
        this.isAppleMobileDevice = this.windowService.isAppleMobileDevice();
        this.isWindowBrowser =
            (browsers['isChrome'] || browsers['isFirefox']) &&
                !windowService.isAppleDevice();
    }
    set id(id) {
        this._id = id || this.uniqueId;
        if (id) {
            this.hostId = id + '-host';
        }
    }
    get id() {
        return this._id;
    }
    mouseEnter(element) {
        element.setAttribute('title', this.caption);
    }
    mouseLeave(element) {
        element.removeAttribute('title');
    }
}
TagCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TagCheckboxComponent, deps: [{ token: i1$1.WindowService }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1.FocusMonitor }, { token: i2.CDKCoreService }], target: i0.ɵɵFactoryTarget.Component });
TagCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: TagCheckboxComponent, selector: "ds-tag-checkbox", inputs: { id: "id", icon: "icon" }, host: { classAttribute: "ds-tag" }, providers: [DS_TAG_CHECKBOX_CONTROL_VALUE_ACCESSOR], usesInheritance: true, ngImport: i0, template: "<label\n  [attr.for]=\"inputId\"\n  class=\"ds-tag__label d-inline-flex py-8\"\n  (mouseenter)=\"caption ? mouseEnter($event.target) : ''\"\n  (mouseleave)=\"caption ? mouseLeave($event.target) : ''\"\n>\n  <input\n    #input\n    type=\"checkbox\"\n    class=\"ds-tag__input cdk-visually-hidden\"\n    [attr.aria-label]=\"isWindowBrowser ? null : caption\"\n    [attr.aria-labelledby]=\"\n      isAppleMobileDevice\n        ? inputId + '-content'\n        : isWindowBrowser\n        ? ''\n        : inputId + '-caption'\n    \"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [tabIndex]=\"disabled ? -1 : 0\"\n    [attr.aria-checked]=\"checked ? 'true' : 'false'\"\n    (change)=\"onInteractionEvent($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <div\n    class=\"\n      ds-tag__content\n      ds-pointer\n      outline-none\n      ds-bgcolor-white\n      d-flex\n      align-items-center\n      ds-borders ds-brcolor-slate ds-no-overflow\n      mb-0\n      py-4\n      text-body-sm text-bold text-nowrap\n    \"\n    [id]=\"inputId + '-content'\"\n    [ngClass]=\"{\n      '-disabled': disabled,\n      'pl-16': !icon?.name,\n      'pl-8': icon?.name,\n      'pr-16': !checked,\n      'pr-8': checked\n    }\"\n  >\n    <ds-icon\n      *ngIf=\"icon?.name\"\n      [name]=\"icon.name\"\n      [caption]=\"icon.caption\"\n      [ariaHidden]=\"!icon.caption\"\n    ></ds-icon>\n    <!-- Add an invisible span so JAWS can read the label -->\n    <span style=\"display: none\">&nbsp;</span>\n    <span\n      *ngIf=\"caption && !isAppleMobileDevice\"\n      [ngClass]=\"isWindowBrowser ? 'sr-only' : 'd-none'\"\n      [id]=\"inputId + '-caption'\"\n      >{{ caption }}</span\n    >\n    <span\n      [ngClass]=\"{\n        'ml-4': icon?.name,\n        'mr-4': checked\n      }\"\n    >\n      <ng-content></ng-content>\n    </span>\n    <ds-icon *ngIf=\"checked\" name=\"close\"></ds-icon>\n  </div>\n</label>\n", components: [{ type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TagCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-tag-checkbox', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, providers: [DS_TAG_CHECKBOX_CONTROL_VALUE_ACCESSOR], host: {
                        class: 'ds-tag',
                    }, template: "<label\n  [attr.for]=\"inputId\"\n  class=\"ds-tag__label d-inline-flex py-8\"\n  (mouseenter)=\"caption ? mouseEnter($event.target) : ''\"\n  (mouseleave)=\"caption ? mouseLeave($event.target) : ''\"\n>\n  <input\n    #input\n    type=\"checkbox\"\n    class=\"ds-tag__input cdk-visually-hidden\"\n    [attr.aria-label]=\"isWindowBrowser ? null : caption\"\n    [attr.aria-labelledby]=\"\n      isAppleMobileDevice\n        ? inputId + '-content'\n        : isWindowBrowser\n        ? ''\n        : inputId + '-caption'\n    \"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [tabIndex]=\"disabled ? -1 : 0\"\n    [attr.aria-checked]=\"checked ? 'true' : 'false'\"\n    (change)=\"onInteractionEvent($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <div\n    class=\"\n      ds-tag__content\n      ds-pointer\n      outline-none\n      ds-bgcolor-white\n      d-flex\n      align-items-center\n      ds-borders ds-brcolor-slate ds-no-overflow\n      mb-0\n      py-4\n      text-body-sm text-bold text-nowrap\n    \"\n    [id]=\"inputId + '-content'\"\n    [ngClass]=\"{\n      '-disabled': disabled,\n      'pl-16': !icon?.name,\n      'pl-8': icon?.name,\n      'pr-16': !checked,\n      'pr-8': checked\n    }\"\n  >\n    <ds-icon\n      *ngIf=\"icon?.name\"\n      [name]=\"icon.name\"\n      [caption]=\"icon.caption\"\n      [ariaHidden]=\"!icon.caption\"\n    ></ds-icon>\n    <!-- Add an invisible span so JAWS can read the label -->\n    <span style=\"display: none\">&nbsp;</span>\n    <span\n      *ngIf=\"caption && !isAppleMobileDevice\"\n      [ngClass]=\"isWindowBrowser ? 'sr-only' : 'd-none'\"\n      [id]=\"inputId + '-caption'\"\n      >{{ caption }}</span\n    >\n    <span\n      [ngClass]=\"{\n        'ml-4': icon?.name,\n        'mr-4': checked\n      }\"\n    >\n      <ng-content></ng-content>\n    </span>\n    <ds-icon *ngIf=\"checked\" name=\"close\"></ds-icon>\n  </div>\n</label>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.WindowService }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1.FocusMonitor }, { type: i2.CDKCoreService }]; }, propDecorators: { id: [{
                type: Input
            }], icon: [{
                type: Input
            }] } });

let uid = 0;
class TagRadioComponent extends RadioComponent {
    constructor(radioGroup, cdr, focusMonitor, radioDispatcher, element, windowService) {
        super(radioGroup, cdr, focusMonitor, radioDispatcher, element, windowService);
        this.uniqueInputId = `ds-tag-radio-id-${uid++}`;
        this.isAppleMobileDevice = false;
        this.isWindowBrowser = false;
        const browsers = windowService.getBrowsers();
        this.isAppleMobileDevice = windowService.isAppleMobileDevice();
        this.isWindowBrowser =
            (browsers['isChrome'] || browsers['isFirefox']) &&
                !windowService.isAppleDevice();
    }
    set id(id) {
        this._id = id || this.uniqueInputId;
        if (id) {
            this.hostId = id + '-host';
        }
    }
    get id() {
        return this._id;
    }
    mouseEnter(element) {
        element.setAttribute('title', this.caption);
    }
    mouseLeave(element) {
        element.removeAttribute('title');
    }
}
TagRadioComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TagRadioComponent, deps: [{ token: RadioGroupComponent, optional: true }, { token: i0.ChangeDetectorRef }, { token: i1.FocusMonitor }, { token: i3$4.UniqueSelectionDispatcher }, { token: i0.ElementRef }, { token: i1$1.WindowService }], target: i0.ɵɵFactoryTarget.Component });
TagRadioComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: TagRadioComponent, selector: "ds-tag-radio", inputs: { id: "id", icon: "icon" }, host: { classAttribute: "ds-tag" }, usesInheritance: true, ngImport: i0, template: "<label\n  [attr.for]=\"inputId\"\n  class=\"ds-tag__label d-inline-flex py-8\"\n  (mouseenter)=\"caption ? mouseEnter($event.target) : ''\"\n  (mouseleave)=\"caption ? mouseLeave($event.target) : ''\"\n>\n  <input\n    #input\n    type=\"radio\"\n    class=\"ds-tag__input cdk-visually-hidden\"\n    [attr.aria-label]=\"isWindowBrowser ? null : caption\"\n    [attr.aria-labelledby]=\"\n      isAppleMobileDevice\n        ? inputId + '-content'\n        : isWindowBrowser\n        ? ''\n        : inputId + '-caption'\n    \"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [tabIndex]=\"disabled ? -1 : 0\"\n    [attr.aria-checked]=\"checked ? 'true' : 'false'\"\n    (change)=\"onInputChange($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <div\n    class=\"\n      ds-tag__content\n      ds-pointer\n      outline-none\n      ds-bgcolor-white\n      d-flex\n      align-items-center\n      ds-borders ds-brcolor-slate ds-no-overflow\n      mb-0\n      pr-16\n      py-4\n      text-body-sm text-bold text-nowrap\n    \"\n    [id]=\"inputId + '-content'\"\n    [ngClass]=\"{\n      '-disabled': disabled,\n      'pl-16': !icon?.name,\n      'pl-8': icon?.name\n    }\"\n  >\n    <ds-icon\n      *ngIf=\"icon?.name\"\n      [name]=\"icon.name\"\n      [caption]=\"icon.caption\"\n      [ariaHidden]=\"!icon.caption\"\n    ></ds-icon>\n    <!-- Add an invisible span so JAWS can read the label -->\n    <span\n      *ngIf=\"caption && !isAppleMobileDevice\"\n      [ngClass]=\"isWindowBrowser ? 'sr-only' : 'd-none'\"\n      [id]=\"inputId + '-caption'\"\n      >{{ caption }}</span\n    >\n    <span\n      [ngClass]=\"{\n        'ml-4': icon?.name\n      }\"\n    >\n      <ng-content></ng-content>\n    </span>\n  </div>\n</label>\n", components: [{ type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TagRadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-tag-radio', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        class: 'ds-tag',
                    }, template: "<label\n  [attr.for]=\"inputId\"\n  class=\"ds-tag__label d-inline-flex py-8\"\n  (mouseenter)=\"caption ? mouseEnter($event.target) : ''\"\n  (mouseleave)=\"caption ? mouseLeave($event.target) : ''\"\n>\n  <input\n    #input\n    type=\"radio\"\n    class=\"ds-tag__input cdk-visually-hidden\"\n    [attr.aria-label]=\"isWindowBrowser ? null : caption\"\n    [attr.aria-labelledby]=\"\n      isAppleMobileDevice\n        ? inputId + '-content'\n        : isWindowBrowser\n        ? ''\n        : inputId + '-caption'\n    \"\n    [id]=\"inputId\"\n    [required]=\"required\"\n    [checked]=\"checked\"\n    [attr.value]=\"value\"\n    [disabled]=\"disabled\"\n    [attr.name]=\"name\"\n    [tabIndex]=\"disabled ? -1 : 0\"\n    [attr.aria-checked]=\"checked ? 'true' : 'false'\"\n    (change)=\"onInputChange($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n  <div\n    class=\"\n      ds-tag__content\n      ds-pointer\n      outline-none\n      ds-bgcolor-white\n      d-flex\n      align-items-center\n      ds-borders ds-brcolor-slate ds-no-overflow\n      mb-0\n      pr-16\n      py-4\n      text-body-sm text-bold text-nowrap\n    \"\n    [id]=\"inputId + '-content'\"\n    [ngClass]=\"{\n      '-disabled': disabled,\n      'pl-16': !icon?.name,\n      'pl-8': icon?.name\n    }\"\n  >\n    <ds-icon\n      *ngIf=\"icon?.name\"\n      [name]=\"icon.name\"\n      [caption]=\"icon.caption\"\n      [ariaHidden]=\"!icon.caption\"\n    ></ds-icon>\n    <!-- Add an invisible span so JAWS can read the label -->\n    <span\n      *ngIf=\"caption && !isAppleMobileDevice\"\n      [ngClass]=\"isWindowBrowser ? 'sr-only' : 'd-none'\"\n      [id]=\"inputId + '-caption'\"\n      >{{ caption }}</span\n    >\n    <span\n      [ngClass]=\"{\n        'ml-4': icon?.name\n      }\"\n    >\n      <ng-content></ng-content>\n    </span>\n  </div>\n</label>\n" }]
        }], ctorParameters: function () { return [{ type: RadioGroupComponent, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }, { type: i1.FocusMonitor }, { type: i3$4.UniqueSelectionDispatcher }, { type: i0.ElementRef }, { type: i1$1.WindowService }]; }, propDecorators: { id: [{
                type: Input
            }], icon: [{
                type: Input
            }] } });

class FormModule {
}
FormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormModule, declarations: [AutoCompleteComponent,
        AutoCompleteHighlight,
        DSEmailDirective,
        FormFieldComponent,
        InputFormDirective,
        InputMaskDirective,
        InputLabelComponent,
        ErrorComponent,
        HintComponent,
        IncrementalCounterComponent,
        PasswordHintsComponent,
        SuffixDirective,
        PasswordHintItemComponent,
        CheckboxRequiredValidatorDirective,
        CheckboxComponent,
        RadioComponent,
        RadioGroupComponent,
        SliderComponent,
        SliderDirective,
        SwitchComponent,
        SuccessComponent,
        DatepickerComponent,
        DatepickerFromDirective,
        DatepickerToDirective,
        DatepickerFieldDirective,
        DatepickerContainerComponent,
        CalendarComponent,
        CalendarMonthComponent,
        CalendarDayComponent,
        CalendarSingleComponent,
        CalendarDualComponent,
        CalendarHeaderComponent,
        CalendarContainerComponent,
        DatepickerOverlayHostComponent,
        DatepickerDirective,
        FormGroupComponent,
        SelectionCheckboxComponent,
        SelectionComponent,
        CodeInputComponent,
        OptionComponent,
        TagCheckboxComponent,
        TagRadioComponent,
        FileUploadComponent,
        FileInputDirective], imports: [A11yModule,
        CommonModule,
        FormsModule,
        IconModule,
        ButtonModule,
        PortalModule,
        OverlayModule,
        DirectivesModule,
        PlatformModule], exports: [AutoCompleteComponent,
        AutoCompleteHighlight,
        DSEmailDirective,
        FormFieldComponent,
        InputFormDirective,
        InputMaskDirective,
        InputLabelComponent,
        ErrorComponent,
        HintComponent,
        IncrementalCounterComponent,
        PasswordHintsComponent,
        SuffixDirective,
        PasswordHintItemComponent,
        CheckboxRequiredValidatorDirective,
        CheckboxComponent,
        RadioComponent,
        RadioGroupComponent,
        SliderComponent,
        SliderDirective,
        SwitchComponent,
        SuccessComponent,
        DatepickerComponent,
        DatepickerFromDirective,
        DatepickerToDirective,
        DatepickerFieldDirective,
        DatepickerContainerComponent,
        CalendarComponent,
        CalendarMonthComponent,
        CalendarDayComponent,
        CalendarHeaderComponent,
        CalendarSingleComponent,
        CalendarDualComponent,
        CalendarContainerComponent,
        DatepickerOverlayHostComponent,
        DatepickerDirective,
        FormGroupComponent,
        SelectionCheckboxComponent,
        SelectionComponent,
        CodeInputComponent,
        OptionComponent,
        TagCheckboxComponent,
        TagRadioComponent,
        FileUploadComponent,
        FileInputDirective] });
FormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormModule, providers: [DatepickerService], imports: [[
            A11yModule,
            CommonModule,
            FormsModule,
            IconModule,
            ButtonModule,
            PortalModule,
            OverlayModule,
            DirectivesModule,
            PlatformModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AutoCompleteComponent,
                        AutoCompleteHighlight,
                        DSEmailDirective,
                        FormFieldComponent,
                        InputFormDirective,
                        InputMaskDirective,
                        InputLabelComponent,
                        ErrorComponent,
                        HintComponent,
                        IncrementalCounterComponent,
                        PasswordHintsComponent,
                        SuffixDirective,
                        PasswordHintItemComponent,
                        CheckboxRequiredValidatorDirective,
                        CheckboxComponent,
                        RadioComponent,
                        RadioGroupComponent,
                        SliderComponent,
                        SliderDirective,
                        SwitchComponent,
                        SuccessComponent,
                        DatepickerComponent,
                        DatepickerFromDirective,
                        DatepickerToDirective,
                        DatepickerFieldDirective,
                        DatepickerContainerComponent,
                        CalendarComponent,
                        CalendarMonthComponent,
                        CalendarDayComponent,
                        CalendarSingleComponent,
                        CalendarDualComponent,
                        CalendarHeaderComponent,
                        CalendarContainerComponent,
                        DatepickerOverlayHostComponent,
                        DatepickerDirective,
                        FormGroupComponent,
                        SelectionCheckboxComponent,
                        SelectionComponent,
                        CodeInputComponent,
                        OptionComponent,
                        TagCheckboxComponent,
                        TagRadioComponent,
                        FileUploadComponent,
                        FileInputDirective,
                    ],
                    imports: [
                        A11yModule,
                        CommonModule,
                        FormsModule,
                        IconModule,
                        ButtonModule,
                        PortalModule,
                        OverlayModule,
                        DirectivesModule,
                        PlatformModule,
                    ],
                    exports: [
                        AutoCompleteComponent,
                        AutoCompleteHighlight,
                        DSEmailDirective,
                        FormFieldComponent,
                        InputFormDirective,
                        InputMaskDirective,
                        InputLabelComponent,
                        ErrorComponent,
                        HintComponent,
                        IncrementalCounterComponent,
                        PasswordHintsComponent,
                        SuffixDirective,
                        PasswordHintItemComponent,
                        CheckboxRequiredValidatorDirective,
                        CheckboxComponent,
                        RadioComponent,
                        RadioGroupComponent,
                        SliderComponent,
                        SliderDirective,
                        SwitchComponent,
                        SuccessComponent,
                        DatepickerComponent,
                        DatepickerFromDirective,
                        DatepickerToDirective,
                        DatepickerFieldDirective,
                        DatepickerContainerComponent,
                        CalendarComponent,
                        CalendarMonthComponent,
                        CalendarDayComponent,
                        CalendarHeaderComponent,
                        CalendarSingleComponent,
                        CalendarDualComponent,
                        CalendarContainerComponent,
                        DatepickerOverlayHostComponent,
                        DatepickerDirective,
                        FormGroupComponent,
                        SelectionCheckboxComponent,
                        SelectionComponent,
                        CodeInputComponent,
                        OptionComponent,
                        TagCheckboxComponent,
                        TagRadioComponent,
                        FileUploadComponent,
                        FileInputDirective,
                    ],
                    providers: [DatepickerService],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AutoCompleteComponent, AutoCompleteHighlight, CalendarComponent, CalendarContainerComponent, CalendarDayComponent, CalendarDualComponent, CalendarHeaderComponent, CalendarHeaderControls, CalendarMonthComponent, CalendarSingleComponent, CheckboxChange, CheckboxComponent, CheckboxRequiredValidatorDirective, CodeInputComponent, DSEmailDirective, DS_CHECKBOX_CONTROL_VALUE_ACCESSOR, DS_CHECKBOX_REQUIRED_VALIDATOR, DS_RADIO_GROUP_CONTROL_VALUE_ACCESSOR, DS_SELECTION_CHECKBOX_CONTROL_VALUE_ACCESSOR, DS_TAG_CHECKBOX_CONTROL_VALUE_ACCESSOR, DatepickerComponent, DatepickerContainerComponent, DatepickerDirective, DatepickerFieldDirective, DatepickerFromDirective, DatepickerInjectableData, DatepickerOverlayHostComponent, DatepickerService, DatepickerToDirective, Day, ErrorComponent, ErrorStateMatcher, EventType, FileInputDirective, FileUploadComponent, FormFieldComponent, FormFieldControl, FormGroupComponent, FormModule, HintComponent, IncrementalCounterAction, IncrementalCounterComponent, InputBase$1 as InputBase, InputFormDirective, InputLabelComponent, InputMaskDirective, InputMaskType, InputMixinBase$1 as InputMixinBase, MASKEDINPUT_VALUE_ACCESSOR, Month, OptionComponent, PasswordHintItemComponent, PasswordHintsComponent, RadioChange, RadioComponent, RadioGroupComponent, SelectionCheckboxComponent, SelectionComponent, ShowOnDirtyErrorStateMatcher, SliderComponent, SliderDirective, SuccessComponent, SuffixDirective, SwitchComponent, TagCheckboxComponent, TagRadioComponent, dpid, mixinErrorState, provider, token };
